<template>
  <div class="app">
    <Loading :value="loading"></Loading>

    <!-- RACOURCIS -->
    <v-card>
      <v-card-title>
        <v-breadcrumbs icons divider="chevron_right">
          <v-breadcrumbs-item
            icons
            router
            :to="item.path"
            v-for="item in racourcis"
            :key="item.text"
            :disabled="item.disabled"
            >{{ item.text }}</v-breadcrumbs-item
          >
        </v-breadcrumbs>
      </v-card-title>
    </v-card>
    <br />

    <!-- MODAL SHOW DE PROJET -->
    <v-dialog
      persistent
      v-model="dialogShowProjet"
      v-if="droitAcces.show_projet"
      fullscreen
      :overlay="false"
      scrollable
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title
            >Détail du projet {{ detailProjet.libelle }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon @click.native="closeDialogProjet()" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-md>
            <!-- MODAL MAP GOOGLE -->
            <v-expansion-panel>
              <v-expansion-panel-content class="blue lighten-4 elevation-18">
                <div slot="header">
                  Cliquez pour afficher tous les projets sur la carte
                  <v-icon>map</v-icon>
                </div>
                <v-card>
                  <v-card-text>
                    <div
                      class="google-map"
                      :id="mapName"
                      style="height:500px; width:100%"
                    ></div>
                    <div id="legend2"></div>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- MODAL MAP GOOGLE  -->
            <br />

            <div>
              <el-tabs
                v-model="tab"
                type="border-card"
                @tab-click="handleTabClick(tab)"
              >
                <!-- DETAIL PROJET -->
                <el-tab-pane>
                  <span slot="label">
                    <i class="el-icon-tickets"></i> Dashboard du projet
                  </span>

                  <v-layout row wrap justify>
                    <v-flex xs12>
                      <v-expansion-panel focusable popout value="0">
                        <v-expansion-panel-content>
                          <template v-slot:header>
                            <div>Informations sur le projet</div>
                          </template>
                          <v-card>
                            <v-card-text class="grey lighten-5">
                              <v-layout row>
                                <v-flex md3>
                                  <p>
                                    <b>Référence :</b>
                                    {{ detailProjet.ref }}
                                  </p>
                                  <p>
                                    <b>Prix du marché:</b>
                                    <v-chip
                                      outline
                                      text-color="orange"
                                      label
                                      > {{detailProjet.mntMarche}} XOF
                                      </v-chip>
                                  </p>
                                  <p>
                                    <b>Délai contractuel:</b>
                                    <v-chip
                                      outline
                                      text-color="orange"
                                      label
                                      > {{detailProjet.duree}} Mois
                                      </v-chip>
                                  </p>

                                  <p>
                                    <b>Budget validé:</b>
                                    <v-chip
                                      outline
                                      text-color="green"
                                      label
                                      color="green"
                                      >{{new Intl.NumberFormat().format(detailProjet.mntBudgetValide)}} XOF</v-chip
                                    >
                                  </p>

                                  <p>
                                    <b>Ecart théorique:</b>
                                      <v-chip
                                      outline
                                      text-color="red"
                                      label
                                      > {{ new Intl.NumberFormat().format(detailProjet.EcartTheorique)}}
                                      </v-chip>
                                  </p>
                                  <p>
                                    <b>Libellé :</b>
                                    {{ detailProjet.libelle }}
                                  </p>
                                  <p>
                                    <b>Date de début :</b>
                                    {{ detailProjet.dateDFormat }}
                                  </p>
                                  <p>
                                    <b>Date de fin :</b>
                                    {{ detailProjet.dateFFormat }}
                                  </p>
                                </v-flex>
                                <v-flex md3>
                                  <p>
                                    <b>Situation géographique :</b>
                                    {{ detailProjet.adresse }}
                                  </p>
                                  <p>
                                    <b>Chef de projet :</b>
                                    {{ detailProjet.chef }}
                                  </p>
                                  <p>
                                    <b>Maitre d'ouvrage :</b>
                                    {{ detailProjet.maitreOuvrage }}
                                  </p>
                                  <p>
                                    <b>Architect :</b>
                                    {{ detailProjet.architect }}
                                  </p>
                                  <p>
                                    <b>Responsable d'étude :</b>
                                    {{ detailProjet.chefEtude }}
                                  </p>
                                  <p>
                                    <b>Responsable du contrôle :</b>
                                    {{ detailProjet.chefControle }}
                                  </p>

                                </v-flex>
                                <v-flex md3>
                                  <p>
                                    <b>Compte caisse affilié :</b>
                                     <v-chip
                                      outline
                                      text-color="orange"
                                      label
                                      >  {{ detailProjet.caisse }}
                                      </v-chip>
                                  </p>
                                  <p>
                                    <b>Compte banque(s) affilié(s) :</b>
                                      <span v-for="(item, index) in detailProjet.banque " :key="index">
                                         <v-chip
                                      outline
                                      text-color="green"
                                      label
                                      >  {{ item }}
                                      </v-chip>
                                        /
                                        </span>
                                  </p>
                                  <p>
                                    <b>Nombre d'heure :</b>
                                    {{ detailProjet.nbrHeure }} H
                                  </p>
                                  <p>
                                    <b>Date d'enregistrement :</b>
                                    {{ detailProjet.created }}
                                  </p>
                                  <p>
                                    <b>Date de modification :</b>
                                    {{ detailProjet.modified }}
                                  </p>

                                  <p v-if="detailProjet.budget">
                                    <b>Budget:</b>
                                    <v-chip
                                      v-if="detailProjet.budget.etat == true"
                                      outline
                                      text-color="green"
                                      label
                                      color="green"
                                      >Validé</v-chip
                                    >

                                    <v-chip
                                      v-else
                                      outline
                                      text-color="orange"
                                      label
                                      color="orange"
                                      >En attente</v-chip
                                    >
                                  </p>

                                  <p v-if="detailProjet.participant">
                                    <b>Participants:</b>
                                      <span v-for="(item, index) in detailProjet.participant " :key="index">
                                         <v-chip
                                      outline
                                      text-color="blue"
                                      label
                                      >  {{ item }}
                                      </v-chip>
                                        /
                                        </span>
                                  </p>
                                </v-flex>
                                <v-flex md3>
                                  <v-layout row>
                                    <v-flex xs12>
                                      <p></p>
                                    </v-flex>
                                    <v-flex xs12>
                                      <v-card>
                                        <!-- <span v-for="(photo, index) in detailProjet.photos" :key="index"> -->
                                        <a
                                          :href="detailProjet.urlImage"
                                          target="_blank"
                                        >
                                          <v-avatar
                                            class="mr-2"
                                            :tile="true"
                                            size="250px"
                                            height="250px"
                                            color="grey lighten-4"
                                          >
                                            <img
                                              :src="detailProjet.urlImage"
                                              alt="avatar"
                                            />
                                          </v-avatar>
                                        </a>
                                        <!-- </span> -->
                                      </v-card>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                          <!-- DASHBOARD PROJET -->
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-flex>
                    <v-flex xs12>
                      <!-- DASHBOARD PROJET-->
                      <DashboardOngletPrj
                        :detailProjet="detailProjet"
                        :show="showDetailProjet"
                        @close="showDetailProjet = false"
                      ></DashboardOngletPrj>
                    </v-flex>
                  </v-layout>
                </el-tab-pane>

                <!-- PREPARATION CHANTIER -->
                <el-tab-pane>
                  <span slot="label">
                    <i class="el-icon-menu"></i> Préparation du chantier
                    <span
                      v-if="nbChantier == 0"
                      style="color:red; font-weight:bold;font-size: 27px;"
                      >!</span
                    >
                  </span>
                  <v-chip text-color="white" label color="primary"
                    >LISTE DES CHANTIERS</v-chip
                  >
                  <v-spacer></v-spacer>
                  <div class="text-xs-right">
                    <v-layout row>
                      <v-flex
                        v-if="
                          droitAcces.imprime_pdf_histo_chantier_liste_projet ||
                            droitAcces.imprime_exc_histo_liste_chantier_projet
                        "
                      >
                        <el-popover
                          ref="popChantier"
                          placement="top"
                          width="180"
                          trigger="hover"
                        >
                          <p>Veuillez choisir le format d'impression ?</p>
                          <div style="text-align: right; margin: 0">
                            <el-button
                              type="success"
                              size="mini"
                              v-if="
                                droitAcces.imprime_pdf_histo_chantier_liste_projet
                              "
                              @click="imprimeListeHisChantierProjet('PDF')"
                              >PDF</el-button
                            >
                            <el-button
                              type="primary"
                              size="mini"
                              v-if="
                                droitAcces.imprime_exc_histo_liste_chantier_projet
                              "
                              @click="imprimeListeHisChantierProjet('EXC')"
                              >EXCEL</el-button
                            >
                          </div>
                        </el-popover>
                        <div>
                          <el-button
                            v-popover:popChantier
                            type="warning"
                            :disabled="disabledBtnPop"
                            icon="el-icon-printer"
                            >Rapport</el-button
                          >
                        </div>
                      </v-flex>

                      <v-flex>
                        <v-tooltip top>
                          <v-btn
                            slot="activator"
                            icons
                            color="primary"
                            @click.stop="
                              newChantier(detailProjet);loadTypeProjet()
                              imageProjet = '/static/avatar_proj.png';
                            "
                            dark
                          >
                            Chantier
                            <v-icon left>add</v-icon> </v-btn
                          >Chantier
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </div>
                  <div>
                    <data-tables
                      ref="multipleTable"
                      @selection-change="selectionChangeDuplique"
                      :data="listChantier"
                      height="450"
                      style="width:100%"
                    >
                      <el-table-column
                        width="55"
                        type="selection"
                      ></el-table-column>
                      <el-table-column
                        prop="libelle"
                        label="Libellé"
                        width="400"
                        fixed
                      >
                        <template slot-scope="scope">
                          <v-chip text-color="white" label color="primary"
                            >CHANT-{{ scope.row.id }} /
                            {{ scope.row.libelle }}</v-chip
                          >
                          <v-chip
                            v-if="scope.row.soutraite == 1"
                            text-color="white"
                            color="orange"
                            >CHANTIER SOUS-TRAITE</v-chip
                          >
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="chef"
                        label="Chef chantier"
                        width="300"
                      >
                        <template slot-scope="scope">
                          <span v-for="(item, index) in scope.row.chefChantier" :key="index">
                            <v-chip outline text-color="green" label> {{ item }}</v-chip>/
                          </span>                          
                        </template>
                      </el-table-column>
                      <el-table-column prop="duree" label="Durée prévue">
                        <template slot-scope="scope">
                          <v-chip
                            outline
                            text-color="orange"
                            label
                            color="orange"
                            >{{ scope.row.dureeJ }} jour(s)</v-chip
                          >
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="montantNbr"
                        label="Coût du marché"
                        width="150"
                      >
                        <template slot-scope="scope">
                          <v-chip text-color="white" label color="green"
                            >{{ scope.row.montantNbr }}
                          </v-chip>
                        </template>
                      </el-table-column>

                      <el-table-column
                        prop="total"
                        label="Dépenses"
                        width="150"
                      >
                        <template slot-scope="scope">
                          <v-chip text-color="white" label color="red"
                            >{{ scope.row.total }}
                          </v-chip>
                        </template>
                      </el-table-column>
                      <el-table-column label="Travaux planifiés" width="140">
                        <template slot-scope="scope">
                          <v-chip text-color="white" label color="red"
                            >{{ scope.row.nbTravauxPlanif }} /
                            {{ scope.row.nbTravauxTot }}</v-chip
                          >
                        </template>
                      </el-table-column>
                      <el-table-column label="Eta globale" width="140">
                        <template slot-scope="scope">
                          <v-progress-circular
                            :size="90"
                            :width="15"
                            :rotate="360"
                            :value="scope.row.evolution"
                            color="primary"
                            >{{ scope.row.evolutionNbr }} %</v-progress-circular
                          >
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="Actions"
                        width="350"
                        fixed="right"
                      >
                        <template slot-scope="scope">
                          <v-btn
                            v-if="scope.row.evolution !== 100"
                            icons
                            color="primary"
                            @click="editChantier(scope.row)"
                            fab
                            dark
                            small
                          >
                            <v-icon>edit</v-icon>
                          </v-btn>

                          <v-btn
                            v-if="
                              scope.row.evolution !== 100 ||
                                droitAcces.new_travaux
                            "
                            slot="activator"
                            icons
                            color="deep-orange"
                            @click="newTravaux(scope.row)"
                            fab
                            dark
                            small
                          >
                            <v-badge color="red" right>
                              <span v-if="scope.row.nbTravaux == 0" slot="badge"
                                >!</span
                              >
                              <v-icon>terrain</v-icon>
                            </v-badge>
                          </v-btn>

                          <v-btn
                            v-if="scope.row.evolution === 0"
                            icons
                            color="red"
                            @click.stop="
                              dialogSuprChantier = true;
                              idChantier = scope.row.id;
                            "
                            fab
                            dark
                            small
                          >
                            <v-icon>delete</v-icon>
                          </v-btn>
                          <v-btn
                            icons
                            color="orange"
                            v-if="droitAcces.imprime_chantier"
                            @click="imprimerChantier(scope.row)"
                            fab
                            dark
                            small
                          >
                            <v-icon>print</v-icon>
                          </v-btn>

                           <v-btn
                            icons
                            color="purple"
                            v-if="droitAcces.new_travaux"
                            @click="duplicateChantier(scope.row)"
                            fab
                            dark
                            small
                          >
                           <v-icon dark>content_copy</v-icon>
                          </v-btn>
                        </template>
                      </el-table-column>
                    </data-tables>
                  </div>
                </el-tab-pane>

                <!-- PLANIFICATION TRAVAUX -->
                <el-tab-pane>
                  <span slot="label">
                    <i class="el-icon-date"></i> Planification des travaux
                  </span>

                  <div>
                    <v-chip
                      text-color="white"
                      label
                      color="primary"
                      style="width: 100%; font-weight:bold; font-size: 25px"
                      >VEUILLEZ EFFECTUER VOTRE RECHERCHE EN FONCTION DU
                      CHANTIER ET DES TRAVAUX</v-chip
                    >

                    <!-- RECHERCHE CHANTIER ET TRAVAUX -->
                    <div class="grid-content" style="padding:3px; margin:5px">
                      <el-row>
                        <v-container fluid grid-list-md>
                          <el-card class="box-card">
                            <v-form
                              v-model="valid"
                              ref="formSearchPlanif"
                              lazy-validation
                              id="formSearchPlanif"
                            >
                              <v-layout row>
                                <v-flex md3>
                                  <el-select
                                    v-model="selectTypeSearch"
                                    placeholder="Type de recherche"
                                    style="width:100%"
                                  >
                                    <el-option
                                      v-for="item in typeSearch"
                                      :key="item.value"
                                      :label="item.text"
                                      :value="item.value"
                                    ></el-option>
                                  </el-select>
                                </v-flex>
                                <v-flex v-if="selectTypeSearch == 1" md4>
                                  <el-select
                                    clearable
                                    v-model="selectSearchChantierFind"
                                    placeholder="Chantier"
                                    style="width:100%"
                                  >
                                    <el-option
                                      v-for="item in listChantier"
                                      :key="item.id"
                                      :label="item.libelle"
                                      :value="item.id"
                                    ></el-option>
                                  </el-select>
                                </v-flex>
                                <v-flex v-if="selectTypeSearch == 2" md4>
                                  <el-select
                                    clearable
                                    v-on:change="loadTravaux()"
                                    v-model="selectSearchChantier"
                                    placeholder="Chantier"
                                    style="width:100%"
                                  >
                                    <el-option
                                      v-for="item in listChantier"
                                      :key="item.id"
                                      :label="item.libelle"
                                      :value="item.id"
                                    ></el-option>
                                  </el-select>
                                </v-flex>
                                <v-flex v-if="selectTypeSearch == 2" md4>
                                  <el-select
                                    clearable
                                    v-model="selectSearchTravaux"
                                    filterable
                                    placeholder="Travaux"
                                    style="width:100%"
                                  >
                                    <el-option
                                      v-for="item in listTravaux"
                                      :key="item.id"
                                      :label="item.libelle"
                                      :value="item.id"
                                    ></el-option>
                                  </el-select>
                                </v-flex>

                                <v-flex v-if="selectTypeSearch == 1" md1>
                                  <v-btn
                                    icons
                                    color="blue"
                                    @click="loadChantierSearch()"
                                    fab
                                    dark
                                    small
                                  >
                                    <v-icon>search</v-icon>
                                  </v-btn>
                                </v-flex>
                                <v-flex v-if="selectTypeSearch == 2" md1>
                                  <v-btn
                                    icons
                                    color="blue"
                                    @click="loadTravauxSearch()"
                                    fab
                                    dark
                                    small
                                  >
                                    <v-icon>search</v-icon>
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                            </v-form>
                          </el-card>
                        </v-container>
                      </el-row>
                    </div>

                    <!-- RESULATS CHANTIER -->
                    <el-tabs v-if="listChantierResult.length != 0">
                      <el-tab-pane
                        :label="item.libelle"
                        :name="item.key"
                        v-for="(item) in listChantierResult"
                        :key="item.key"
                      >
                        <el-row>
                          <el-card class="box-card">
                            <v-layout row>
                              <v-flex md3>
                                <p>
                                  <b>Libellé du chantier :</b>
                                  {{ item.libelle }}
                                </p>
                                <p>
                                  <b>Statut du chantier :</b>
                                  {{ detailProjet.libelle }}
                                </p>
                                <p>
                                  <b>Sous-traité :</b>
                                  {{ item.soutraiteLibelle }}
                                </p>
                                <p v-if="item.fournisseur !=''">
                                  <b>Sous-traitant :</b>
                                  {{ item.fournisseur }}
                                </p>
                              </v-flex>
                              <v-flex md3>
                                <p>
                                  <b>Date de début prévue :</b>
                                  {{ item.dateD }}
                                </p>
                                <p>
                                  <b>Date de fin prévue :</b>
                                  {{ item.dateF }}
                                </p>
                                <p>
                                  <b>Durée prévue :</b>
                                  {{ item.dureeJ }} Jour(s)
                                </p>
                                <p>
                                  <b>Chef du chantier :</b>
                                  <span v-for="(element, index) in item.chef " :key="index">
                                         <v-chip
                                      outline
                                      text-color="green"
                                      label
                                      >  {{ element }}
                                      </v-chip>
                                        /
                                        </span>
                                </p>
                              </v-flex>
                              <v-flex md3>
                                <p>
                                  <b>Coût estimatif des travaux :</b>
                                  {{ item.montantNbr }}
                                </p>
                                <p>
                                  <b>Montant déjà depensé :</b>
                                  {{ item.total }}
                                </p>
                              </v-flex>
                              <v-flex md3>
                                <p>
                                  <b>ETAT GLOBAL DU CHANTIER</b>
                                </p>
                                <p>
                                  <v-progress-circular
                                    :size="110"
                                    :width="25"
                                    :rotate="360"
                                    :value="item.evolution"
                                    color="primary"
                                    >{{
                                      item.evolutionNbr
                                    }}
                                    %</v-progress-circular
                                  >
                                </p>
                              </v-flex>
                            </v-layout>
                          </el-card>
                        </el-row>

                        <br />
                        <div class="text-xs-center">
                          <v-layout row>
                            <v-flex
                              v-if="
                                droitAcces.imprime_pdf_histo_plan_travaux_liste_projet ||
                                  droitAcces.imprime_exc_histo_plan_travaux_liste_projet
                              "
                            >
                              <el-popover
                                placement="top-start"
                                title
                                width="200"
                                trigger="hover"
                                content
                              >
                                <p>Veuillez choisir le format d'impression ?</p>
                                <div style="text-align: right; margin: 0">
                                  <el-button
                                    type="success"
                                    size="mini"
                                    v-if="
                                      droitAcces.imprime_pdf_histo_plan_travaux_liste_projet
                                    "
                                    @click="
                                      imprimeListeHisPlanTravauxProjet('PDF')
                                    "
                                    >PDF</el-button
                                  >
                                  <el-button
                                    type="primary"
                                    size="mini"
                                    v-if="
                                      droitAcces.imprime_exc_histo_plan_travaux_liste_projet
                                    "
                                    @click="
                                      imprimeListeHisPlanTravauxProjet('EXC')
                                    "
                                    >EXCEL</el-button
                                  >
                                </div>
                                <el-button slot="reference" type="warning"
                                  >Rapport</el-button
                                >
                              </el-popover>
                            </v-flex>
                          </v-layout>
                        </div>
                        <br />

                        <el-row>
                          <data-tables :data="item.travaux" style="width:100%;">
                            <el-table-column
                              prop="libelle"
                              label="TRAVAUX A REALISER"
                              align="center"
                              width="380"
                              fixed
                            >
                              <template slot-scope="scope">
                                <v-chip
                                  outline
                                  label
                                  text-color="primary"
                                  color="primary"
                                  >{{ scope.row.libelle }}</v-chip
                                >
                                <v-chip
                                  v-if="scope.row.soutraite == 1"
                                  text-color="white"
                                  color="orange"
                                  >TRAVAUX SOUS-TRAITE</v-chip
                                >
                              </template>
                            </el-table-column>
                            <el-table-column label="DATE" align="center">
                              <el-table-column
                                prop="dateD"
                                label="Début"
                              ></el-table-column>
                              <el-table-column
                                prop="dateF"
                                label="Fin"
                              ></el-table-column>
                              <el-table-column
                                prop="duree"
                                label="Durée (Jours) "
                              >
                                <template slot-scope="scope">
                                  <v-chip text-color="white" color="primary"
                                    >{{ scope.row.duree }} Jour(s)</v-chip
                                  >
                                </template>
                              </el-table-column>
                            </el-table-column>

                            <!-- <el-table-column label="COÛT  REALISES " align="center">
                                            <template slot-scope="scope">
                                              <v-chip

                                                text-color="white"
                                                label
                                                color="green"
                                              >{{scope.row.montant}} </v-chip>

                                            </template>
                                          </el-table-column>-->

                            <el-table-column
                              label="QTE ESTIMATIF "
                              align="center"
                            >
                              <template slot-scope="scope">
                                <v-chip
                                  text-color="white"
                                  label
                                  color="green"
                                  >{{ scope.row.qteEstim }}</v-chip
                                >
                              </template>
                            </el-table-column>

                            <el-table-column
                              label="MONTANT DU MARCHE "
                              align="center"
                            >
                              <template slot-scope="scope">
                                <v-chip text-color="white" label color="green"
                                  >{{
                                    new Intl.NumberFormat().format(
                                      scope.row.montantEstim
                                    )
                                  }}
                                </v-chip>
                              </template>
                            </el-table-column>

                            <el-table-column
                              label="BUDGET TRAVAUX"
                              align="center"
                            >
                              <template slot-scope="scope">
                                <v-chip
                                  text-color="white"
                                  label
                                  color="green"
                                  >{{
                                    new Intl.NumberFormat().format(
                                      scope.row.budgetTrx
                                    )
                                  }}</v-chip
                                >
                              </template>
                            </el-table-column>

                            <el-table-column
                              label="ECART BUDGET - MNT MARCHE"
                              align="center"
                            >
                              <template slot-scope="scope">
                                <v-chip
                                  text-color="white"
                                  label
                                  color="orange"
                                  >{{
                                    new Intl.NumberFormat().format(
                                      scope.row.budgetTrx -
                                        scope.row.montantEstim
                                    )
                                  }}</v-chip
                                >
                              </template>
                            </el-table-column>

                            <el-table-column label="ETAT GLOBAL" align="center">
                              <template slot-scope="scope">
                                <v-progress-circular
                                  :size="80"
                                  :width="15"
                                  :rotate="360"
                                  :value="scope.row.evolution"
                                  color="orange"
                                  >{{
                                    scope.row.evolutionNbr
                                  }}
                                  %</v-progress-circular
                                >
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="etat"
                              label="ETAT D'EXECUTION"
                              align="center"
                            >
                              <template slot-scope="scope">
                                <v-chip
                                  v-if="parseInt(scope.row.evolution) == 0"
                                  label
                                  text-color="white"
                                  color="red"
                                  >EN ATTENTE</v-chip
                                >
                                <v-chip
                                  v-if="
                                    parseInt(scope.row.evolution) > 0 &&
                                      parseInt(scope.row.evolution) != 100
                                  "
                                  label
                                  text-color="white"
                                  color="primary"
                                  >EN EXECUTION</v-chip
                                >
                                <v-chip
                                  v-if="parseInt(scope.row.evolution) == 100"
                                  label
                                  text-color="white"
                                  color="green"
                                  >TERMINE</v-chip
                                >
                              </template>
                            </el-table-column>
                            <el-table-column
                              label="ACTION"
                              align="center"
                              width="200"
                              fixed="right"
                            >
                              <template slot-scope="scope">
                                <v-btn
                                  icons
                                  color="green"
                                  @click="
                                    showTravaux(scope.row, item);
                                    loadEquipe(scope.row);
                                  "
                                  fab
                                  dark
                                  small
                                >
                                  <v-icon>folder_open</v-icon>
                                </v-btn>
                                <v-btn
                                  v-if="scope.row.evolution === 0"
                                  icons
                                  color="primary"
                                  @click="editTravaux(scope.row)"
                                  fab
                                  dark
                                  small
                                >
                                  <v-icon>edit</v-icon>
                                </v-btn>

                                <v-btn
                                  icons
                                  color="teal"
                                  @click="newPlanifProduit(scope.row)"
                                  fab
                                  dark
                                  small
                                >
                                  <v-icon>playlist_add</v-icon>
                                </v-btn>

                                <!-- <v-btn v-if="scope.row.evolution !== 100" icons color="indigo" @click="newCommande(scope.row, item)" fab dark small> <v-icon>shopping_cart</v-icon>
                                                  </v-btn>-->
                                <v-btn
                                  icons
                                  color="orange"
                                  @click="imprimerTravaux(scope.row, item)"
                                  fab
                                  dark
                                  small
                                >
                                  <v-icon>print</v-icon>
                                </v-btn>
                                <v-btn
                                  v-if="scope.row.evolution == '0.00'"
                                  icons
                                  color="red"
                                  @click.stop="
                                    dialogSuprTravaux = true;
                                    idTravaux = scope.row.id;
                                  "
                                  fab
                                  dark
                                  small
                                >
                                  <v-icon>delete</v-icon>
                                </v-btn>
                              </template>
                            </el-table-column>
                          </data-tables>
                          <br />
                        </el-row>
                      </el-tab-pane>
                    </el-tabs>

                    <!-- RESULATS TRAVAUX -->
                    <el-row v-if="listTravauxResult.length != 0">
                      <data-tables
                        :data="listTravauxResult"
                        style="width:100%;"
                      >
                        <el-table-column
                          prop="libelle"
                          label="TRAVAUX A REALISER"
                          align="center"
                          width="430"
                          fixed
                        >
                          <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="primary"
                              >{{ scope.row.libelle }}</v-chip
                            >
                            <v-chip
                              v-if="scope.row.soutraite == 1"
                              text-color="white"
                              color="orange"
                              >TRAVAUX SOUS-TRAITE</v-chip
                            >
                          </template>
                        </el-table-column>
                        <el-table-column label="DATE" align="center">
                          <el-table-column
                            prop="dateD"
                            label="Début"
                          ></el-table-column>
                          <el-table-column
                            prop="dateF"
                            label="Fin"
                          ></el-table-column>
                          <el-table-column prop="duree" label="Durée (Jours) ">
                            <template slot-scope="scope">
                              <v-chip text-color="white" color="primary"
                                >{{ scope.row.duree }} Jour(s)</v-chip
                              >
                            </template>
                          </el-table-column>
                        </el-table-column>
                        <el-table-column
                          label="COÛT DES TRAVAUX"
                          align="center"
                        >
                          <template slot-scope="scope">
                            <v-chip
                              v-if="scope.row.montant != 0"
                              text-color="white"
                              label
                              color="green"
                              >{{ scope.row.montant }}
                            </v-chip>
                            <v-chip
                              v-else
                              text-color="white"
                              label
                              color="primary"
                              >NON DEFINIT</v-chip
                            >
                          </template>
                        </el-table-column>
                        <el-table-column label="ETAT GLOBAL" align="center">
                          <template slot-scope="scope">
                            <v-progress-circular
                              :size="80"
                              :width="15"
                              :rotate="360"
                              :value="scope.row.evolution"
                              color="orange"
                              >{{
                                scope.row.evolutionNbr
                              }}
                              %</v-progress-circular
                            >
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="etat"
                          label="ETAT GLOBAL"
                          align="center"
                        >
                          <template slot-scope="scope">
                            <v-chip
                              v-if="scope.row.evolution === 0"
                              label
                              text-color="white"
                              color="red"
                              >EN ATTENTE</v-chip
                            >
                            <v-chip
                              v-if="
                                scope.row.evolution > 0 &&
                                  scope.row.evolution !== 100
                              "
                              label
                              text-color="white"
                              color="primary"
                              >EN EXECUTION</v-chip
                            >
                            <v-chip
                              v-if="scope.row.evolution === 100"
                              label
                              text-color="white"
                              color="green"
                              >TERMINE</v-chip
                            >
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="ACTION"
                          align="center"
                          width="250"
                          fixed="right"
                        >
                          <template slot-scope="scope">
                            <v-btn
                              icons
                              color="green"
                              @click="
                                showTravaux(scope.row);
                                loadEquipe(scope.row);
                              "
                              fab
                              dark
                              small
                            >
                              <v-icon>folder_open</v-icon>
                            </v-btn>
                            <v-btn
                              v-if="scope.row.evolution === 0"
                              icons
                              color="primary"
                              @click="editTravaux(scope.row)"
                              fab
                              dark
                              small
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                            <!-- <v-btn
                                            icons
                                            color="teal"
                                            @click="newPlanifProduit(scope.row)"
                                            fab
                                            dark
                                            small
                                          >
                                            <v-icon>playlist_add</v-icon>
                                          </v-btn>-->
                            <v-btn
                              v-if="scope.row.evolution !== 100"
                              icons
                              color="indigo"
                              @click="newCommande(scope.row)"
                              fab
                              dark
                              small
                            >
                              <v-icon>shopping_cart</v-icon>
                            </v-btn>
                            <v-btn
                              icons
                              color="orange"
                              @click="imprimerTravaux(scope.row)"
                              fab
                              dark
                              small
                            >
                              <v-icon>print</v-icon>
                            </v-btn>
                            <v-btn
                              v-if="scope.row.evolution === 0
                              && droitAcces.projet_index_chefProjet && droitAcces.projet_index && droitAcces.delete_travaux"
                              icons
                              color="red"

                              @click.stop="
                                dialogSuprTravaux = true;
                                idTravaux = scope.row.id;
                              "
                              fab
                              dark
                              small
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </template>
                        </el-table-column>
                      </data-tables>
                      <br />
                    </el-row>
                  </div>
                </el-tab-pane>

                <!-- SUIVIE -->
                <el-tab-pane>
                  <span slot="label">
                    <i class="el-icon-d-arrow-right"></i> Suivie et contrôle
                    technique
                  </span>
                  <div>
                    <!-- POINT DU SUIVIE GENERAL DU PROJET -->
                    <el-card class="box-card">
                      <v-layout row>
                        <v-flex md12>
                          <v-chip
                            v-if="
                              detailProjet.estimation <
                                detailProjet.montantTotalDepense
                            "
                            text-color="white"
                            label
                            color="red"
                            style="width: 100%"
                            >LE BUDGET ESTIMATIF INITIAL A ÉTÉ DÉPASSÉ</v-chip
                          >
                          <v-chip
                            v-if="
                              detailProjet.estimation >=
                                detailProjet.montantTotalDepense
                            "
                            text-color="white"
                            label
                            color="primary"
                            style="width: 100%"
                            >LES DEPENSES ÉFFECTUÉES SONT TOUJOURS DANS LA
                            FOURCHETTE ESTIMATIF DU BUDGET INITIAL</v-chip
                          >
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex md4>
                          <p>
                            <b>BUDGET :</b>
                            <v-chip
                              outline
                              text-color="green"
                              label
                              > {{detailProjet.estimationNbr}}
                              </v-chip>
                          </p>
                          <p>
                            <b>MONTANT TOTAL DES COMMANDES :</b>
                            {{ detailProjet.montantTotalCommandeNbr }}
                          </p>
                          <p>
                            <b>HEURES TOTAL DE TRAVAIL :</b>
                            {{ detailProjet.totalHeure }} H
                          </p>
                        </v-flex>
                        <v-flex md4>
                          <p>
                            <b>MONTANT TOTAL COMMANDES DECAISSE :</b>
                            {{ detailProjet.montantTotalDepenseNbr }}
                          </p>
                          <p>
                            <b>MONTANT TOTAL DEPENSE :</b>
                             <v-chip
                              outline
                              text-color="red"
                              label
                              > {{ new Intl.NumberFormat('fr-Fr').format(detailProjet.montantTotal) }}
                              </v-chip>
                          </p>
                          <p>
                            <b>TOTAL DEMANDE DE FOND:</b>
                            {{ new Intl.NumberFormat('fr-Fr').format(detailProjet.montantDmdFond )}}
                          </p>
                        </v-flex>
                        <v-flex md4>
                          <!--<p>-->
                          <!--<b>TOTAL DE LA MAIN D'OEUVRE :</b>-->
                          <!--{{detailProjet.montantMainDoeuvreNbr}} -->
                          <!--</p>-->
                          <!--<p>-->
                          <!--<b>TOTAL MAIN D'OEUVRE PAYÉ :</b> 0 -->
                          <!--</p>-->
                          <p>
                            <b>TOTAL MISSION :</b>
                            {{
                              new Intl.NumberFormat().format(
                                detailProjet.montantMission
                              )
                            }}
                          </p>
                        </v-flex>
                      </v-layout>
                    </el-card>
                    <br />

                    <v-chip
                      text-color="white"
                      label
                      color="primary"
                      style="width: 100%; font-weight:bold; font-size: 25px"
                      >VEUILLEZ EFFECTUER VOTRE RECHERCHE EN FONCTION DU
                      CHANTIER ET DES TRAVAUX</v-chip
                    >

                    <!-- RECHERCHE CHANTIER ET TRAVAUX -->
                    <div class="grid-content" style="padding:3px; margin:5px">
                      <el-row>
                        <v-container fluid grid-list-md>
                          <el-card class="box-card">
                            <v-form
                              v-model="valid"
                              ref="formSearchPlanifSuivi"
                              lazy-validation
                              id="formSearchPlanifSuivi"
                            >
                              <v-layout row>
                                <v-flex md3>
                                  <el-select
                                    v-model="selectTypeSearchSuivi"
                                    placeholder="Type de recherche"
                                    style="width:100%"
                                  >
                                    <el-option
                                      v-for="item in typeSearch"
                                      :key="item.value"
                                      :label="item.text"
                                      :value="item.value"
                                    ></el-option>
                                  </el-select>
                                </v-flex>
                                <v-flex v-if="selectTypeSearchSuivi == 1" md4>
                                  <el-select
                                    clearable
                                    v-model="selectSearchChantierFindSuivi"
                                    placeholder="Chantier"
                                    style="width:100%"
                                  >
                                    <el-option
                                      v-for="item in listChantier"
                                      :key="item.id"
                                      :label="item.libelle"
                                      :value="item.id"
                                    ></el-option>
                                  </el-select>
                                </v-flex>
                                <v-flex v-if="selectTypeSearchSuivi == 2" md4>
                                  <el-select
                                    clearable
                                    v-on:change="loadTravauxSuivi()"
                                    v-model="selectSearchChantierSuivi"
                                    placeholder="Chantier"
                                    style="width:100%"
                                  >
                                    <el-option
                                      v-for="item in listChantier"
                                      :key="item.id"
                                      :label="item.libelle"
                                      :value="item.id"
                                    ></el-option>
                                  </el-select>
                                </v-flex>
                                <v-flex v-if="selectTypeSearchSuivi == 2" md4>
                                  <el-select
                                    clearable
                                    v-model="selectSearchTravauxSuivi"
                                    filterable
                                    placeholder="Travaux"
                                    style="width:100%"
                                  >
                                    <el-option
                                      v-for="item in listTravaux"
                                      :key="item.id"
                                      :label="item.libelle"
                                      :value="item.id"
                                    ></el-option>
                                  </el-select>
                                </v-flex>

                                <v-flex v-if="selectTypeSearchSuivi == 1" md1>
                                  <v-btn
                                    icons
                                    color="blue"
                                    @click="loadChantierSuivie()"
                                    fab
                                    dark
                                    small
                                  >
                                    <v-icon>search</v-icon>
                                  </v-btn>
                                </v-flex>
                                <v-flex v-if="selectTypeSearchSuivi == 2" md1>
                                  <v-btn
                                    icons
                                    color="blue"
                                    @click="loadTravauxSuivie()"
                                    fab
                                    dark
                                    small
                                  >
                                    <v-icon>search</v-icon>
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                            </v-form>
                          </el-card>
                        </v-container>
                      </el-row>
                    </div>

                    <v-layout v-if="listChantierSuivie.length != 0" row>
                      <v-flex md12>
                        <v-chip
                          text-color="white"
                          label
                          color="orange"
                          style="width: 100%"
                          >DETAILS CHANTIER {{ detailProjet.libelle }}</v-chip
                        >
                      </v-flex>
                    </v-layout>
                    <!-- POINT DU SUIVIE GENERAL DU PROJET PAR CHANTIER -->
                    <el-tabs v-if="listChantierSuivie.length != 0">
                      <el-tab-pane
                        :label="item.libelle"
                        :name="item.key"
                        v-for="(item) in listChantierSuivie"
                        :key="item.key"
                      >
                        <!-- BOUTON DASHBORD CHANTIER -->

                        <!-- DETAIL SUR LES TRAVAUX SELECTIONNER -->
                        <v-card>
                          <v-layout wrap class="elevation-5">
                            <v-flex xs12 class="mb-1">
                              <v-tooltip top>
                                <v-btn
                                  slot="activator"
                                  @click="modalDashboardChantier(item)"
                                  dark
                                  small
                                  color="blue"
                                >
                                  Dashboard chantier
                                  <v-icon dark>dashboard</v-icon> </v-btn
                                >Info dashboard chantier
                              </v-tooltip>
                            </v-flex>

                            <v-flex xs12>
                              <v-layout row>
                                <!-- COLONE1 -->
                                <v-flex xs6 class="mr-4">
                                  <v-layout row>
                                    <v-flex xs6>Libelle</v-flex>
                                    <v-flex xs6 class="text-xs-right title">{{
                                      item.libelle
                                    }}</v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>
                                  <v-layout row>
                                    <v-flex xs6>Date début et fin</v-flex>
                                    <v-flex xs6 class="text-xs-right title"
                                      >{{ item.dateD }} --
                                      {{ item.dateF }}</v-flex
                                    >
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>
                                  <v-layout row>
                                    <v-flex xs6>Créé le</v-flex>
                                    <v-flex xs6 class="text-xs-right title">{{
                                      item.created
                                    }}</v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>
                                  <v-layout row>
                                    <v-flex xs6>Chef chantier</v-flex>
                                    <v-flex xs6 class="text-xs-right title">{{
                                      item.chef
                                    }}</v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>
                                  <v-layout row>
                                    <v-flex xs6>Durée (Jours)</v-flex>
                                    <v-flex xs6 class="text-xs-right title">{{
                                      item.dureeJ
                                    }}</v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>
                                  <v-layout row>
                                    <v-flex xs6>Retard (J)</v-flex>
                                    <v-flex xs6 class="text-xs-right title">{{
                                      item.nbrRetard
                                    }}</v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>
                                  <v-layout row>
                                    <v-flex xs6>Coût du marché</v-flex>
                                    <v-flex xs6 class="text-xs-right title">{{
                                      item.montantNbr
                                    }}</v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>
                                  <v-layout row>
                                    <v-flex xs6>Images</v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      <span
                                        v-for="(photo, index) in item.photos"
                                        :key="index"
                                      >
                                        <v-avatar
                                          class="mr-2"
                                          :tile="true"
                                          size="100px"
                                          height="100px"
                                          color="grey lighten-4"
                                        >
                                          <img :src="photo" alt="avatar" />
                                        </v-avatar>
                                      </span>
                                    </v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>
                                </v-flex>

                                <!-- COLONE2 -->
                                <v-flex xs6>
                                  <v-layout row>
                                    <v-flex xs6>Dépenses</v-flex>
                                    <v-flex xs6 class="text-xs-right title">{{
                                      item.total
                                    }}</v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>
                                  <v-layout row>
                                    <v-flex xs6>Créé par</v-flex>
                                    <v-flex xs6 class="text-xs-right title">{{
                                      item.createdUser
                                    }}</v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>
                                  <v-layout row>
                                    <v-flex xs6>Travaux planifiés</v-flex>
                                    <v-flex xs6 class="text-xs-right title">
                                      <v-chip label outline color="primary">{{
                                        item.nbTrxPlan
                                      }}</v-chip>
                                    </v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>
                                  <v-layout row>
                                    <v-flex xs6>Prestataire (chantier)</v-flex>
                                    <v-flex xs6 class="text-xs-right title">{{
                                      item.prestataire
                                    }}</v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>
                                  <v-layout row>
                                    <v-flex xs6
                                      >Montant prestataire (chantier)</v-flex
                                    >
                                    <v-flex xs6 class="text-xs-right title"
                                      >{{ item.montantSoustraitanceFormat }}
                                    </v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>
                                  <v-layout row>
                                    <v-flex xs6>Evolution</v-flex>
                                    <v-flex xs6 class="text-xs-left title">
                                      <v-progress-circular
                                        :size="160"
                                        :width="25"
                                        :rotate="360"
                                        :value="item.evolution"
                                        color="primary"
                                        >{{
                                          item.evolutionNbr
                                        }}
                                        %</v-progress-circular
                                      >
                                    </v-flex>
                                  </v-layout>
                                  <v-divider class="mb-3"></v-divider>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>

                        <br />
                        <v-layout row>
                          <v-flex md12>
                            <v-chip
                              text-color="white"
                              label
                              color="green"
                              style="width: 100%"
                              >LISTE DES TRAVAUX DU CHANTIER</v-chip
                            >
                          </v-flex>
                        </v-layout>
                        <!-- TOUS LES TRAVAUX -->
                        <el-tabs  @tab-click="handleTabClickTravaux">
                          <el-tab-pane
                            :label="itemT.libelle"
                            :name="itemT.key"
                            :idTravau ="itemT.idTrx"
                            :item ="itemT"
                            v-for="(itemT) in item.travaux"
                            :key="itemT.key"

                          >
                            <!-- DETAILS DES TRAVAUX -->
                            <el-row v-if="listTravauxRow !=''">
                              <el-card class="box-card">
                                <div class="grid-content" style="padding:3px;">
                                  <el-row>
                                    <div class="text item">
                                      <v-layout row justify>
                                        <v-flex md3>
                                          <p>
                                            <b>Identifiant :</b>
                                            {{ listTravauxRow.code }}
                                          </p>
                                          <p>
                                            <b>Libellé :</b>
                                            {{ listTravauxRow.libelle }}
                                          </p>
                                          <!-- <p>
                                                                        <b>Chantier concerné :</b>
                                                                        {{itemT.chantier}}
                                                                      </p> -->
                                          <p>
                                            <b>Sous-traité :</b>
                                            {{ listTravauxRow.soutraiteLibelle }}
                                          </p>

                                          <p v-if="listTravauxRow.fournisseur !=''">
                                            <b>Sous-traitant :</b>
                                            {{ listTravauxRow.fournisseur }}
                                          </p>
                                          <!-- <p>
                                                                          <v-btn slot="activator" @click="showModalTache(itemT)" dark small color="blue">
                                                                            Tâches <v-icon dark>terrain</v-icon>
                                                                          </v-btn>
                                                                      </p>-->
                                        </v-flex>
                                        <v-flex md3>
                                          <p>
                                            <b>Date de début :</b>
                                            {{ listTravauxRow.dateD }}
                                          </p>
                                          <p>
                                            <b>Date de fin :</b>
                                            {{ listTravauxRow.dateF }}
                                          </p>
                                          <p>
                                            <b>Durée :</b>
                                            {{ listTravauxRow.duree }} Jour(s)
                                          </p>
                                          <!-- <p>
                                                                        <b>Tache correspondant :</b>
                                                                        {{itemT.tache}}
                                                                      </p> -->
                                        </v-flex>
                                        <v-flex md3>
                                          <p>
                                            <b>Statut :</b>
                                            <v-chip
                                              v-if="listTravauxRow.evolution == 0"
                                              outline
                                              text-color="orange"
                                              label
                                              color="green"
                                            >
                                              EN ATTENTE
                                              <v-icon right></v-icon>
                                            </v-chip>
                                            <v-chip
                                              v-else
                                              outline
                                              text-color="green"
                                              label
                                              color="green"
                                            >
                                              EN EXECUTION
                                              <v-icon right></v-icon>
                                            </v-chip>
                                          </p>
                                          <p>
                                            <b>Montant travaux dépensé :</b>
                                            {{ listTravauxRow.montant }}
                                          </p>
                                          <p>
                                            <b>Date d'enregistrement :</b>
                                            {{ listTravauxRow.created }}
                                          </p>
                                          <p>
                                            <b>Date de modification :</b>
                                            {{ listTravauxRow.modified }}
                                          </p>
                                        </v-flex>
                                        <v-flex md3>
                                          <p>
                                            <b>ETAT GLOBAL DES TRAVAUX</b>
                                          </p>
                                          <p>
                                            <v-progress-circular
                                              :size="160"
                                              :width="25"
                                              :rotate="360"
                                              :value="listTravauxRow.evolution"
                                              color="orange"
                                              >{{
                                                listTravauxRow.evolutionNbr
                                              }}
                                              %</v-progress-circular
                                            >
                                          </p>
                                        </v-flex>
                                      </v-layout>
                                    </div>
                                  </el-row>
                                </div>
                              </el-card>
                            </el-row>
                            <br />

                            <!-- MENU DETAILE DES TRAVAUX -->
                            <el-tabs v-model="activeTacheChantier"  v-if="listTravauxRow !=''" @tab-click="handleTabClickTaches">
                              <!-- TACHE -->
                              <el-tab-pane label="TACHES" name="tacheChantier">
                                <br />
                                <el-card class="box-card" v-if="listTachesRow !=''">
                                  <p align="right">
                                    <v-tooltip
                                      top
                                      v-if="
                                        droitAcces.imprime_tache_travaaux_all
                                      "
                                    >
                                      <v-btn
                                        slot="activator"
                                        icons
                                        color="orange"
                                        @click.stop="
                                          imprimerTacheTravaux(listTravauxRow)
                                        "
                                        dark
                                      >
                                        Imprimer
                                        <v-icon right>print</v-icon> </v-btn
                                      >Imprimer toutes les tâches
                                    </v-tooltip>
                                  </p>

                                  <div
                                    class="grid-content"
                                    style="padding:3px;"
                                  >
                                    <el-row>
                                      <data-tables
                                        :data="listTachesRow.taches"
                                        style="width:100%; font-size:15px"
                                      >
                                        <el-table-column
                                          prop="tacheLibelle"
                                          label="TÂCHES A REALISER"
                                          width="200"
                                          fixed="left"
                                        >
                                          <template slot-scope="scope">
                                            <v-chip
                                              outline
                                              label
                                              text-color="primary"
                                              color="primary"
                                              >{{
                                                scope.row.tacheLibelle
                                              }}</v-chip
                                            >
                                          </template>
                                        </el-table-column>

                                        <el-table-column
                                          prop="travaux"
                                          label="TRAVAUX"
                                          width="200"
                                        >
                                          <template slot-scope="scope">
                                            <v-chip
                                              label
                                              text-color="white"
                                              color="primary"
                                              >{{ scope.row.travaux }}</v-chip
                                            >
                                          </template>
                                        </el-table-column>
                                        <el-table-column
                                          label="DATE ET INTERVAL DE TEMPS"
                                          align="center"
                                        >
                                          <el-table-column
                                            prop="dateDebut"
                                            label="Début"
                                            width="100"
                                          ></el-table-column>
                                          <el-table-column
                                            prop="dateFin"
                                            label="Fin"
                                            width="100"
                                          ></el-table-column>
                                          <el-table-column
                                            prop="duree"
                                            label="Durée (Jours) "
                                            width="120"
                                          >
                                            <template slot-scope="scope">
                                              <v-chip
                                                text-color="white"
                                                color="primary"
                                                >{{
                                                  scope.row.duree
                                                }}
                                                Jour(s)</v-chip
                                              >
                                            </template>
                                          </el-table-column>
                                        </el-table-column>
                                        <el-table-column
                                          prop="dateDemar"
                                          label="Date de démarrage"
                                          width="100"
                                        ></el-table-column>

                                        <el-table-column
                                          label="ETAT GLOBAL"
                                          width="140"
                                        >
                                          <template slot-scope="scope">
                                            <el-progress
                                              :text-inside="true"
                                              :stroke-width="30"
                                              :percentage="scope.row.evolution"
                                              status="success"
                                            ></el-progress>
                                          </template>
                                        </el-table-column>

                                        <el-table-column
                                          label="ETAT"
                                          width="150"
                                        >
                                          <template slot-scope="scope">
                                            <v-chip
                                              label
                                              text-color="white"
                                              color="blue"
                                              >{{ scope.row.libEtat }}</v-chip
                                            >

                                            <v-chip
                                              v-if="
                                                scope.row.nBprestataire == false
                                              "
                                              label
                                              text-color="white"
                                              color="orange"
                                              >Aucun ouvriers ou prestataires
                                              !</v-chip
                                            >
                                          </template>
                                        </el-table-column>

                                        <el-table-column
                                          prop="unite"
                                          label="UNITE"
                                          width="150"
                                        ></el-table-column>

                                        <el-table-column
                                          prop="qte"
                                          label="QUT ESTIMATIF"
                                          width="150"
                                        ></el-table-column>
                                        <el-table-column
                                          prop="qteEffec"
                                          label="QUT REALISEE"
                                          width="150"
                                        ></el-table-column>

                                        <el-table-column
                                          prop="qteEcart"
                                          label="ECART"
                                          width="150"
                                        ></el-table-column>

                                        <el-table-column
                                          label="PRIX UNITAIRE"
                                          width="150"
                                        >
                                          <template slot-scope="prop">{{
                                            new Intl.NumberFormat().format(
                                              prop.row.prixUHT
                                            )
                                          }}</template>
                                        </el-table-column>

                                        <el-table-column
                                          label="TOTAL HT (ESTIMATIF)"
                                          width="150"
                                        >
                                          <template slot-scope="prop">{{
                                            new Intl.NumberFormat().format(
                                              prop.row.totalHT
                                            )
                                          }}</template>
                                        </el-table-column>

                                        <el-table-column
                                          label="MONTANT REALISE"
                                          width="150"
                                        >
                                          <template slot-scope="prop">{{
                                            new Intl.NumberFormat().format(
                                              prop.row.montantEffec
                                            )
                                          }}</template>
                                        </el-table-column>

                                        <el-table-column
                                          label="ACTIONS"
                                          width="200"
                                          fixed="right"
                                        >
                                          <template slot-scope="scope">
                                            <v-btn
                                              icons
                                              color="green"
                                              v-if="
                                                droitAcces.show_tache_travaux
                                              "
                                              @click="showTache(scope.row)"
                                              fab
                                              dark
                                              small
                                            >
                                              <v-icon>folder_open</v-icon>
                                            </v-btn>
                                            <v-tooltip bottom>
                                              <v-btn
                                                @click="showOuvrier(scope.row)"
                                                v-if="
                                                  scope.row.nBprestataire ==
                                                    true
                                                "
                                                slot="activator"
                                                icons
                                                color="blue"
                                                fab
                                                dark
                                                small
                                              >
                                                <v-icon>assignment_ind</v-icon>
                                              </v-btn>
                                              <span>ouvriers</span>
                                            </v-tooltip>

                                            <v-tooltip bottom>
                                              <v-btn
                                                v-if="
                                                  (scope.row.etat == 0 ||
                                                    scope.row.etat == null) &&
                                                    scope.row.nBprestataire ==
                                                      true
                                                "
                                                @click.native="
                                                  tacheSel = scope.row;
                                                  dialogDemarrer = true;
                                                "
                                                slot="activator"
                                                :disabled="
                                                  scope.row.disaledDemar
                                                "
                                                icons
                                                color="purple"
                                                fab
                                                dark
                                                small
                                              >
                                                <v-icon
                                                  >play_circle_outline</v-icon
                                                > </v-btn
                                              >Démarrer
                                            </v-tooltip>
                                            <v-btn
                                              icons
                                              color="orange"
                                              v-if="droitAcces.imprime_tache"
                                              @click="imprimerTache(scope.row)"
                                              fab
                                              dark
                                              small
                                            >
                                              <v-icon>print</v-icon>
                                            </v-btn>
                                            <v-btn
                                              v-if="
                                                scope.row.evolution === 0 &&
                                                  scope.row.etatContrat == 0
                                              "
                                              icons
                                              color="red"
                                              @click.stop="
                                                dialogSuprTache = true;
                                                idTache = scope.row.id;
                                              "
                                              fab
                                              dark
                                              small
                                            >
                                              <v-icon>delete</v-icon>
                                            </v-btn>
                                          </template>
                                        </el-table-column>
                                      </data-tables>
                                    </el-row>
                                  </div>
                                </el-card>
                                <br />

                                <v-tooltip top>
                                  <v-btn
                                    v-if="!choixTravux"
                                    slot="activator"
                                    icons
                                    color="green"
                                    @click.stop="newDemarerTravaux(listTravauxRow)"
                                    dark
                                  >
                                    Démarrer
                                    <v-icon right>last_page</v-icon> </v-btn
                                  >Démarrer les travaux
                                </v-tooltip>
                              </el-tab-pane>

                              <!-- LISTE DES PLANIFICATION PRODUIT -->
                              <el-tab-pane label="ETAT RESSOURCES">
                                <el-row :gutter="20" style="padding:10px;" v-if="listRessourcesRow !=''">
                                  <el-card class="box-card">
                                    <div
                                      class="grid-content"
                                      style="padding:3px;"
                                    >
                                      <el-row>
                                        <data-tables
                                          :data="listRessourcesRow.planifProduits"
                                          style="width:100%; font-size:15px"
                                        >
                                          <el-table-column
                                            prop="produit"
                                            label="RESSOURCES"
                                            align="center"
                                            width="230"
                                            fixed="left"
                                          >
                                            <template slot-scope="scope">
                                              <v-chip
                                                outline
                                                label
                                                text-color="primary"
                                                color="primary"
                                                >{{ scope.row.produit }}</v-chip
                                              >
                                            </template>
                                          </el-table-column>
                                          <el-table-column
                                            prop="qte"
                                            label="Quantité planifiée"
                                            align="center"
                                          >
                                            <template slot-scope="scope">
                                              <v-chip
                                                text-color="white"
                                                color="primary"
                                                >{{ new Intl.NumberFormat('fr-Fr').format(scope.row.qte )}}</v-chip
                                              >
                                            </template>
                                          </el-table-column>

                                          <el-table-column
                                            prop="unite"
                                            label="Unité"
                                            align="center"
                                          >
                                            <template slot-scope="scope">
                                              <v-chip
                                                text-color="white"
                                                color="primary"
                                                >{{ scope.row.unite }}</v-chip
                                              >
                                            </template>
                                          </el-table-column>

                                          <el-table-column
                                            prop="qteUtil"
                                            label="Quantité utilisée"
                                            align="center"
                                          >
                                            <template slot-scope="scope">
                                              <v-chip
                                                text-color="white"
                                                color="primary"
                                                >{{ new Intl.NumberFormat('fr-Fr').format(scope.row.qteUtil) }}</v-chip
                                              >
                                            </template>
                                          </el-table-column>

                                          <el-table-column
                                            prop="ecart"
                                            label="Ecart"
                                            align="center"
                                          ></el-table-column>
                                        </data-tables>
                                      </el-row>
                                    </div>
                                  </el-card>
                                </el-row>
                              </el-tab-pane>
                              <!-- COMMANDE -->
                              <el-tab-pane
                                label="COMMANDES"
                                name="commandeChantier"
                              >
                                <div>
                                  <el-tabs v-model="activeComChantier" v-if="listCommandesRow !=''">
                                    <!-- COMMANDE A VALIDER -->
                                    <el-tab-pane
                                      label="A VALIDER"
                                      name="avalider"
                                    >
                                      <br />
                                      <el-card class="box-card">
                                        <div
                                          class="grid-content"
                                          style="padding:3px;"
                                        >
                                          <p align="left">
                                            <v-layout row>
                                              <v-flex md4>
                                                <v-chip
                                                  text-color="white"
                                                  label
                                                  color="orange"
                                                  style="width: 100%; font-weight: 20px"
                                                  >MONTANT :
                                                  {{
                                                    listCommandesRow.totalCommandeAValider
                                                  }}
                                                </v-chip>
                                              </v-flex>
                                            </v-layout>
                                          </p>
                                          <el-row>
                                            <data-tables
                                              :data="listCommandesRow.commavalider"
                                              style="width:100%; font-size:15px"
                                            >
                                              <el-table-column
                                                prop="libelle"
                                                label="LIBELLE"
                                                fixed
                                              >
                                                <template slot-scope="scope">
                                                  <v-chip
                                                    label
                                                    text-color="white"
                                                    color="primary"
                                                    >{{ scope.row.ref }}</v-chip
                                                  >
                                                  <v-chip
                                                    label
                                                    text-color="white"
                                                    color="primary"
                                                    >{{
                                                      scope.row.libelle
                                                    }}</v-chip
                                                  >
                                                </template>
                                              </el-table-column>
                                              <el-table-column
                                                prop="dateC"
                                                label="DATE"
                                                width="120"
                                              >
                                                <template slot-scope="scope">
                                                  <v-chip
                                                    outline
                                                    label
                                                    text-color="primary"
                                                    color="primary"
                                                    >{{
                                                      scope.row.dateC
                                                    }}</v-chip
                                                  >
                                                </template>
                                              </el-table-column>
                                              <el-table-column label="ETAT">
                                                <template slot-scope="scope">
                                                  <v-chip
                                                    text-color="white"
                                                    label
                                                    color="orange"
                                                    v-if="scope.row.valid === 0"
                                                  >
                                                    EN ATENTE DE VALIDATION
                                                    <v-icon right></v-icon>
                                                  </v-chip>
                                                  <v-chip
                                                    text-color="white"
                                                    label
                                                    color="red"
                                                    v-if="scope.row.valid === 2"
                                                  >
                                                    REJETE
                                                    <v-icon right></v-icon>
                                                  </v-chip>
                                                  <v-chip
                                                    text-color="white"
                                                    label
                                                    color="red"
                                                    v-if="
                                                      scope.row.etat === false
                                                    "
                                                  >
                                                    NON LIVRE
                                                    <v-icon right></v-icon>
                                                  </v-chip>
                                                </template>
                                              </el-table-column>
                                              <el-table-column
                                                label="ACTIONS"
                                                width="200"
                                                fixed="right"
                                              >
                                                <template slot-scope="scope">
                                                  <v-btn
                                                    icons
                                                    color="green"
                                                    @click="
                                                      showCommande(scope.row)
                                                    "
                                                    fab
                                                    dark
                                                    small
                                                  >
                                                    <v-icon>folder_open</v-icon>
                                                  </v-btn>
                                                  <v-btn
                                                    icons
                                                    color="primary"
                                                    @click="
                                                      editCommande(scope.row)
                                                    "
                                                    fab
                                                    dark
                                                    small
                                                  >
                                                    <v-icon>edit</v-icon>
                                                  </v-btn>
                                                  <v-btn
                                                    icons
                                                    color="green"
                                                    @click="
                                                      newValidCommande(
                                                        scope.row
                                                      )
                                                    "
                                                    fab
                                                    dark
                                                    small
                                                  >
                                                    <v-icon>done_all</v-icon>
                                                  </v-btn>
                                                  <v-btn
                                                    icons
                                                    color="orange"
                                                    v-if="
                                                      droitAcces.imprime_commande
                                                    "
                                                    @click="
                                                      imprimerCommande(
                                                        scope.row
                                                      )
                                                    "
                                                    fab
                                                    dark
                                                    small
                                                  >
                                                    <v-icon>print</v-icon>
                                                  </v-btn>
                                                </template>
                                              </el-table-column>
                                            </data-tables>
                                          </el-row>
                                        </div>
                                      </el-card>
                                    </el-tab-pane>
                                    <!-- COMMANDE VALIDER -->
                                    <el-tab-pane label="VALIDER" name="valider">
                                      <br />
                                      <el-card class="box-card">
                                        <div
                                          class="grid-content"
                                          style="padding:3px;"
                                        >
                                          <p align="left">
                                            <v-layout row>
                                              <v-flex md4>
                                                <v-chip
                                                  text-color="white"
                                                  label
                                                  color="orange"
                                                  style="width: 100%; font-weight: 20px"
                                                  >MONTANT :
                                                  {{
                                                    listCommandesRow.totalCommandeValider
                                                  }}
                                                </v-chip>
                                              </v-flex>
                                            </v-layout>
                                          </p>
                                          <el-row>
                                            <data-tables
                                              :data="listCommandesRow.commvalide"
                                              style="width:100%; font-size:15px"
                                            >
                                              <el-table-column
                                                prop="libelle"
                                                label="LIBELLE"
                                                fixed
                                              >
                                                <template slot-scope="scope">
                                                  <v-chip
                                                    label
                                                    text-color="white"
                                                    color="primary"
                                                    >{{ scope.row.ref }}</v-chip
                                                  >
                                                  <v-chip
                                                    label
                                                    text-color="white"
                                                    color="primary"
                                                    >{{
                                                      scope.row.libelle
                                                    }}</v-chip
                                                  >
                                                </template>
                                              </el-table-column>
                                              <el-table-column
                                                prop="dateC"
                                                label="DATE"
                                                width="120"
                                              >
                                                <template slot-scope="scope">
                                                  <v-chip
                                                    outline
                                                    label
                                                    text-color="primary"
                                                    color="primary"
                                                    >{{
                                                      scope.row.dateC
                                                    }}</v-chip
                                                  >
                                                </template>
                                              </el-table-column>
                                              <el-table-column label="ETAT">
                                                <template slot-scope="scope">
                                                  <v-chip
                                                    text-color="white"
                                                    label
                                                    color="green"
                                                    v-if="scope.row.valid === 1"
                                                  >
                                                    VALIDER
                                                    <v-icon right></v-icon>
                                                  </v-chip>
                                                  <v-chip
                                                    text-color="white"
                                                    label
                                                    color="red"
                                                    v-if="scope.row.valid === 2"
                                                  >
                                                    REJETE
                                                    <v-icon right></v-icon>
                                                  </v-chip>
                                                  <v-chip
                                                    text-color="white"
                                                    label
                                                    color="red"
                                                    v-if="
                                                      scope.row.etat === false
                                                    "
                                                  >
                                                    NON LIVRE
                                                    <v-icon right></v-icon>
                                                  </v-chip>
                                                  <v-chip
                                                    text-color="white"
                                                    label
                                                    color="green"
                                                    v-if="
                                                      scope.row.etat == true
                                                    "
                                                  >
                                                    LIVRE
                                                    <v-icon right></v-icon>
                                                  </v-chip>
                                                </template>
                                              </el-table-column>
                                              <el-table-column
                                                label="ACTIONS"
                                                width="200"
                                                fixed="right"
                                              >
                                                <template slot-scope="scope">
                                                  <v-btn
                                                    icons
                                                    color="green"
                                                    @click="
                                                      showCommande(scope.row)
                                                    "
                                                    fab
                                                    dark
                                                    small
                                                  >
                                                    <v-icon>folder_open</v-icon>
                                                  </v-btn>
                                                  <v-btn
                                                    icons
                                                    color="orange"
                                                    @click="
                                                      imprimerCommande(
                                                        scope.row
                                                      )
                                                    "
                                                    fab
                                                    dark
                                                    small
                                                  >
                                                    <v-icon>print</v-icon>
                                                  </v-btn>
                                                </template>
                                              </el-table-column>
                                            </data-tables>
                                          </el-row>
                                        </div>
                                      </el-card>
                                    </el-tab-pane>
                                    <!-- COMMANDE A LIVRE -->
                                    <el-tab-pane label="A LIVRE" name="alivre">
                                      <br />

                                      <el-card class="box-card">
                                        <div
                                          class="grid-content"
                                          style="padding:3px;"
                                        >
                                          <p align="left">
                                            <v-layout row>
                                              <v-flex md4>
                                                <v-chip
                                                  text-color="white"
                                                  label
                                                  color="orange"
                                                  style="width: 100%; font-weight: 20px"
                                                  >MONTANT :
                                                  {{
                                                    listCommandesRow.totalCommandeALivrer
                                                  }}
                                                </v-chip>
                                              </v-flex>
                                            </v-layout>
                                          </p>
                                          <el-row>
                                            <data-tables
                                              :data="listCommandesRow.commaLivrer"
                                              style="width:100%; font-size:15px"
                                            >
                                              <el-table-column
                                                prop="libelle"
                                                label="LIBELLE"
                                                fixed
                                              >
                                                <template slot-scope="scope">
                                                  <v-chip
                                                    label
                                                    text-color="white"
                                                    color="primary"
                                                    >{{ scope.row.ref }}</v-chip
                                                  >
                                                  <v-chip
                                                    label
                                                    text-color="white"
                                                    color="primary"
                                                    >{{
                                                      scope.row.libelle
                                                    }}</v-chip
                                                  >
                                                </template>
                                              </el-table-column>
                                              <el-table-column
                                                prop="dateC"
                                                label="DATE"
                                                width="120"
                                              >
                                                <template slot-scope="scope">
                                                  <v-chip
                                                    outline
                                                    label
                                                    text-color="primary"
                                                    color="primary"
                                                    >{{
                                                      scope.row.dateC
                                                    }}</v-chip
                                                  >
                                                </template>
                                              </el-table-column>
                                              <el-table-column label="ETAT">
                                                <template slot-scope="scope">
                                                  <v-chip
                                                    text-color="white"
                                                    label
                                                    color="green"
                                                    v-if="scope.row.valid === 1"
                                                  >
                                                    VALIDE
                                                    <v-icon right></v-icon>
                                                  </v-chip>
                                                  <v-chip
                                                    text-color="white"
                                                    label
                                                    color="red"
                                                    v-if="
                                                      scope.row.etat == false
                                                    "
                                                  >
                                                    NON LIVRE
                                                    <v-icon right></v-icon>
                                                  </v-chip>
                                                </template>
                                              </el-table-column>
                                              <el-table-column
                                                label="ACTIONS"
                                                width="200"
                                                fixed="right"
                                              >
                                                <template slot-scope="scope">
                                                  <v-btn
                                                    icons
                                                    color="green"
                                                    @click="
                                                      showCommande(scope.row)
                                                    "
                                                    fab
                                                    dark
                                                    small
                                                  >
                                                    <v-icon>folder_open</v-icon>
                                                  </v-btn>
                                                  <v-btn
                                                    icons
                                                    color="orange"
                                                    @click="
                                                      imprimerCommande(
                                                        scope.row
                                                      )
                                                    "
                                                    fab
                                                    dark
                                                    small
                                                  >
                                                    <v-icon>print</v-icon>
                                                  </v-btn>
                                                </template>
                                              </el-table-column>
                                            </data-tables>
                                          </el-row>
                                        </div>
                                      </el-card>
                                    </el-tab-pane>
                                    <!-- COMMANDE LIVRE -->
                                    <el-tab-pane label="LIVRE" name="livre">
                                      <br />

                                      <el-card class="box-card">
                                        <div
                                          class="grid-content"
                                          style="padding:3px;"
                                        >
                                          <p align="left">
                                            <v-layout row>
                                              <v-flex md4>
                                                <v-chip
                                                  text-color="white"
                                                  label
                                                  color="orange"
                                                  style="width: 100%; font-weight: 20px"
                                                  >MONTANT :
                                                  {{ listCommandesRow.totalCommandeLivre }}
                                                </v-chip>
                                              </v-flex>
                                            </v-layout>
                                          </p>
                                          <el-row>
                                            <data-tables
                                              :data="listCommandesRow.commLivre"
                                              style="width:100%; font-size:15px"
                                            >
                                              <el-table-column
                                                prop="libelle"
                                                label="LIBELLE"
                                                fixed
                                              >
                                                <template slot-scope="scope">
                                                  <v-chip
                                                    label
                                                    text-color="white"
                                                    color="primary"
                                                    >{{ scope.row.ref }}</v-chip
                                                  >
                                                  <v-chip
                                                    label
                                                    text-color="white"
                                                    color="primary"
                                                    >{{
                                                      scope.row.libelle
                                                    }}</v-chip
                                                  >
                                                </template>
                                              </el-table-column>
                                              <el-table-column
                                                prop="dateC"
                                                label="DATE"
                                                width="120"
                                              >
                                                <template slot-scope="scope">
                                                  <v-chip
                                                    outline
                                                    label
                                                    text-color="primary"
                                                    color="primary"
                                                    >{{
                                                      scope.row.dateC
                                                    }}</v-chip
                                                  >
                                                </template>
                                              </el-table-column>
                                              <el-table-column label="ETAT">
                                                <template slot-scope="scope">
                                                  <v-chip
                                                    text-color="white"
                                                    label
                                                    color="green"
                                                    v-if="scope.row.valid === 1"
                                                  >
                                                    VALIDE
                                                    <v-icon right></v-icon>
                                                  </v-chip>
                                                  <v-chip
                                                    text-color="white"
                                                    label
                                                    color="green"
                                                    v-if="
                                                      scope.row.etat == true
                                                    "
                                                  >
                                                    LIVRE
                                                    <v-icon right></v-icon>
                                                  </v-chip>
                                                </template>
                                              </el-table-column>
                                              <el-table-column
                                                label="ACTIONS"
                                                width="200"
                                                fixed="right"
                                              >
                                                <template slot-scope="scope">
                                                  <v-btn
                                                    icons
                                                    color="green"
                                                    @click="
                                                      showCommande(scope.row)
                                                    "
                                                    fab
                                                    dark
                                                    small
                                                  >
                                                    <v-icon>folder_open</v-icon>
                                                  </v-btn>
                                                  <v-btn
                                                    icons
                                                    color="orange"
                                                    @click="
                                                      imprimerCommande(
                                                        scope.row
                                                      )
                                                    "
                                                    fab
                                                    dark
                                                    small
                                                  >
                                                    <v-icon>print</v-icon>
                                                  </v-btn>
                                                </template>
                                              </el-table-column>
                                            </data-tables>
                                          </el-row>
                                        </div>
                                      </el-card>
                                    </el-tab-pane>
                                    <!-- TOUTES LES COMMANDES -->
                                    <el-tab-pane
                                      label="TOUTES LES COMMANDES"
                                      name="all"
                                    >
                                      <br />
                                      <p align="left">
                                        <v-layout row>
                                          <v-flex md4>
                                            <v-chip
                                              text-color="white"
                                              label
                                              color="orange"
                                              style="width: 100%; font-weight: 20px"
                                              >MONTANT :
                                              {{ listCommandesRow.totalCommande }}
                                            </v-chip>
                                          </v-flex>
                                        </v-layout>
                                      </p>
                                      <data-tables
                                        :data="listCommandesRow.commAll"
                                        style="width:100%; font-size:15px"
                                      >
                                        <el-table-column
                                          prop="libelle"
                                          label="LIBELLE"
                                          fixed
                                        >
                                          <template slot-scope="scope">
                                            <v-chip
                                              label
                                              text-color="white"
                                              color="primary"
                                              >{{ scope.row.ref }}</v-chip
                                            >
                                            <v-chip
                                              label
                                              text-color="white"
                                              color="primary"
                                              >{{ scope.row.libelle }}</v-chip
                                            >
                                          </template>
                                        </el-table-column>
                                        <el-table-column
                                          prop="dateC"
                                          label="DATE"
                                          width="120"
                                        >
                                          <template slot-scope="scope">
                                            <v-chip
                                              outline
                                              label
                                              text-color="primary"
                                              color="primary"
                                              >{{ scope.row.dateC }}</v-chip
                                            >
                                          </template>
                                        </el-table-column>
                                        <el-table-column label="ETAT">
                                          <template slot-scope="scope">
                                            <v-chip
                                              text-color="white"
                                              label
                                              color="green"
                                              v-if="scope.row.valid === 1"
                                            >
                                              VALIDER
                                              <v-icon right></v-icon>
                                            </v-chip>
                                            <v-chip
                                              text-color="white"
                                              label
                                              color="red"
                                              v-if="scope.row.valid === 2"
                                            >
                                              REJETE
                                              <v-icon right></v-icon>
                                            </v-chip>
                                            <v-chip
                                              text-color="white"
                                              label
                                              color="red"
                                              v-if="scope.row.etat === false"
                                            >
                                              NON LIVRE
                                              <v-icon right></v-icon>
                                            </v-chip>
                                            <v-chip
                                              text-color="white"
                                              label
                                              color="green"
                                              v-if="scope.row.etat == true"
                                            >
                                              LIVRE
                                              <v-icon right></v-icon>
                                            </v-chip>
                                          </template>
                                        </el-table-column>
                                        <el-table-column
                                          label="ACTIONS"
                                          width="200"
                                          fixed="right"
                                        >
                                          <template slot-scope="scope">
                                            <v-btn
                                              icons
                                              color="green"
                                              @click="showCommande(scope.row)"
                                              fab
                                              dark
                                              small
                                            >
                                              <v-icon>folder_open</v-icon>
                                            </v-btn>
                                            <v-btn
                                              v-if="
                                                scope.row.factureValide === 0
                                              "
                                              icons
                                              color="primary"
                                              @click="editCommande(scope.row)"
                                              fab
                                              dark
                                              small
                                            >
                                              <v-icon>edit</v-icon>
                                            </v-btn>
                                            <v-btn
                                              v-if="scope.row.valid === 0"
                                              icons
                                              color="green"
                                              @click="
                                                newValidCommande(scope.row)
                                              "
                                              fab
                                              dark
                                              small
                                            >
                                              <v-icon>done_all</v-icon>
                                            </v-btn>
                                            <v-btn
                                              icons
                                              color="orange"
                                              @click="
                                                imprimerCommande(scope.row)
                                              "
                                              fab
                                              dark
                                              small
                                            >
                                              <v-icon>print</v-icon>
                                            </v-btn>
                                          </template>
                                        </el-table-column>
                                      </data-tables>
                                    </el-tab-pane>
                                  </el-tabs>
                                </div>
                              </el-tab-pane>
                            </el-tabs>

                          </el-tab-pane>
                        </el-tabs>
                      </el-tab-pane>
                      <!-- PLANINGS -->
                      <el-tab-pane label="PLANINGS" name="planings">
                        <div>
                          <div style="height: 400px" ref="gantt"></div>
                        </div>
                      </el-tab-pane>
                    </el-tabs>

                    <!-- POINT DU SUIVIE GENERAL DU PROJET PAR TRAVAUX -->
                    <el-tabs v-if="listTravauxSuivie.length != 0">
                      <v-layout row>
                        <v-flex md12>
                          <v-chip
                            text-color="white"
                            label
                            color="green"
                            style="width: 100%"
                            >TRAVAUX {{ listTravauxSuivie[0].libelle }}</v-chip
                          >
                        </v-flex>
                      </v-layout>

                      <el-tab-pane
                        :label="itemT.libelle"
                        :name="itemT.key"
                        v-for="(itemT) in listTravauxSuivie"
                        :key="itemT.key"
                      >
                        <!-- DETAILS DES TRAVAUX -->
                        <el-row>
                          <el-card class="box-card">
                            <div class="grid-content" style="padding:3px;">
                              <el-row>
                                <div class="text item">
                                  <v-layout row justify>
                                    <v-flex md3>
                                      <p>
                                        <b>Identifiant :</b>
                                        {{ itemT.ref }}
                                      </p>
                                      <p>
                                        <b>Libellé :</b>
                                        {{ itemT.libelle }}
                                      </p>
                                      <p>
                                        <b>Chantier concerné :</b>
                                        {{ itemT.chantier }}
                                      </p>
                                      <p>
                                        <b>Sous-traité :</b>
                                        {{ itemT.soutraiteLibelle }}
                                      </p>
                                      <p v-if="itemT.fournisseur !=''">
                                        <b>Sous-traitant :</b>
                                        {{ itemT.fournisseur }}
                                      </p>
                                    </v-flex>
                                    <v-flex md3>
                                      <p>
                                        <b>Date de début :</b>
                                        {{ itemT.dateD }}
                                      </p>
                                      <p>
                                        <b>Date de fin :</b>
                                        {{ itemT.dateF }}
                                      </p>
                                      <p>
                                        <b>Durée :</b>
                                        {{ itemT.duree }} Jour(s)
                                      </p>
                                      <p>
                                        <b>Tache correspondant :</b>
                                        {{ itemT.tache }}
                                      </p>
                                    </v-flex>
                                    <v-flex md3>
                                      <p>
                                        <b>Statut :</b>
                                        <v-chip
                                          v-if="itemT.evolution == 0"
                                          outline
                                          text-color="orange"
                                          label
                                          color="green"
                                        >
                                          EN ATTENTE
                                          <v-icon right></v-icon>
                                        </v-chip>
                                        <v-chip
                                          v-else
                                          outline
                                          text-color="green"
                                          label
                                          color="green"
                                        >
                                          EN EXECUTION
                                          <v-icon right></v-icon>
                                        </v-chip>
                                      </p>
                                      <p>
                                        <b>Montant des travaux :</b>
                                        {{ new Intl.NumberFormat('fr-Fr').format(itemT.montant) }}
                                      </p>
                                      <p>
                                        <b>Date d'enregistrement :</b>
                                        {{ itemT.created }}
                                      </p>
                                      <p>
                                        <b>Date de modification :</b>
                                        {{ itemT.modified }}
                                      </p>
                                    </v-flex>
                                    <v-flex md3>
                                      <p>
                                        <b>ETAT GLOBAL DES TRAVAUX</b>
                                      </p>
                                      <p>
                                        <v-progress-circular
                                          :size="160"
                                          :width="25"
                                          :rotate="360"
                                          :value="itemT.evolution"
                                          color="orange"
                                          >{{
                                            itemT.evolutionNbr
                                          }}
                                          %</v-progress-circular
                                        >
                                      </p>
                                    </v-flex>
                                  </v-layout>
                                </div>
                              </el-row>
                            </div>
                          </el-card>
                        </el-row>
                        <br />

                        <!-- MENU DETAILE DES TRAVAUX -->
                        <el-tabs v-model="activeTacheChantier">
                          <el-tab-pane label="TACHES" name="tacheChantier">
                            <br />
                            <el-card class="box-card">
                              <p align="right">
                                <v-tooltip
                                  top
                                  v-if="droitAcces.imprime_tache_travaaux_all"
                                >
                                  <v-btn
                                    slot="activator"
                                    icons
                                    color="orange"
                                    @click.stop="imprimerTacheTravaux(itemT)"
                                    dark
                                  >
                                    Imprimer
                                    <v-icon right>print</v-icon> </v-btn
                                  >Imprimer toutes les tâches
                                </v-tooltip>
                              </p>

                              <div class="grid-content" style="padding:3px;">
                                <el-row>
                                  <data-tables
                                    ref="multipleTable"
                                    @selection-change="selectionChangeTravaux"
                                    :data="itemT.taches"
                                    style="width:100%; font-size:15px"
                                  >
                                    <el-table-column
                                      :selectable="soustraitanceSelect"
                                      width="55"
                                      type="selection"
                                    ></el-table-column>
                                    <el-table-column
                                      prop="travaux"
                                      label="TRAVAUX"
                                      width="230"
                                      fixed="left"
                                    >
                                      <template slot-scope="scope">
                                        <v-chip
                                          label
                                          text-color="white"
                                          color="primary"
                                          >{{ scope.row.travaux }}</v-chip
                                        >
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      prop="tacheLibelle"
                                      label="TÂCHES A REALISER"
                                    >
                                      <template slot-scope="scope">
                                        <v-chip
                                          outline
                                          label
                                          text-color="primary"
                                          color="primary"
                                          >{{ scope.row.tacheLibelle }}</v-chip
                                        >
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      label="DATE ET INTERVAL DE TEMPS"
                                      align="center"
                                    >
                                      <el-table-column
                                        prop="dateDebut"
                                        label="Début"
                                        width="100"
                                      ></el-table-column>
                                      <el-table-column
                                        prop="dateFin"
                                        label="Fin"
                                        width="100"
                                      ></el-table-column>
                                      <el-table-column
                                        prop="duree"
                                        label="Durée (Jours) "
                                        width="120"
                                      >
                                        <template slot-scope="scope">
                                          <v-chip
                                            text-color="white"
                                            color="primary"
                                            >{{
                                              scope.row.duree
                                            }}
                                            Jour(s)</v-chip
                                          >
                                        </template>
                                      </el-table-column>
                                    </el-table-column>
                                    <el-table-column
                                      label="ETAT GLOBAL"
                                      width="140"
                                    >
                                      <template slot-scope="scope">
                                        <el-progress
                                          :text-inside="true"
                                          :stroke-width="30"
                                          :percentage="scope.row.evolution"
                                          status="success"
                                        ></el-progress>
                                      </template>
                                    </el-table-column>
                                    <el-table-column label="ETAT" width="150">
                                      <template slot-scope="scope">
                                        <v-chip
                                          v-if="scope.row.evolution === 0"
                                          label
                                          text-color="white"
                                          color="red"
                                          >EN ATTENTE</v-chip
                                        >
                                        <v-chip
                                          v-if="
                                            scope.row.evolution > 0 &&
                                              scope.row.evolution !== 100
                                          "
                                          label
                                          text-color="white"
                                          color="primary"
                                          >EN EXECUTION</v-chip
                                        >
                                        <v-chip
                                          v-if="scope.row.evolution === 100"
                                          label
                                          text-color="white"
                                          color="green"
                                          >TERMINE</v-chip
                                        >
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      label="ACTIONS"
                                      width="200"
                                      fixed="right"
                                    >
                                      <template slot-scope="scope">
                                        <v-btn
                                          icons
                                          color="green"
                                          @click="showTache(scope.row)"
                                          fab
                                          dark
                                          small
                                        >
                                          <v-icon>folder_open</v-icon>
                                        </v-btn>
                                        <v-btn
                                          v-if="
                                            scope.row.evolution !== 100 &&
                                              scope.row.etatContrat == 1 &&
                                              scope.row.lastRapport === true &&
                                              droitAcces.new_rapport_travaux
                                          "
                                          icons
                                          color="orange"
                                          @click="newRapport(scope.row)"
                                          fab
                                          dark
                                          small
                                        >
                                          <v-icon>description</v-icon>
                                        </v-btn>
                                        <v-btn
                                          v-if="scope.row.evolution === 100"
                                          icons
                                          color="green"
                                          @click="newValid(scope.row)"
                                          fab
                                          dark
                                          small
                                        >
                                          <v-icon>done_all</v-icon>
                                        </v-btn>
                                        <v-btn
                                          icons
                                          color="orange"
                                          v-if="droitAcces.imprime_tache"
                                          @click="imprimerTache(scope.row)"
                                          fab
                                          dark
                                          small
                                        >
                                          <v-icon>print</v-icon>
                                        </v-btn>
                                        <v-btn
                                          v-if="
                                            scope.row.evolution === 0 &&
                                              scope.row.etatContrat == 0
                                          "
                                          icons
                                          color="red"
                                          @click.stop="
                                            dialogSuprTache = true;
                                            idTache = scope.row.id;
                                          "
                                          fab
                                          dark
                                          small
                                        >
                                          <v-icon>delete</v-icon>
                                        </v-btn>
                                      </template>
                                    </el-table-column>
                                  </data-tables>
                                </el-row>
                              </div>
                            </el-card>
                            <br />

                            <v-tooltip top>
                              <v-btn
                                v-if="
                                  !choixTravux &&
                                    droitAcces.new_demarrer_travaux
                                "
                                slot="activator"
                                icons
                                color="green"
                                @click.stop="newDemarerTravaux(itemT)"
                                dark
                              >
                                Démarrer
                                <v-icon right>last_page</v-icon> </v-btn
                              >Démarrer les travaux
                            </v-tooltip>
                          </el-tab-pane>
                          <el-tab-pane
                            label="COMMANDES"
                            name="commandeChantier"
                          >
                            <div>
                              <el-tabs v-model="activeComChantier">
                                <!-- COMMANDE A VALIDER -->
                                <el-tab-pane label="A VALIDER" name="avalider">
                                  <br />
                                  <el-card class="box-card">
                                    <div
                                      class="grid-content"
                                      style="padding:3px;"
                                    >
                                      <p align="left">
                                        <v-layout row>
                                          <v-flex md4>
                                            <v-chip
                                              text-color="white"
                                              label
                                              color="orange"
                                              style="width: 100%; font-weight: 20px"
                                              >MONTANT :
                                              {{ itemT.totalCommandeAValider }}
                                            </v-chip>
                                          </v-flex>
                                        </v-layout>
                                      </p>
                                      <el-row>
                                        <data-tables
                                          :data="itemT.commavalider"
                                          style="width:100%; font-size:15px"
                                        >
                                          <el-table-column
                                            prop="libelle"
                                            label="LIBELLE"
                                            fixed
                                          >
                                            <template slot-scope="scope">
                                              <v-chip
                                                label
                                                text-color="white"
                                                color="primary"
                                                >{{ scope.row.ref }}</v-chip
                                              >
                                              <v-chip
                                                label
                                                text-color="white"
                                                color="primary"
                                                >{{ scope.row.libelle }}</v-chip
                                              >
                                            </template>
                                          </el-table-column>
                                          <el-table-column
                                            prop="dateC"
                                            label="DATE"
                                            width="120"
                                          >
                                            <template slot-scope="scope">
                                              <v-chip
                                                outline
                                                label
                                                text-color="primary"
                                                color="primary"
                                                >{{ scope.row.dateC }}</v-chip
                                              >
                                            </template>
                                          </el-table-column>
                                          <el-table-column label="ETAT">
                                            <template slot-scope="scope">
                                              <v-chip
                                                text-color="white"
                                                label
                                                color="orange"
                                                v-if="scope.row.valid === 0"
                                              >
                                                EN ATENTE DE VALIDATION
                                                <v-icon right></v-icon>
                                              </v-chip>
                                              <v-chip
                                                text-color="white"
                                                label
                                                color="red"
                                                v-if="scope.row.valid === 2"
                                              >
                                                REJETE
                                                <v-icon right></v-icon>
                                              </v-chip>
                                              <v-chip
                                                text-color="white"
                                                label
                                                color="red"
                                                v-if="scope.row.etat === false"
                                              >
                                                NON LIVRE
                                                <v-icon right></v-icon>
                                              </v-chip>
                                            </template>
                                          </el-table-column>
                                          <el-table-column
                                            label="ACTIONS"
                                            width="200"
                                            fixed="right"
                                          >
                                            <template slot-scope="scope">
                                              <v-btn
                                                icons
                                                color="green"
                                                @click="showCommande(scope.row)"
                                                fab
                                                dark
                                                small
                                              >
                                                <v-icon>folder_open</v-icon>
                                              </v-btn>
                                              <v-btn
                                                icons
                                                color="primary"
                                                @click="editCommande(scope.row)"
                                                fab
                                                dark
                                                small
                                              >
                                                <v-icon>edit</v-icon>
                                              </v-btn>
                                              <v-btn
                                                icons
                                                color="green"
                                                @click="
                                                  newValidCommande(scope.row)
                                                "
                                                fab
                                                dark
                                                small
                                              >
                                                <v-icon>done_all</v-icon>
                                              </v-btn>
                                              <v-btn
                                                icons
                                                color="orange"
                                                @click="
                                                  imprimerCommande(scope.row)
                                                "
                                                fab
                                                dark
                                                small
                                              >
                                                <v-icon>print</v-icon>
                                              </v-btn>
                                            </template>
                                          </el-table-column>
                                        </data-tables>
                                      </el-row>
                                    </div>
                                  </el-card>
                                </el-tab-pane>
                                <!-- COMMANDE VALIDER -->
                                <el-tab-pane label="VALIDER" name="valider">
                                  <br />
                                  <el-card class="box-card">
                                    <div
                                      class="grid-content"
                                      style="padding:3px;"
                                    >
                                      <p align="left">
                                        <v-layout row>
                                          <v-flex md4>
                                            <v-chip
                                              text-color="white"
                                              label
                                              color="orange"
                                              style="width: 100%; font-weight: 20px"
                                              >MONTANT :
                                              {{ itemT.totalCommandeValider }}
                                            </v-chip>
                                          </v-flex>
                                        </v-layout>
                                      </p>
                                      <el-row>
                                        <data-tables
                                          :data="itemT.commvalide"
                                          style="width:100%; font-size:15px"
                                        >
                                          <el-table-column
                                            prop="libelle"
                                            label="LIBELLE"
                                            fixed
                                          >
                                            <template slot-scope="scope">
                                              <v-chip
                                                label
                                                text-color="white"
                                                color="primary"
                                                >{{ scope.row.ref }}</v-chip
                                              >
                                              <v-chip
                                                label
                                                text-color="white"
                                                color="primary"
                                                >{{ scope.row.libelle }}</v-chip
                                              >
                                            </template>
                                          </el-table-column>
                                          <el-table-column
                                            prop="dateC"
                                            label="DATE"
                                            width="120"
                                          >
                                            <template slot-scope="scope">
                                              <v-chip
                                                outline
                                                label
                                                text-color="primary"
                                                color="primary"
                                                >{{ scope.row.dateC }}</v-chip
                                              >
                                            </template>
                                          </el-table-column>
                                          <el-table-column label="ETAT">
                                            <template slot-scope="scope">
                                              <v-chip
                                                text-color="white"
                                                label
                                                color="green"
                                                v-if="scope.row.valid === 1"
                                              >
                                                VALIDER
                                                <v-icon right></v-icon>
                                              </v-chip>
                                              <v-chip
                                                text-color="white"
                                                label
                                                color="red"
                                                v-if="scope.row.valid === 2"
                                              >
                                                REJETE
                                                <v-icon right></v-icon>
                                              </v-chip>
                                              <v-chip
                                                text-color="white"
                                                label
                                                color="red"
                                                v-if="scope.row.etat === false"
                                              >
                                                NON LIVRE
                                                <v-icon right></v-icon>
                                              </v-chip>
                                              <v-chip
                                                text-color="white"
                                                label
                                                color="green"
                                                v-if="scope.row.etat == true"
                                              >
                                                LIVRE
                                                <v-icon right></v-icon>
                                              </v-chip>
                                            </template>
                                          </el-table-column>
                                          <el-table-column
                                            label="ACTIONS"
                                            width="200"
                                            fixed="right"
                                          >
                                            <template slot-scope="scope">
                                              <v-btn
                                                icons
                                                color="green"
                                                @click="showCommande(scope.row)"
                                                fab
                                                dark
                                                small
                                              >
                                                <v-icon>folder_open</v-icon>
                                              </v-btn>
                                              <v-btn
                                                icons
                                                color="orange"
                                                @click="
                                                  imprimerCommande(scope.row)
                                                "
                                                fab
                                                dark
                                                small
                                              >
                                                <v-icon>print</v-icon>
                                              </v-btn>
                                            </template>
                                          </el-table-column>
                                        </data-tables>
                                      </el-row>
                                    </div>
                                  </el-card>
                                </el-tab-pane>
                                <!-- COMMANDE A LIVRE -->
                                <el-tab-pane label="A LIVRE" name="alivre">
                                  <br />

                                  <el-card class="box-card">
                                    <div
                                      class="grid-content"
                                      style="padding:3px;"
                                    >
                                      <p align="left">
                                        <v-layout row>
                                          <v-flex md4>
                                            <v-chip
                                              text-color="white"
                                              label
                                              color="orange"
                                              style="width: 100%; font-weight: 20px"
                                              >MONTANT :
                                              {{ itemT.totalCommandeALivrer }}
                                            </v-chip>
                                          </v-flex>
                                        </v-layout>
                                      </p>
                                      <el-row>
                                        <data-tables
                                          :data="itemT.commaLivrer"
                                          style="width:100%; font-size:15px"
                                        >
                                          <el-table-column
                                            prop="libelle"
                                            label="LIBELLE"
                                            fixed
                                          >
                                            <template slot-scope="scope">
                                              <v-chip
                                                label
                                                text-color="white"
                                                color="primary"
                                                >{{ scope.row.ref }}</v-chip
                                              >
                                              <v-chip
                                                label
                                                text-color="white"
                                                color="primary"
                                                >{{ scope.row.libelle }}</v-chip
                                              >
                                            </template>
                                          </el-table-column>
                                          <el-table-column
                                            prop="dateC"
                                            label="DATE"
                                            width="120"
                                          >
                                            <template slot-scope="scope">
                                              <v-chip
                                                outline
                                                label
                                                text-color="primary"
                                                color="primary"
                                                >{{ scope.row.dateC }}</v-chip
                                              >
                                            </template>
                                          </el-table-column>
                                          <el-table-column label="ETAT">
                                            <template slot-scope="scope">
                                              <v-chip
                                                text-color="white"
                                                label
                                                color="green"
                                                v-if="scope.row.valid === 1"
                                              >
                                                VALIDE
                                                <v-icon right></v-icon>
                                              </v-chip>
                                              <v-chip
                                                text-color="white"
                                                label
                                                color="red"
                                                v-if="scope.row.etat == false"
                                              >
                                                NON LIVRE
                                                <v-icon right></v-icon>
                                              </v-chip>
                                            </template>
                                          </el-table-column>
                                          <el-table-column
                                            label="ACTIONS"
                                            width="200"
                                            fixed="right"
                                          >
                                            <template slot-scope="scope">
                                              <v-btn
                                                icons
                                                color="green"
                                                @click="showCommande(scope.row)"
                                                fab
                                                dark
                                                small
                                              >
                                                <v-icon>folder_open</v-icon>
                                              </v-btn>
                                              <v-btn
                                                icons
                                                color="orange"
                                                @click="
                                                  imprimerCommande(scope.row)
                                                "
                                                fab
                                                dark
                                                small
                                              >
                                                <v-icon>print</v-icon>
                                              </v-btn>
                                            </template>
                                          </el-table-column>
                                        </data-tables>
                                      </el-row>
                                    </div>
                                  </el-card>
                                </el-tab-pane>
                                <!-- COMMANDE LIVRE -->
                                <el-tab-pane label="LIVRE" name="livre">
                                  <br />

                                  <el-card class="box-card">
                                    <div
                                      class="grid-content"
                                      style="padding:3px;"
                                    >
                                      <p align="left">
                                        <v-layout row>
                                          <v-flex md4>
                                            <v-chip
                                              text-color="white"
                                              label
                                              color="orange"
                                              style="width: 100%; font-weight: 20px"
                                              >MONTANT :
                                              {{ itemT.totalCommandeLivre }}
                                            </v-chip>
                                          </v-flex>
                                        </v-layout>
                                      </p>
                                      <el-row>
                                        <data-tables
                                          :data="itemT.commLivre"
                                          style="width:100%; font-size:15px"
                                        >
                                          <el-table-column
                                            prop="libelle"
                                            label="LIBELLE"
                                            fixed
                                          >
                                            <template slot-scope="scope">
                                              <v-chip
                                                label
                                                text-color="white"
                                                color="primary"
                                                >{{ scope.row.ref }}</v-chip
                                              >
                                              <v-chip
                                                label
                                                text-color="white"
                                                color="primary"
                                                >{{ scope.row.libelle }}</v-chip
                                              >
                                            </template>
                                          </el-table-column>
                                          <el-table-column
                                            prop="dateC"
                                            label="DATE"
                                            width="120"
                                          >
                                            <template slot-scope="scope">
                                              <v-chip
                                                outline
                                                label
                                                text-color="primary"
                                                color="primary"
                                                >{{ scope.row.dateC }}</v-chip
                                              >
                                            </template>
                                          </el-table-column>
                                          <el-table-column label="ETAT">
                                            <template slot-scope="scope">
                                              <v-chip
                                                text-color="white"
                                                label
                                                color="green"
                                                v-if="scope.row.valid === 1"
                                              >
                                                VALIDE
                                                <v-icon right></v-icon>
                                              </v-chip>
                                              <v-chip
                                                text-color="white"
                                                label
                                                color="green"
                                                v-if="scope.row.etat == true"
                                              >
                                                LIVRE
                                                <v-icon right></v-icon>
                                              </v-chip>
                                            </template>
                                          </el-table-column>
                                          <el-table-column
                                            label="ACTIONS"
                                            width="200"
                                            fixed="right"
                                          >
                                            <template slot-scope="scope">
                                              <v-btn
                                                icons
                                                color="green"
                                                @click="showCommande(scope.row)"
                                                fab
                                                dark
                                                small
                                              >
                                                <v-icon>folder_open</v-icon>
                                              </v-btn>
                                              <v-btn
                                                icons
                                                color="orange"
                                                @click="
                                                  imprimerCommande(scope.row)
                                                "
                                                fab
                                                dark
                                                small
                                              >
                                                <v-icon>print</v-icon>
                                              </v-btn>
                                            </template>
                                          </el-table-column>
                                        </data-tables>
                                      </el-row>
                                    </div>
                                  </el-card>
                                </el-tab-pane>
                                <!-- TOUTES LES COMMANDES -->
                                <el-tab-pane
                                  label="TOUTES LES COMMANDES"
                                  name="all"
                                >
                                  <br />
                                  <p align="left">
                                    <v-layout row>
                                      <v-flex md4>
                                        <v-chip
                                          text-color="white"
                                          label
                                          color="orange"
                                          style="width: 100%; font-weight: 20px"
                                          >MONTANT : {{ itemT.totalCommande }}
                                        </v-chip>
                                      </v-flex>
                                    </v-layout>
                                  </p>
                                  <data-tables
                                    :data="itemT.commAll"
                                    style="width:100%; font-size:15px"
                                  >
                                    <el-table-column
                                      prop="libelle"
                                      label="LIBELLE"
                                      fixed
                                    >
                                      <template slot-scope="scope">
                                        <v-chip
                                          label
                                          text-color="white"
                                          color="primary"
                                          >{{ scope.row.ref }}</v-chip
                                        >
                                        <v-chip
                                          label
                                          text-color="white"
                                          color="primary"
                                          >{{ scope.row.libelle }}</v-chip
                                        >
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      prop="dateC"
                                      label="DATE"
                                      width="120"
                                    >
                                      <template slot-scope="scope">
                                        <v-chip
                                          outline
                                          label
                                          text-color="primary"
                                          color="primary"
                                          >{{ scope.row.dateC }}</v-chip
                                        >
                                      </template>
                                    </el-table-column>
                                    <el-table-column label="ETAT">
                                      <template slot-scope="scope">
                                        <v-chip
                                          text-color="white"
                                          label
                                          color="green"
                                          v-if="scope.row.valid === 1"
                                        >
                                          VALIDER
                                          <v-icon right></v-icon>
                                        </v-chip>
                                        <v-chip
                                          text-color="white"
                                          label
                                          color="red"
                                          v-if="scope.row.valid === 2"
                                        >
                                          REJETE
                                          <v-icon right></v-icon>
                                        </v-chip>
                                        <v-chip
                                          text-color="white"
                                          label
                                          color="red"
                                          v-if="scope.row.etat === false"
                                        >
                                          NON LIVRE
                                          <v-icon right></v-icon>
                                        </v-chip>
                                        <v-chip
                                          text-color="white"
                                          label
                                          color="green"
                                          v-if="scope.row.etat == true"
                                        >
                                          LIVRE
                                          <v-icon right></v-icon>
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      label="ACTIONS"
                                      width="200"
                                      fixed="right"
                                    >
                                      <template slot-scope="scope">
                                        <v-btn
                                          icons
                                          color="green"
                                          @click="showCommande(scope.row)"
                                          fab
                                          dark
                                          small
                                        >
                                          <v-icon>folder_open</v-icon>
                                        </v-btn>
                                        <v-btn
                                          v-if="scope.row.factureValide === 0"
                                          icons
                                          color="primary"
                                          @click="editCommande(scope.row)"
                                          fab
                                          dark
                                          small
                                        >
                                          <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn
                                          v-if="scope.row.valid === 0"
                                          icons
                                          color="green"
                                          @click="newValidCommande(scope.row)"
                                          fab
                                          dark
                                          small
                                        >
                                          <v-icon>done_all</v-icon>
                                        </v-btn>
                                        <v-btn
                                          icons
                                          color="orange"
                                          @click="imprimerCommande(scope.row)"
                                          fab
                                          dark
                                          small
                                        >
                                          <v-icon>print</v-icon>
                                        </v-btn>
                                      </template>
                                    </el-table-column>
                                  </data-tables>
                                </el-tab-pane>
                              </el-tabs>
                            </div>
                          </el-tab-pane>
                        </el-tabs>
                      </el-tab-pane>

                      <!-- PLANINGS -->
                      <el-tab-pane label="PLANINGS" name="planings">
                        <div>
                          <div style="height: 400px" ref="gantt"></div>
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                </el-tab-pane>

                <!-- MATRICE CONTRACTUELLE -->
                <el-tab-pane>
                  <span slot="label">
                    <i class="el-icon-tickets"></i> Matrice contractuelle
                  </span>
                  <v-layout row justify>
                    <MatriceContract
                      :idProjet="detailProjet.id"
                      :show="showMatrice"
                    ></MatriceContract>
                  </v-layout>
                </el-tab-pane>
              </el-tabs>
            </div>
          </v-container>

          <v-tooltip top>
            <v-btn
              slot="activator"
              icons
              color="orange"
              @click.stop="dialogShowProjet = false"
              dark
            >
              Fermer
              <v-icon right>close</v-icon> </v-btn
            >Fermer
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              slot="activator"
              icons
              color="primary"
              v-if="droitAcces.new_projet"
              @click.stop="ajoutProjet('edit', detailProjet)"
              dark
            >
              Modifer
              <v-icon right>edit</v-icon> </v-btn
            >Modifier
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              v-if="!choixChantier"
              slot="activator"
              icons
              color="teal"
              @click.stop="newDupliqueChantier(detailProjet)"
              dark
            >
              Dupliquer
              <v-icon right>file_copy</v-icon> </v-btn
            >Dupliquer des chantiers
          </v-tooltip>
          <!-- <v-tooltip top>
            <v-btn
              slot="activator"
              icons
              color="orange"
              @click.stop="newRapportTravaux()"
              dark
            >
              Rapport travaux
              <v-icon right>description</v-icon> </v-btn
            >Rapport des travaux
          </v-tooltip> -->
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW TRAVAUX -->
    <v-dialog
      persistent
      v-model="dialogShowTravaux"
      v-if="droitAcces.show_travaux"
      max-width="90%"
      :overlay="true"
      scrollable
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span
              >Détails des travaux TRAV-{{ detailTravaux.libelle }} /
              {{ detailTravaux.ref }}</span
            >
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="handleTabClick('2'); dialogShowTravaux = false;" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container fluid grid-list-md>
            <!-- DETAIL TRAVAUX -->
            <el-row :gutter="20" style="padding:10px;">
              <el-card class="box-card">
                <div class="grid-content" style="padding:3px;">
                  <el-row>
                    <div class="text item">
                      <v-layout row justify>
                        <v-flex md3>
                          <p>
                            <b>Identifiant :</b>
                            {{ detailTravaux.ref }}
                          </p>
                          <p>
                            <b>Libellé :</b>
                            {{ detailTravaux.libelle }}
                          </p>
                          <p>
                            <b>Chantier concerné :</b>
                            {{ detailTravaux.chantier }}
                          </p>
                          <p>
                            <b>Sous-traité :</b>
                            {{ detailTravaux.soutraiteLibelle }}
                          </p>
                          <p v-if="detailTravaux.fournisseur !=''">
                            <b>Sous-traitant :</b>
                            {{ detailTravaux.fournisseur }}
                          </p>
                        </v-flex>
                        <v-flex md3>
                          <p>
                            <b>Date de début :</b>
                            {{ detailTravaux.dateD }}
                          </p>
                          <p>
                            <b>Date de fin :</b>
                            {{ detailTravaux.dateF }}
                          </p>
                          <p>
                            <b>Durée :</b>
                            {{ detailTravaux.duree }} Jour(s)
                          </p>
                          <p>
                            <b>Tache correspondant :</b>
                            {{ detailTravaux.tache }}
                          </p>
                        </v-flex>
                        <v-flex md3>
                          <p>
                            <b>Statut :</b>
                            <v-chip
                              v-if="detailTravaux.evolution == 0"
                              outline
                              text-color="orange"
                              label
                              color="green"
                            >
                              EN ATTENTE
                              <v-icon right></v-icon>
                            </v-chip>
                            <v-chip
                              v-else
                              outline
                              text-color="green"
                              label
                              color="green"
                            >
                              EN EXECUTION
                              <v-icon right></v-icon>
                            </v-chip>
                          </p>
                          <p>
                            <b>Montant des travaux :</b>
                            {{ detailTravaux.montant }}
                          </p>
                          <p>
                            <b>Date d'enregistrement :</b>
                            {{ detailTravaux.created }}
                          </p>
                          <p>
                            <b>Date de modification :</b>
                            {{ detailTravaux.modified }}
                          </p>
                        </v-flex>
                        <v-flex md3>
                          <p>
                            <b>ETAT GLOBAL DES TRAVAUX</b>
                          </p>
                          <p>
                            <v-progress-circular
                              :size="160"
                              :width="25"
                              :rotate="360"
                              :value="detailTravaux.evolution"
                              color="orange"
                              >{{
                                detailTravaux.evolutionNbr
                              }}
                              %</v-progress-circular
                            >
                          </p>
                        </v-flex>
                      </v-layout>
                    </div>
                  </el-row>
                </div>
              </el-card>
            </el-row>

            <div>
              <!-- TABS DETAIL TACHES ET PLANIF PRODUIT -->
              <el-tabs v-model="tabb">
                <!-- LISTE DES TACHES -->
                <el-tab-pane>
                  <span slot="label">
                    <i class="el-icon-tickets"></i> Liste des Taches
                  </span>
                  <p v-if="detailTravaux.option !== null" align="center">
                    <v-chip
                      text-color="white"
                      label
                      color="primary"
                      style="font-size:22px; width: 100%"
                    >
                      TOUTES LES TÂCHES
                      <v-icon right>subject</v-icon>
                    </v-chip>
                  </p>
                  <el-row
                    v-if="detailTravaux.option !== null"
                    :gutter="20"
                    style="padding:10px;"
                  >
                    <p align="right">
                      <v-tooltip
                        top
                        v-if="droitAcces.imprime_tache_travaaux_all"
                      >
                        <v-btn
                          slot="activator"
                          icons
                          color="orange"
                          @click.stop="imprimerTacheTravaux(detailTravaux)"
                          dark
                        >
                          Imprimer
                          <v-icon right>print</v-icon> </v-btn
                        >Imprimer toutes les tâches
                      </v-tooltip>
                    </p>

                    <el-card class="box-card">
                      <div class="grid-content" style="padding:3px;">
                        <el-row>
                          <data-tables
                            ref="multipleTable"
                            @selection-change="selectionChangeTravaux"
                            :data="detailTravaux.option"
                            style="width:100%; font-size:15px"
                          >
                            <el-table-column
                              :selectable="soustraitanceSelect"
                              width="55"
                              type="selection"
                            ></el-table-column>
                            <el-table-column
                              prop="tache"
                              label="TÂCHES A REALISER"
                              align="center"
                              width="230"
                              fixed="left"
                            >
                              <template slot-scope="scope">
                                <v-chip
                                  outline
                                  label
                                  text-color="primary"
                                  color="primary"
                                  >{{ scope.row.tacheLibelle }}</v-chip
                                >
                              </template>
                            </el-table-column>
                            <el-table-column
                              label="DATE ET INTERVAL DE TEMPS"
                              align="center"
                            >
                              <el-table-column
                                prop="dateD"
                                label="Début"
                                width="190"
                              ></el-table-column>
                              <el-table-column
                                prop="dateF"
                                label="Fin"
                                width="190"
                              ></el-table-column>
                              <el-table-column
                                prop="duree"
                                label="Durée (Jours) "
                                width="120"
                              >
                                <template slot-scope="scope">
                                  <v-chip text-color="white" color="primary"
                                    >{{ scope.row.duree }} Jour(s)</v-chip
                                  >
                                </template>
                              </el-table-column>
                            </el-table-column>
                            <el-table-column label="ETAT GLOBAL" width="120">
                              <template slot-scope="scope">
                                <v-progress-circular
                                  :size="80"
                                  :width="15"
                                  :rotate="360"
                                  :value="scope.row.evolution"
                                  color="green"
                                  >{{
                                    scope.row.evolution
                                  }}
                                  %</v-progress-circular
                                >
                              </template>
                            </el-table-column>
                            <el-table-column label="ETAT" width="150">
                              <template slot-scope="scope">
                                <v-chip
                                  v-if="scope.row.etat == 0"
                                  label
                                  text-color="white"
                                  color="red"
                                  >EN ATTENTE</v-chip
                                >
                                <v-chip
                                  v-if="scope.row.etat == 1"
                                  label
                                  text-color="white"
                                  color="primary"
                                  >EN EXECUTION</v-chip
                                >
                                <v-chip
                                  v-if="scope.row.etat == 2"
                                  label
                                  text-color="white"
                                  color="green"
                                  >TERMINE</v-chip
                                >

                                <v-chip
                                  v-if="scope.row.etat == 3"
                                  label
                                  text-color="white"
                                  color="green"
                                  >ARRETE</v-chip
                                >
                              </template>
                            </el-table-column>
                            <el-table-column
                              label="ACTIONS"
                              width="200"
                              fixed="right"
                            >
                              <template slot-scope="scope">
                                <!-- <v-btn
                                  icons
                                  color="primary"
                                  @click="newEquipe(scope.row)"
                                  fab
                                  dark
                                  small
                                >
                                  <v-icon>person_add</v-icon>
                                </v-btn> -->
                                <!-- <v-btn
                                  v-if="scope.row.evolution === 100"
                                  icons
                                  color="green"
                                  @click="newValid(scope.row)"
                                  fab
                                  dark
                                  small
                                >
                                  <v-icon>done_all</v-icon>
                                </v-btn>-->
                                <v-btn
                                  icons
                                  color="orange"
                                  @click="imprimerTache(scope.row)"
                                  fab
                                  dark
                                  small
                                >
                                  <v-icon>print</v-icon>
                                </v-btn>
                                <v-btn
                                  v-if="
                                    scope.row.evolution === 0 &&
                                      scope.row.etatContrat == 0
                                  "
                                  icons
                                  color="red"
                                  @click.stop="
                                    dialogSuprTache = true;
                                    idTache = scope.row.id;
                                  "
                                  fab
                                  dark
                                  small
                                >
                                  <v-icon>delete</v-icon>
                                </v-btn>
                              </template>
                            </el-table-column>
                          </data-tables>
                        </el-row>
                      </div>
                    </el-card>
                  </el-row>
                </el-tab-pane>
                <!-- LISTE DES PLANIFICATION PRODUIT -->
                <el-tab-pane>
                  <span slot="label">
                    <i class="el-icon-tickets"></i> Liste des planifications des
                    ressources
                  </span>
                  <p align="center">
                    <v-chip
                      text-color="white"
                      label
                      color="primary"
                      style="font-size:22px; width: 100%"
                    >
                      BESOIN ESTIMATF EN RESSOURCES
                      <v-icon right>subject</v-icon>
                    </v-chip>
                  </p>
                  <el-row :gutter="20" style="padding:10px;">
                    <el-card class="box-card">
                      <div class="grid-content" style="padding:3px;">
                        <el-row>
                          <data-tables
                            :data="detailTravaux.prod"
                            style="width:100%; font-size:15px"
                          >
                            <el-table-column
                              prop="tacheLibelle"
                              label="TACHE CONCERNE"
                              align="center"
                              width="250"
                              fixed="left"
                            >
                              <template slot-scope="scope">
                                <v-chip
                                  outline
                                  label
                                  text-color="primary"
                                  color="primary"
                                  >{{ scope.row.tacheLibelle }}</v-chip
                                >
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="dateD"
                              label="DEBUT DE LA TACHE"
                              align="center"
                              width="200"
                              fixed="left"
                            >
                              <template slot-scope="scope">
                                <v-chip
                                  outline
                                  label
                                  text-color="primary"
                                  color="primary"
                                  >{{ scope.row.dateD }}</v-chip
                                >
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="produit"
                              label="PRODUIT"
                              align="center"
                              width="230"
                              fixed="left"
                            >
                              <template slot-scope="scope">
                                <v-chip
                                  outline
                                  label
                                  text-color="primary"
                                  color="primary"
                                  >{{ scope.row.produit }}</v-chip
                                >
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="qte"
                              label="Quantité"
                              align="center"
                            >
                              <template slot-scope="scope">
                                <v-chip text-color="white" color="primary">{{
                                  scope.row.qte
                                }}</v-chip>
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="unite"
                              label="Unité"
                              align="center"
                            >
                              <template slot-scope="scope">
                                <v-chip text-color="white" color="primary">{{
                                  scope.row.unite
                                }}</v-chip>
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="created"
                              label="DATE DE CREATION"
                              align="center"
                            >
                              <template slot-scope="scope">{{
                                scope.row.created
                              }}</template>
                            </el-table-column>
                            <el-table-column label="Actions" width="140">
                          <template slot-scope="scope">
                            <v-btn
                              icons
                              color="green"
                              v-if="scope.row.typeProduit == 'VEHICULE'"
                              @click="showInfoRessources(scope.row)"
                              fab
                              dark
                              small
                            >
                              <v-icon>folder_open</v-icon>
                            </v-btn>
                            <v-btn
                              icons
                              color="primary"
                              v-if="scope.row.etatValid == 1"
                              @click="editRessources(scope.row)"
                              fab
                              dark
                              small
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                             <v-btn
                              icons
                              v-if="scope.row.etatValid == 1"
                              color="red"
                               @click.stop="
                                dialogSuprRessource = true;
                                idRessour = scope.row.id;
                              "
                              fab
                              dark
                              small
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                            <v-chip v-if="scope.row.etatValid == 0 ||  scope.row.etatValid == 2 ||  scope.row.etatValid == 4" text-color="white" color="success">
                              Besoin validé
                            </v-chip>
                              <v-chip v-if="scope.row.etatValid == 3" text-color="white" color="danger">
                              Besoin rejeté
                            </v-chip>
                          </template>
                        </el-table-column>
                          </data-tables>
                        </el-row>
                      </div>
                    </el-card>
                  </el-row>
                </el-tab-pane>
              </el-tabs>
            </div>

            <!-- LISTE DES BON D'EXECUTIONS -->
            <p v-if="listEquipe.length !== 0" align="center">
              <v-chip
                text-color="white"
                label
                color="primary"
                style="font-size:22px; width: 100%"
              >
                TOUTES LES BONS D'EXECUTIONS
                <v-icon right>person_add</v-icon>
              </v-chip>
            </p>
            <el-row
              v-if="listEquipe.length !== 0"
              :gutter="20"
              style="padding:10px;"
            >
              <p align="right">
                <v-tooltip top>
                  <v-btn
                    slot="activator"
                    icons
                    color="orange"
                    @click.stop="imprimerContratTravaux(detailTravaux)"
                    dark
                  >
                    Imprimer
                    <v-icon right>print</v-icon> </v-btn
                  >Imprimer
                </v-tooltip>
              </p>
              <el-card class="box-card">
                <div class="grid-content" style="padding:3px;">
                  <el-row>
                    <data-tables
                      ref="multipleTable"
                      @selection-change="handleSelectionChange"
                      :data="listEquipe"
                      style="width:100%; font-size:15px"
                      stripe
                      border
                    >
                      <el-table-column
                        :selectable="contratSelect"
                        width="55"
                        type="selection"
                      ></el-table-column>
                      <el-table-column
                        label="TÂCHES CONCERNE"
                        align="center"
                        width="220"
                        fixed
                      >
                        <template slot-scope="scope">
                          <v-chip text-color="white" color="primary">{{
                            scope.row.tache
                          }}</v-chip>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="EXECUTANT DE LA TÂCHES"
                        align="center"
                      >
                        <el-table-column
                          prop="typeExec"
                          label="Type"
                          width="190"
                        ></el-table-column>
                        <el-table-column
                          prop="executant"
                          label="Raison Sociale / Nom et prénoms"
                          width="190"
                        ></el-table-column>
                      </el-table-column>
                      <el-table-column
                        label="DATE ET INTERVAL DE TEMPS"
                        align="center"
                      >
                        <el-table-column
                          prop="dateD"
                          label="Début"
                          width="190"
                        ></el-table-column>
                        <el-table-column
                          prop="dateF"
                          label="Fin"
                          width="190"
                        ></el-table-column>
                        <el-table-column
                          prop="duree"
                          label="Durée (Jours)"
                          width="120"
                        >
                          <template slot-scope="scope">
                            <v-chip text-color="white" color="primary"
                              >{{ scope.row.duree }} Jour(s)</v-chip
                            >
                          </template>
                        </el-table-column>
                      </el-table-column>
                      <el-table-column label="COÛT TOTAL () " align="center">
                        <el-table-column
                          prop="montant"
                          label="Montant journalier"
                          width="190"
                        >
                          <template slot-scope="scope"
                            >{{ scope.row.montant }}
                          </template>
                        </el-table-column>
                        <el-table-column prop="total" label="TOTAL" width="120">
                          <template slot-scope="scope">
                            <v-chip text-color="white" color="green"
                              >{{ scope.row.total }}
                            </v-chip>
                          </template>
                        </el-table-column>
                      </el-table-column>
                      <el-table-column label="ETAT" width="150">
                        <template slot-scope="scope">
                          <v-chip
                            v-if="scope.row.etat === 0"
                            label
                            text-color="white"
                            color="red"
                            >EN ATTENTE</v-chip
                          >
                          <v-chip
                            v-if="scope.row.etat === 1"
                            label
                            text-color="white"
                            color="primary"
                            >EN EXECUTION</v-chip
                          >
                          <v-chip
                            v-if="scope.row.etat === 2"
                            label
                            text-color="white"
                            color="orange"
                            >SUSPENDU</v-chip
                          >
                          <v-chip
                            v-if="scope.row.etat === 3"
                            label
                            text-color="white"
                            color="green"
                            >TERMINE</v-chip
                          >
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="ACTIONS"
                        width="170"
                        fixed="right"
                      >
                        <template slot-scope="scope">
                          <v-btn
                            icons
                            color="primary"
                            @click="editEquipe(scope.row)"
                            fab
                            dark
                            small
                          >
                            <v-icon>edit</v-icon>
                          </v-btn>
                          <v-btn
                            icons
                            color="orange"
                            @click="imprimerContrat(scope.row)"
                            fab
                            dark
                            small
                          >
                            <v-icon>print</v-icon>
                          </v-btn>
                        </template>
                      </el-table-column>
                    </data-tables>
                  </el-row>
                </div>
              </el-card>
            </el-row>
          </v-container>

          <v-tooltip top>
            <v-btn
              slot="activator"
              icons
              color="orange"
              @click.stop="dialogShowTravaux = false"
              dark
            >
              Fermer
              <v-icon right>close</v-icon> </v-btn
            >Fermer
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              slot="activator"
              icons
              color="primary"
              @click.stop="
                editTravaux(detailTravaux, travauxCourant, listChantierResult)
              "
              dark
            >
              Modifier les travaux
              <v-icon right>edit</v-icon> </v-btn
            >Modifier
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              slot="activator"
              icons
              color="orange"
              @click.stop="imprimerTravaux(detailTravaux)"
              dark
            >
              Imprimer
              <v-icon right>print</v-icon> </v-btn
            >Imprimer
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              v-if="!choix"
              slot="activator"
              icons
              color="green"
              @click.stop="newDemarer(detailTravaux)"
              dark
            >
              Démarrer
              <v-icon right>last_page</v-icon> </v-btn
            >Démarrer les tâches
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              v-if="!choixTravux"
              slot="activator"
              icons
              color="green"
              @click.stop="newDemarerTravaux(detailTravaux)"
              dark
            >
              Démarrer
              <v-icon right>last_page</v-icon> </v-btn
            >Démarrer les travaux
          </v-tooltip>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW TACHE -->
    <v-dialog
      persistent
      v-model="dialogShowTache"
      v-if="droitAcces.show_tache_projet"
      max-width="90%"
      :overlay="true"
      scrollable
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span
              >Détails des tâches TACH-{{ detailTache.ref }}
              {{ detailTache.tacheLibelle }}</span
            >
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowTache = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container fluid grid-list-md>
            <!-- DETAIL TRAVAUX -->
            <el-row :gutter="20" style="padding:10px;">
              <el-card class="box-card">
                <div class="grid-content" style="padding:3px;">
                  <el-row>
                    <div class="text item">
                      <v-layout row justify>
                        <v-flex md3>
                          <p>
                            <b>Référence :</b>
                            {{ detailTache.ref }}
                          </p>
                          <p>
                            <b>Libellé :</b>
                            {{ detailTache.tacheLibelle }}
                          </p>
                          <p>
                            <b>Travaux concerné :</b>
                            {{ detailTache.travaux }}
                          </p>
                          <p>
                            <b>Sous-traité :</b>
                            {{ detailTache.soutraiteLibelle }}
                          </p>
                        </v-flex>
                        <v-flex md3>
                          <p v-if="detailTache.fournisseur !=''">
                            <b>Sous-traitant :</b>
                            {{ detailTache.fournisseur }}
                          </p>
                          <p>
                            <b>Date de début :</b>
                            {{ detailTache.dateD }}
                          </p>
                          <p>
                            <b>Date de fin :</b>
                            {{ detailTache.dateF }}
                          </p>
                          <p>
                            <b>Durée estimatif :</b>
                            {{ detailTache.duree }} Jour(s)
                          </p>
                        </v-flex>
                        <v-flex md3>
                          <p>
                            <b>Statut :</b>
                            <v-chip
                              v-if="detailTache.evolution == 0"
                              outline
                              text-color="orange"
                              label
                              color="green"
                            >
                              EN ATTENTE
                              <v-icon right></v-icon>
                            </v-chip>
                            <v-chip
                              v-else
                              outline
                              text-color="green"
                              label
                              color="green"
                            >
                              EN EXECUTION
                              <v-icon right></v-icon>
                            </v-chip>
                          </p>
                          <p>
                            <b>Date d'enregistrement :</b>
                            {{ detailTache.created }}
                          </p>
                          <p>
                            <b>Date de modification :</b>
                            {{ detailTache.modified }}
                          </p>
                        </v-flex>
                        <v-flex md3>
                          <p>
                            <b>ETAT GLOBAL DE LA TÂCHE</b>
                          </p>
                          <p>
                            <v-progress-circular
                              :size="120"
                              :width="25"
                              :rotate="360"
                              :value="detailTache.evolution"
                              color="orange"
                              >{{
                                detailTache.evolutionNbr
                              }}
                              %</v-progress-circular
                            >
                          </p>
                        </v-flex>
                      </v-layout>
                    </div>
                  </el-row>
                </div>
              </el-card>
            </el-row>

            <el-row>
              <el-collapse>
                <el-collapse-item
                  :title="item.ref"
                  :name="item.key"
                  v-for="(item) in detailTache.rapport"
                  :key="item.key"
                >
                  <div>
                    <div class="text item">
                      <v-layout row>
                        <v-flex md3>
                          <p>
                            <b>Référence :</b>
                            {{ item.ref }}
                          </p>
                          <p>
                            <b>Evolution :</b>
                            <v-chip text-color="white" color="primary"
                              >{{ item.evolutionNbr }} %</v-chip
                            >
                          </p>
                          <p>
                            <b>Progrès de :</b>
                            <v-chip text-color="white" color="green"
                              >{{ item.ecart }} %</v-chip
                            >
                          </p>
                        </v-flex>
                        <v-flex md3>
                          <p>
                            <b>Validé par :</b>
                            {{ item.validation }}
                          </p>
                          <p>
                            <b>Description :</b>
                            {{ item.description }}
                          </p>
                          <p>
                            <b>Crée par :</b>
                            {{ item.userCreate }}
                          </p>
                        </v-flex>
                        <v-flex md3>
                          <el-upload
                            class="upload-demo"
                            action
                            :file-list="item.fichier"
                            list-type="picture"
                            :disabled="true"
                          ></el-upload>
                        </v-flex>
                      </v-layout>
                    </div>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </el-row>
          </v-container>

          <v-tooltip top>
            <v-btn
              slot="activator"
              icons
              color="orange"
              @click.stop="dialogShowTache = false"
              dark
            >
              Fermer
              <v-icon right>close</v-icon> </v-btn
            >Fermer
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              slot="activator"
              icons
              color="orange"
              @click.stop="imprimerTache(detailTache)"
              dark
            >
              Imprimer
              <v-icon right>print</v-icon> </v-btn
            >Imprimer
          </v-tooltip>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW COMMANDE -->
    <v-dialog
      persistent
      v-model="dialogShowCommande"
      v-if="droitAcces.commande_show"
      max-width="60%"
      :overlay="true"
      scrollable
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span
              >Détails de la commande {{ detailCommande.libelle }} /
              {{ detailCommande.ref }}</span
            >
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowCommande = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container fluid grid-list-md>
            <!-- DETAIL COMMANDE -->
            <el-row :gutter="20" style="padding:10px;">
              <el-card class="box-card">
                <div class="grid-content" style="padding:3px;">
                  <el-row>
                    <div class="text item">
                      <v-layout row justify>
                        <v-flex md6>
                          <p>
                            <b>Identifiant :</b>
                            {{ detailCommande.ref }}
                          </p>
                          <p>
                            <b>Libellé :</b>
                            {{ detailCommande.libelle }}
                          </p>
                          <p>
                            <b>Date de la commande :</b>
                            {{ detailCommande.dateC }}
                          </p>
                          <p>
                            <b>Date de la livraison :</b>
                            {{ detailCommande.dateLivr }}
                          </p>
                          <p>
                            <b>Statut :</b>
                            <v-chip
                              text-color="white"
                              label
                              color="orange"
                              v-if="detailCommande.valid === 0"
                            >
                              EN ATENTE DE VALIDATION
                              <v-icon right></v-icon>
                            </v-chip>
                            <v-chip
                              text-color="white"
                              label
                              color="green"
                              v-if="detailCommande.valid === 1"
                            >
                              VALIDE
                              <v-icon right></v-icon>
                            </v-chip>
                            <v-chip
                              text-color="white"
                              label
                              color="red"
                              v-if="detailCommande.valid === 2"
                            >
                              REJETE
                              <v-icon right></v-icon>
                            </v-chip>
                          </p>
                        </v-flex>
                        <v-flex md6>
                          <p>
                            <b>Etat de la livraison :</b>
                            <v-chip
                              text-color="white"
                              label
                              color="red"
                              v-if="detailCommande.etat === false"
                            >
                              NON LIVRE
                              <v-icon right></v-icon>
                            </v-chip>
                            <v-chip
                              text-color="white"
                              label
                              color="green"
                              v-if="detailCommande.etat == true"
                            >
                              LIVRE EN TOTALITE
                              <v-icon right></v-icon>
                            </v-chip>
                          </p>
                          <p>
                            <b>Etat de la facture :</b>
                            <v-chip
                              text-color="white"
                              label
                              color="orange"
                              v-if="detailCommande.factureValide === 0"
                            >
                              EN ATENTE DE VALIDATION
                              <v-icon right></v-icon>
                            </v-chip>
                            <v-chip
                              text-color="white"
                              label
                              color="green"
                              v-if="detailCommande.factureValide === 1"
                            >
                              FACTURE VALIDE
                              <v-icon right></v-icon>
                            </v-chip>
                            <v-chip
                              text-color="white"
                              label
                              color="red"
                              v-if="detailCommande.factureValide === 2"
                            >
                              FACTURE REJETE
                              <v-icon right></v-icon>
                            </v-chip>
                          </p>
                          <p>
                            <b>Fournisseur :</b>
                            {{ detailCommande.fournisseurNom }}
                          </p>
                          <p>
                            <b>Date d'enregistrement :</b>
                            {{ detailCommande.created }}
                          </p>
                          <p>
                            <b>Date de modification :</b>
                            {{ detailCommande.modified }}
                          </p>
                        </v-flex>
                      </v-layout>
                    </div>
                  </el-row>
                </div>
              </el-card>
            </el-row>

            <!-- LISTE DES LIGNES -->
            <p align="center">
              <v-chip
                text-color="white"
                label
                color="primary"
                style="font-size:22px; width: 100%"
              >
                TOUTS LES PRODUITS DEMANDE
                <v-icon right>shopping_cart</v-icon>
              </v-chip>
            </p>
            <el-row :gutter="20" style="padding:10px;">
              <el-card class="box-card">
                <div class="grid-content" style="padding:3px;">
                  <el-row>
                    <el-table
                      :data="detailCommande.option"
                      height="250"
                      style="width: 100%"
                    >
                      <el-table-column
                        prop="produit"
                        label="Désignation"
                      ></el-table-column>
                      <el-table-column
                        prop="qte"
                        label="Quantité"
                      ></el-table-column>
                    </el-table>
                  </el-row>
                </div>
              </el-card>
            </el-row>
          </v-container>

          <v-tooltip top>
            <v-btn
              slot="activator"
              icons
              color="orange"
              @click.stop="dialogShowCommande = false"
              dark
            >
              Fermer
              <v-icon right>close</v-icon> </v-btn
            >Fermer
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              slot="activator"
              icons
              color="primary"
              @click.stop="editCommande(detailCommande)"
              dark
            >
              Modifer
              <v-icon right>edit</v-icon> </v-btn
            >Modifer
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              slot="activator"
              icons
              color="orange"
              @click.stop="imprimerCommande(detailCommande)"
              dark
            >
              Imprimer
              <v-icon right>print</v-icon> </v-btn
            >Imprimer
          </v-tooltip>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DE PROJET -->
    <v-dialog
      persistent
      v-model="form.etat"
      max-width="80%"
      :overlay="true"
      scrollable
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span>{{ texteP }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="form.etat = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form
            v-model="valid"
            ref="formProjet"
            lazy-validation
            id="formProjet"
          >
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip
                  text-color="white"
                  label
                  color="primary"
                  style="width:100%"
                  >Détails concernant le projet</v-chip
                >
              </p>

              <v-layout row>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Nom du projet</span>
                    <el-input
                      name="libelle"
                      placeholder="Nom du projet"
                      v-model="form.libelle"
                    ></el-input>
                  </div>
                </v-flex>

                <!--<v-flex md4>-->
                <!--<div class="block">-->
                <!--<span class="demonstration">Type de Projet</span>-->
                <!--<el-select-->
                <!--filterable-->
                <!--@change="loadProduitBudget()"-->
                <!--v-model="form.type"-->
                <!--placeholder="Type de Projet"-->
                <!--style="width:100%"-->
                <!--&gt;-->
                <!--<el-option-->
                <!--v-for="item in listTypeProjet"-->
                <!--:key="item.id"-->
                <!--:label="item.libelle"-->
                <!--:value="item.id"-->
                <!--&gt;</el-option>-->
                <!--</el-select>-->
                <!--</div>-->
                <!--</v-flex>-->

                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Situation géographique</span>
                    <el-input
                      name="adresse"
                      placeholder="Situation géographique"
                      v-model="form.adresse"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Date de début *</span>
                    <el-date-picker
                      format="dd-MM-yyyy"
                      name="dateD"
                      value-format="dd-MM-yyyy"
                      v-model="dateD"
                      type="date"
                      placeholder="Date de début"
                      style="width:100%"
                    ></el-date-picker>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Date de fin *</span>
                    <el-date-picker
                      name="dateF"
                      format="dd-MM-yyyy"
                      value-format="dd-MM-yyyy"
                      v-model="dateF"
                      type="date"
                      placeholder="Date de fin"
                      style="width:100%"
                    ></el-date-picker>
                  </div>
                </v-flex>

                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Prix du marché</span>
                    <el-input-number
                      :min="1"
                      placeholder="Prix du marché"
                      v-model="form.prix"
                      style="width:100%"
                      :readonly="false"
                    ></el-input-number>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Description du projet</span>
                    <el-input
                      type="textarea"
                      name="description"
                      placeholder="Description du projet"
                      v-model="form.description"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <p align="center">
                <v-chip
                  text-color="white"
                  label
                  color="primary"
                  style="width: 100%"
                  >Poste de responsabilité</v-chip
                >
              </p>

              <v-layout row>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Responsable du projet</span>
                    <el-select
                      filterable
                      v-model="form.chef"
                      placeholder="Responsable du projet"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in users"
                        :key="item.id"
                        :label="item.nom"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Architect</span>
                    <el-select
                      filterable
                      v-model="form.architect"
                      placeholder="Architect"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in users"
                        :key="item.id"
                        :label="item.nom"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Responsable étude</span>
                    <el-select
                      filterable
                      v-model="form.chefEtude"
                      placeholder="Responsable étude"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in users"
                        :key="item.id"
                        :label="item.nom"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Responsable contrôle</span>
                    <el-select
                      filterable
                      v-model="form.chefControle"
                      placeholder="Responsable contrôle"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in users"
                        :key="item.id"
                        :label="item.nom"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </v-flex>

                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Maître d'ouvrage *</span>
                    <el-select
                      filterable
                      v-model="form.maitre_ouvrage"
                      placeholder="Maître d'ouvrage"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listClient"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Participants</span>
                    <el-select
                      filterable
                      multiple
                      v-model="selectUsers"
                      placeholder="Participants"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in users"
                        :key="item.id"
                        :label="item.nom"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>

              <p align="center">
                <v-chip
                  text-color="white"
                  label
                  color="primary"
                  style="width: 100%"
                  >Localisation du projet</v-chip
                >
              </p>

              <v-layout row>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Latitude *</span>
                    <el-input
                      type="number"
                      value="latitude"
                      name="latitude"
                      placeholder="Latitude"
                      v-model="latitude"
                    ></el-input>
                  </div>
                </v-flex>

                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Longitude *</span>
                    <el-input
                      type="number"
                      value="Longitude"
                      name="longitude"
                      placeholder="Longitude"
                      v-model="longitude"
                    ></el-input>
                  </div>
                </v-flex>

                <v-flex md4>
                  <div class="block">
                    <span class="demonstration"></span>
                    <v-tooltip top>
                      <v-btn
                        @click="mapGoogle()"
                        dark
                        slot="activator"
                        color="info"
                        >Google Map</v-btn
                      >
                      <span
                        >Cliquez pour rechercher les coordonnees d'un lieu</span
                      >
                    </v-tooltip>
                  </div>
                </v-flex>
              </v-layout>

              <p align="center">
                <v-chip
                  text-color="white"
                  label
                  color="primary"
                  style="width: 100%"
                  >Autre détails concernant le projet</v-chip
                >
              </p>

              <v-layout row>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Banque affiliée *</span>
                    <el-select v-model="selectBanques" filterable  multiple placeholder="Banque affiliée" style="width:100%">
                          <el-option v-for="item in listBanque" :key="item.id" :label="item.libelle" :value="item.id">
                          </el-option>
                      </el-select>
                    <!-- <el-select
                      filterable
                      v-model="form.banque"
                      placeholder="Caisse affiliée"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listBanque"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      ></el-option>
                    </el-select> -->
                  </div>
                </v-flex>

                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Caisse affiliée *</span>
                    <el-select
                      filterable
                      v-model="form.caisse"
                      placeholder="Caisse affiliée"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listCaisse"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </v-flex>

                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Nombre d'heure de travail</span>
                    <el-input
                      type="number"
                      :min="1"
                      :max="24"
                      name="nbrHeure"
                      placeholder="Nombre d'heure de travail"
                      v-model="form.nbrHeure"
                    ></el-input>
                  </div>
                </v-flex>

                <v-flex md3>
                  <a :href="logoProjet" target="_blank">
                    <v-avatar
                      :tile="true"
                      size="140px"
                      height="120px"
                      color="grey lighten-4"
                    >
                      <img :src="logoProjet" alt="avatar"/></v-avatar
                    ><br />
                  </a>
                  <input
                    name="fileProj"
                    type="file"
                    style="display:none"
                    ref="fileLogo"
                    accept="image/*"
                    @change="onFileImageLogoPicked"
                  />
                  <v-btn
                    color="primary"
                    class="white--text"
                    required
                    @click.native="$refs.fileLogo.click()"
                    >Photo <v-icon right dark>cloud_upload</v-icon></v-btn
                  ><br />
                  <!-- <div class="font-weight-thin" >Fichier au format (JPEG,PNG,PDF) avec une taille de 1048 ko maximale</div> -->
                </v-flex>
              </v-layout>

              <br />

              <v-btn color="orange" @click.stop="form.etat = false" dark>
                Annuler
                <v-icon right>close</v-icon>
              </v-btn>
              <v-btn icons color="primary" @click="submit()" dark>
                Enregistrer
                <v-icon right>save</v-icon>
              </v-btn>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DE CHANTIER -->
    <v-dialog
      v-model="dialogPlan"
      max-width="80%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span v-if="dialogEdit != true"
              >Ajouter de nouveau chantier pour le projet
              {{ detailProjet.ref }} / {{ detailProjet.libelle }}</span
            >
            <span v-if="dialogEdit"
              >Modifier le chantier {{ chantierCourant.libelle }}</span
            >
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogPlan = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form v-model="valid" ref="formPlan" lazy-validation id="formPlan">
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip
                  text-color="white"
                  label
                  color="primary"
                  style="font-size:22px; width:100%"
                >
                  Détails le projet {{ detailProjet.ref }} /
                  {{ projetCourant.libelle }}
                  <v-icon right>terrain</v-icon>
                </v-chip>
              </p>

              <v-layout row>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Projet concerné</span>
                    <el-input
                      style="font-size:22px"
                      :value="projetCourant.libelle"
                      v-model="projetCourant.libelle"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3 v-if="projetCourant.type != ''">
                  <div class="block">
                    <span class="demonstration">Type de projet</span>
                    <el-input
                      style="font-size:22px"
                      :value="projetCourant.type"
                      v-model="projetCourant.type"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Date de début *</span>
                    <el-input
                      style="font-size:22px"
                      :value="projetCourant.dateD"
                      v-model="projetCourant.dateD"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Date de fin *</span>
                    <el-input
                      style="font-size:22px"
                      :value="projetCourant.dateF"
                      v-model="projetCourant.dateF"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md2>
                  <div class="block">
                    <span class="demonstration"></span>
                    <v-tooltip top>
                      <v-btn
                        @click="mapGoogle()"
                        dark
                        slot="activator"
                        color="info"
                        >Google Map</v-btn
                      >
                      <span
                        >Cliquez pour rechercher les coordonnees d'un lieu</span
                      >
                    </v-tooltip>
                  </div>
                </v-flex>

                <v-flex md4>
                  <a :href="logoChantier" target="_blank">
                    <v-avatar
                      :tile="true"
                      size="140px"
                      height="120px"
                      color="grey lighten-4"
                    >
                      <img :src="logoChantier" alt="avatar"/></v-avatar
                    ><br />
                  </a>
                  <input
                    name="photo"
                    type="file"
                    style="display:none"
                    ref="fileChantier"
                    accept="image/*"
                    @change="onFileImageChantPicked"
                  />
                  <v-btn
                    color="primary"
                    class="white--text"
                    required
                    @click.native="$refs.fileChantier.click()"
                    >Photo <v-icon right dark>cloud_upload</v-icon></v-btn
                  ><br />
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Latitude *</span>
                    <el-input
                      type="number"
                      value="latitude"
                      name="latitude"
                      placeholder="Latitude"
                      v-model="chantier.latitude"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Longitude *</span>
                    <el-input
                      type="number"
                      value="Longitude"
                      name="longitude"
                      placeholder="Longitude"
                      v-model="chantier.longitude"
                      style="width: 100%"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Libellé *</span>
                    <el-input
                      value="libelle"
                      name="libelle"
                      placeholder="Libellé"
                      v-model="chantier.libelle"
                      style="width: 100%"
                    ></el-input>
                  </div>
                </v-flex>

                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Type de Chantier *</span>
                    <el-input v-if="dialogEdit"
                      style="font-size:22px"
                      :value="chantier.typeLibelle"
                      disabled
                    ></el-input>
                    <el-select v-if="!dialogEdit"
                     
                      filterable
                      @change="loadProduitBudget()"
                      v-model="chantier.type"
                      placeholder="Type de Projet"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listTypeProjet"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md3 v-show="false">
                  <div class="block">
                    <span class="demonstration">Montant du marché *</span>
                    <el-input
                      type="number"
                      :min="0"
                      value="montant"
                      name="montant"
                      placeholder="Montant estimatif"
                      v-model="chantier.montant"
                      style="width: 100%"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Date de début *</span>
                    <el-date-picker
                      name="dateD"
                      id="date3"
                      format="dd-MM-yyyy"
                      value-format="dd-MM-yyyy"
                      v-model="chantier.dateD"
                      type="date"
                      placeholder="Date de début"
                      style="width: 100%"
                    ></el-date-picker>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Date de fin *</span>
                    <el-date-picker
                      name="dateF"
                      id="date4"
                      format="dd-MM-yyyy"
                      value-format="dd-MM-yyyy"
                      v-model="chantier.dateF"
                      type="date"
                      placeholder="Date de fin"
                      style="width: 100%"
                    ></el-date-picker>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Chef de chantier *</span>
                    <el-select
                      clearable
                      multiple
                      filterable
                      v-model="chantier.idChef"
                      placeholder="Chef de chantier"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in users"
                        :key="item.id"
                        :label="item.nom"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Sous-traiter ?</span>
                    <el-select
                      v-model="chantier.soutraite"
                      placeholder="Soutraitance"
                      @change="handleChangeSoustraitant"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in etatSoutraitance"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md3 v-if="chantier.soutraite == 1">
                  <div class="block">
                    <span class="demonstration">Sous-traitant</span>
                    <el-select
                      filterable
                      v-model="chantier.prestataire"
                      placeholder="Prestataire"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listPrestataire"
                        :key="item.idPres"
                        :label="item.libelle"
                        :value="item.idPres"
                      ></el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md3 v-show="chantier.soutraite == 1">
                  <div class="block">
                    <span class="demonstration">Montant sous traitance *</span>
                    <el-input
                      type="number"
                      name="montantSoustraitance"
                      placeholder="Montant sous traitance"
                      v-model="chantier.montantSoustraitance"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3 v-show="idChantMod">
                  <div class="block">
                    <span class="demonstration">Etat du chantier</span>
                    <el-select
                      v-model="chantier.etat"
                      placeholder="Etat du chantier "
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listEtat"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>
              <br />

              <p align="center" v-if="dialogEdit">
                <v-chip
                  outline
                  text-color="green"
                  label
                  color="green"
                  style="font-size:22px; width:100%"
                  >LISTE DES TRAVAUX CONCERNANT CE CHANTIER</v-chip
                >
              </p>
              <!-- <el-row :gutter="20"> -->
              <div class="grid-content" style=" padding: 3px" v-if="dialogEdit">
                <el-row>
                  <el-card class="box-card">
                    <div>
                      <data-tables
                        ref="multipleTable"
                        :data="travauxCourant"
                        :default-sort="{ prop: 'id', order: 'descending' }"
                        stripe
                        border
                        height="350"
                        style="width: 100%"
                      >
                        <el-table-column
                          prop="ref"
                          label="Taches"
                          width="280"
                          fixed
                        >
                          <template slot-scope="scope">
                            <v-chip text-color="white" label color="primary">{{
                              scope.row.libelle
                            }}</v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="etat"
                          label="Date de debut"
                          width="220"
                        >
                          <template slot-scope="scope">
                            <v-chip text-color="white" label color="red">{{
                              scope.row.dateDebut
                            }}</v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="montant"
                          label="Date de fin"
                          width="240"
                        >
                          <template slot-scope="scope">
                            <v-chip
                              text-color="white"
                              label
                              color="secondary"
                              >{{ scope.row.dateFin }}</v-chip
                            >
                          </template>
                        </el-table-column>
                        <el-table-column prop="date" label="Durée" width="240">
                          <template slot-scope="scope">
                            <v-chip text-color="white" label color="secondary"
                              >{{ scope.row.duree }} Jours</v-chip
                            >
                          </template>
                        </el-table-column>
                        <el-table-column label="Actions" width="140">
                          <template slot-scope="scope">
                            <v-btn
                              icons
                              color="primary"
                              @click="editTache(scope.row)"
                              fab
                              dark
                              small
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                           </template>
                        </el-table-column>
                      </data-tables>
                    </div>
                  </el-card>
                </el-row>
              </div>
              <!-- </el-row> -->

              <v-btn @click="dialogPlan = false" color="orange" dark>
                Annuler
                <v-icon right>close</v-icon>
              </v-btn>
              <v-btn icons color="primary"   :disabled="loading" @click="submitPlan()">
                Enregistrer
                <v-icon right>save</v-icon>
              </v-btn>
            </v-container>
          </v-form>
          <div style="flex: 1 1 auto;"></div>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT LES TRAVAUX -->
    <v-dialog
      v-model="dialogTravaux"
      transition="dialog-bottom-transition"
      scrollable
      :loading="loading"
      fullscreen
      hide-overlay
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span
              >Ajouter de nouveaux travaux sur le chantier
              {{ detailPlanifCourant.libelle }} pour le projet
              {{ detailPlanifCourant.projet }}</span
            >
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogTravaux = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form
            v-model="valid"
            ref="formTravaux"
            lazy-validation
            id="formTravaux"
          >
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip
                  text-color="white"
                  label
                  color="primary"
                  style="font-size:22px; width:100%"
                >
                  Détails du chantier {{ detailPlanifCourant.libelle }}
                  <v-icon right>terrain</v-icon>
                </v-chip>

                <v-chip
                  v-if="chantierCourant.soutraite == true"
                  text-color="white"
                  label
                  color="orange"
                  style="font-size:22px; width:100%"
                  >Le projet est sous-traiter par le
                  {{ chantierCourant.fournisseur }} ce qui signifie que tous les
                  travaux qui en découllent seront également soutraité</v-chip
                >
              </p>

              <v-layout row>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Projet concerné</span>
                    <el-input
                      style="font-size:22px"
                      :value="detailPlanifCourant.projet"
                      v-model="detailPlanifCourant.projet"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Chef de projet</span>
                    <el-input
                      style="font-size:22px"
                      :value="detailPlanifCourant.chefPrj"
                      v-model="detailPlanifCourant.chefPrj"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Date de début</span>
                    <el-input
                      style="font-size:22px"
                      :value="detailPlanifCourant.dateDbtProj"
                      v-model="detailPlanifCourant.dateDbtProj"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Date de fin</span>
                    <el-input
                      style="font-size:22px"
                      :value="detailPlanifCourant.dateFinProj"
                      v-model="detailPlanifCourant.dateFinProj"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Chantier concerné</span>
                    <el-input
                      style="font-size:22px"
                      :value="detailPlanifCourant.libelle"
                      v-model="detailPlanifCourant.libelle"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Chef de chantier</span>
                    <el-input
                      style="font-size:22px"
                      :value="detailPlanifCourant.chef"
                      v-model="detailPlanifCourant.chef"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Date de début</span>
                    <el-input
                      style="font-size:22px"
                      :value="detailPlanifCourant.dateD"
                      v-model="detailPlanifCourant.dateD"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Date de fin</span>
                    <el-input
                      style="font-size:22px"
                      :value="detailPlanifCourant.dateF"
                      v-model="detailPlanifCourant.dateF"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Soustraitance</span>
                    <el-input
                      style="font-size:22px"
                      :value="detailPlanifCourant.soutraiteLibelle"
                      v-model="detailPlanifCourant.soutraiteLibelle"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Sous-traitant</span>
                    <el-input
                      style="font-size:22px"
                      :value="detailPlanifCourant.fournisseur"
                      v-model="detailPlanifCourant.fournisseur"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Durée prévue (Jours)</span>
                    <el-input
                      style="font-size:22px"
                      :value="detailPlanifCourant.dureeJ"
                      v-model="detailPlanifCourant.dureeJ"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Montant du marché ()</span>
                    <el-input
                      style="font-size:22px"
                      :value="detailPlanifCourant.montantNbr"
                      v-model="detailPlanifCourant.montantNbr"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <p align="center">
                <v-chip
                  text-color="white"
                  label
                  color="primary"
                  style="font-size:22px; width:100%"
                >
                  Détails concernant les travaux
                  <v-icon right>filter_2</v-icon>
                </v-chip>
              </p>

              <v-stepper v-model="etape">
                <v-stepper-header>
                  <v-stepper-step step="1" :complete="etape > 1"
                    >Détail des travaux à effectuer</v-stepper-step
                  >
                  <v-divider></v-divider>
                  <v-stepper-step step="2" :complete="etape > 2"
                    >Tâches à éffectuer</v-stepper-step
                  >
                </v-stepper-header>
                
                <v-stepper-items>
                  <v-stepper-content step="1">
                    <v-layout row>
                      <v-flex md3>
                        <div class="block">

                          <span class="demonstration"
                            >Travaux concerné par le projet</span
                          >

                          <el-select v-show="!readBtnModTrx"
                            clearable
                            :disabled="readBtnModTrx"
                            v-on:change="loadTache()"
                            filterable
                            v-model="selectTravaux"
                            placeholder="Travaux concerné par le projet"
                            style="width:100%"
                          >
                            <el-option
                              v-for="item in listTravauxProjet"
                              :key="item.id"
                              :label="item.libelle"
                              :value="item.id"
                            ></el-option>
                          </el-select>

                           <el-input v-show="readBtnModTrx"
                            type="text"
                            name="typeTravaux"
                            :disabled="readBtnModTrx"
                            placeholder="Travaux concerné par le projet"
                            v-model=" this.travauxCourant.libelle"
                            style="width:100%"
                          ></el-input>

                        </div>
                      </v-flex>
                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">Date de début</span>
                          <el-date-picker
                            name="dateD"
                            format="dd-MM-yyyy"
                            value-format="dd-MM-yyyy"
                            v-model="travauxCourant.dateDebut"
                            type="date"
                            placeholder="Date de fin"
                            style="width:100%"
                          ></el-date-picker>
                        </div>
                      </v-flex>
                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">Date de fin</span>
                          <el-date-picker
                            name="dateF"
                            id="dateFTrx"
                            format="dd-MM-yyyy"
                            value-format="dd-MM-yyyy"
                            v-model="travauxCourant.dateFin"
                            placeholder="Date de fin"
                            type="date"
                            required
                            style="width: 100%"
                          ></el-date-picker>
                        </div>
                      </v-flex>
                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">Chef des travaux</span>
                          <el-select
                            filterable
                            v-model="selectChefTravaux"
                            placeholder="Chef des travaux"
                            style="width:100%"
                          >
                            <el-option
                              v-for="item in users"
                              :key="item.id"
                              :label="item.nom"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </div>
                      </v-flex>
                    </v-layout>

                    <v-layout
                      v-if="
                        chantierCourant.soutraite == 0 || dialogEdit == true
                      "
                      row
                    >
                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">Sous-traiter ?</span>
                          <el-select
                            filterable
                            v-model="selectSoustraite"
                            placeholder="Sous-traiter"
                            style="width:100%"
                          >
                            <el-option
                              v-for="item in etatSoutraitance"
                              :key="item.value"
                              :label="item.text"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </div>
                      </v-flex>
                      <v-flex md3 v-if="selectSoustraite == 1">
                        <div class="block">
                          <span class="demonstration">Sous-traitant</span>
                          <el-select
                            filterable
                            v-model="selectPrestataire"
                            placeholder="Sous-traitant"
                            style="width:100%"
                          >
                            <el-option
                              v-for="item in listPrestataire"
                              :key="item.idPres"
                              :label="item.libelle"
                              :value="item.idPres"
                            ></el-option>
                          </el-select>
                        </div>
                      </v-flex>

                      <v-flex md3 v-if="selectSoustraite == 1">
                        <div class="block">
                          <span class="demonstration"
                            >Montant sous traitance *</span
                          >
                          <el-input
                            type="number"
                            name="montantSoustraitance"
                            placeholder="Montant sous traitance"
                            v-model="montantSoustraitance"
                            style="width:100%"
                          ></el-input>
                        </div>
                      </v-flex>

                      <v-flex md3 v-show="false">
                        <div class="block">
                          <span class="demonstration">Montant du marché *</span>
                          <el-input
                            type="number"
                            name="montantEstime"
                            placeholder="Montant estimatif"
                            v-model="montantEstime"
                            style="width:100%"
                          ></el-input>
                        </div>
                      </v-flex>
                    </v-layout>

                    <v-layout v-if="chantierCourant.soutraite == 1" row>
                      <v-flex md2>
                        <div class="block">
                          <span class="demonstration">Soutraitance</span>
                          <el-input
                            style="font-size:22px"
                            :value="chantierCourant.soutraiteLibelle"
                            v-model="chantierCourant.soutraiteLibelle"
                            disabled
                          ></el-input>
                        </div>
                      </v-flex>

                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">Sous-traitant</span>
                          <el-input
                            style="font-size:22px"
                            :value="chantierCourant.fournisseur"
                            v-model="chantierCourant.fournisseur"
                            disabled
                          ></el-input>
                        </div>
                      </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex md12>
                        <div class="block">
                          <span class="demonstration">Description</span>
                          <el-input
                            name="description"
                            type="textarea"
                            :rows="5"
                            v-model="descriptionTravaux"
                            style="width: 100%"
                          ></el-input>
                        </div>
                      </v-flex>
                    </v-layout>
                    <br />
                    <v-layout>
                      <v-spacer></v-spacer>
                      <v-btn
                        icons
                        color="orange"
                        @click="dialogTravaux = false"
                        dark
                      >
                        Annuler
                        <v-icon right>close</v-icon>
                      </v-btn>
                      <v-btn
                        icons
                        :disabled="!disabledBtnContTrx"
                        color="primary"
                        @click="
                          calculMntTache();
                          etape += 1;
                        "
                      >
                        Continuer
                        <v-icon right>keyboard_arrow_right</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-stepper-content>

                  <v-stepper-content step="2">
                    <v-layout row>
                      <v-flex md6>
                        <div class="block">
                          <span class="demonstration">Début des travaux</span>
                          <el-input
                            value-format="dd-MM-yyyy"
                            format="dd-MM-yyyy"
                            v-model="travauxCourant.dateDebut"
                            placeholder="Date de début"
                            style="width: 100%; font-size:22px"
                            :readonly="true"
                          ></el-input>
                        </div>
                      </v-flex>
                      <v-flex md6>
                        <div class="block">
                          <span class="demonstration">Fin des travaux</span>
                          <el-input
                            value-format="dd-MM-yyyy"
                            format="dd-MM-yyyy"
                            v-model="travauxCourant.dateFin"
                            placeholder="Date de fin"
                            style="width: 100%; font-size:22px"
                            :readonly="true"
                          ></el-input>
                        </div>
                      </v-flex>
                    </v-layout>

                    <p align="center">
                      <v-chip
                        text-color="white"
                        label
                        color="primary"
                        style="font-size:22px; width:100%"
                      >
                        Ajouter des tâches
                        <v-icon right>filter_2</v-icon>
                      </v-chip>
                    </p>

                    <v-layout row>
                      <v-flex xs12>
                        <v-chip
                          style="font-size:20px"
                          label
                          outline
                          color="green"
                        >
                          <b
                            >Total (HT):
                            {{ new Intl.NumberFormat().format(totalHT) }}</b
                          >
                        </v-chip>
                      </v-flex>
                    </v-layout>

                    <v-layout
                      row
                      v-for="(optionT, index) in optionTache"
                      :key="optionT.key"
                    >
                      <v-flex md1 v-show="readBtnModTrx">
                        <div class="block">
                          <span class="demonstration">Ordre</span>
                          <el-input
                            v-model="optionT.ordre"
                            :prop="'optionTache.' + index + '.ordre'"
                            :readonly="!readBtnModTrx"
                          ></el-input>
                        </div>
                      </v-flex>

                      <v-flex md2>
                        <div class="block">
                          <span class="demonstration">Tâche</span>
                          <el-input
                            v-model="optionT.libelle"
                            :prop="'optionTache.' + index + '.tache'"
                            :readonly="!readBtnModTrx"
                          ></el-input>
                        </div>
                      </v-flex>

                      <v-flex md1>
                        <div class="block">
                          <span class="demonstration">Unité</span>
                          <el-input
                            :min="0"
                            value="unite"
                            v-model="optionT.unite"
                            :prop="'optionTache.' + index + '.unite'"
                            placeholder="Unité"
                            style="width:100%"
                            :readonly="!readBtnModTrx"
                          ></el-input>
                        </div>
                      </v-flex>

                      <v-flex md2>
                        <div class="block">
                          <span class="demonstration">Date de début  *</span>
                          <el-date-picker
                            id="dateD"
                            value-format="dd-MM-yyyy"
                            format="dd-MM-yyyy"
                            v-model="optionT.dateDebut"
                            :prop="'optionTache.' + index + '.dateDebut'"
                            placeholder="Date de début"
                            type="date"
                            required
                            style="width: 100%"
                          ></el-date-picker>
                        </div>
                      </v-flex>

                      <v-flex md2>
                        <div class="block">
                          <span class="demonstration">Date de fin  *</span>
                          <el-date-picker
                            id="dateF"
                            value-format="dd-MM-yyyy"
                            format="dd-MM-yyyy"
                            v-model="optionT.dateFin"
                            :prop="'optionTache.' + index + '.dateFin'"
                            placeholder="Date de fin"
                            type="date"
                            required
                            style="width: 100%"
                          ></el-date-picker>
                        </div>
                      </v-flex>
                      <v-flex md1>
                        <div class="block">
                          <span class="demonstration">Prix</span>
                          <el-input
                            :min="0"
                            value="prix HT"
                            v-model="optionT.prix"
                            :prop="'optionTache.' + index + '.prix'"
                            placeholder="Prix"
                            style="width:100%"
                            :readonly="!readBtnModTrx"
                          ></el-input>
                        </div>
                      </v-flex>

                      <v-flex md2>
                        <div class="block">
                          <span class="demonstration">Quantité *</span>
                          <el-input-number
                            @change="calculTotalTache(index)"
                            :min="1"
                            value="qte"
                            v-model="optionT.qte"
                            :prop="'optionTache.' + index + '.qte'"
                            placeholder="Quantité"
                            style="width:100%"
                            :readonly="!readBtnModTrx"
                          ></el-input-number>
                        </div>
                      </v-flex>

                      <v-flex md1 class="mr-4">
                        <div class="block">
                          <span class="demonstration">Total (HT)</span>
                          <p>
                            <v-chip
                              style="font-size:20px"
                              :prop="'optionTache.' + index + '.total'"
                              label
                              outline
                              color="primary"
                            >
                              <b>{{
                                new Intl.NumberFormat().format(optionT.total)
                              }}</b>
                            </v-chip>
                          </p>
                        </div>
                      </v-flex>

                      <v-flex md1 class="ml-4">
                        <v-tooltip top>
                          <v-btn
                            slot="activator"
                            @click.prevent="removeTache(optionT)"
                            fab
                            dark
                            small
                            color="red"
                          >
                            <v-icon dark>delete</v-icon> </v-btn
                          >Supprimer
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                    <v-layout row v-if="readBtnModTrx">
                        <v-flex xs12 class="text-xs-right">
                            <v-btn icons color="primary" @click="addTacheComm()" fab small dark> <v-icon>add</v-icon></v-btn>
                        </v-flex>
                    </v-layout>
                    <br />

                    <v-layout>
                      <v-btn
                        icons
                        color="orange"
                        @click="dialogTravaux = false"
                        dark
                      >
                        Annuler
                        <v-icon right>close</v-icon>
                      </v-btn>
                      <v-btn icons color="primary" @click="etape -= 1" dark>
                        <v-icon right>keyboard_arrow_left</v-icon>Précédent
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        v-if="dialogEdit !== true"
                        color="primary"
                         :disabled="loading"
                        @click="submitTravaux()"
                        dark
                      >
                        Enregistrer
                        <v-icon right>save</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="dialogEdit"
                        color="primary"
                        :disabled="loading"
                        @click="submitEditTravaux(travauxCourant.id)"
                        dark
                      >
                        Enregistrer
                        <v-icon right>save</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-container>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT COMMANDE -->
    <v-dialog
      v-model="dialogComm"
      max-width="90%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="indigo">
          <v-toolbar-title>
            <span v-if="dialogEdit !== true"
              >Recueille de besoin pour les travaux du chantier
              {{ travauxCourant.chantier }}</span
            >
            <span v-if="dialogEdit"
              >Modifier le recueille de besoin
              {{ commandeCourant.libelle }}</span
            >
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogComm = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container fluid grid-list-md>
            <p align="center">
              <v-chip
                v-if="dialogEdit !== true"
                text-color="white"
                label
                color="indigo"
                style="font-size:22px; width: 100%"
              >
                Recueillir les besoins pour la travaux
                {{ travauxCourant.libelle }}
                <v-icon right>shopping_cart</v-icon>
              </v-chip>
              <v-chip
                v-if="dialogEdit"
                text-color="white"
                label
                color="indigo"
                style="font-size:22px; width: 100%"
              >
                Modification du recueille de besoin
                {{ commandeCourant.libelle }}
                <v-icon right>shopping_cart</v-icon>
              </v-chip>
            </p>
            <el-form
              :model="FormComm"
              :rules="rulesComm"
              ref="formComm"
              class="demo-ruleForm"
              id="formComm"
            >
              <v-layout row>
                <v-flex md3 v-if="dialogEdit !== true">
                  <div class="block">
                    <span class="demonstration">Chantier concerné</span>
                    <el-input
                      style="font-size:22px"
                      :value="travauxCourant.chantier"
                      v-model="travauxCourant.chantier"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3 v-if="dialogEdit !== true">
                  <div class="block">
                    <span class="demonstration">Travaux</span>
                    <el-input
                      style="font-size:22px"
                      :value="travauxCourant.libelle"
                      v-model="travauxCourant.libelle"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3 v-if="dialogEdit !== true">
                  <div class="block">
                    <span class="demonstration">Durée (Jours)</span>
                    <el-input
                      style="font-size:22px"
                      :value="travauxCourant.duree"
                      v-model="travauxCourant.duree"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md6 v-if="dialogEdit">
                  <div class="block">
                    <span class="demonstration">Libellé</span>
                    <el-input
                      style="font-size:22px"
                      :value="commandeCourant.libelle"
                      v-model="commandeCourant.libelle"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Fournisseur</span>
                    <el-select
                      v-model="FormComm.fournisseur"
                      placeholder="Prestataire"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listPrestataire"
                        :key="item.idPres"
                        :label="item.libelle"
                        :value="item.idPres"
                      ></el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md11>
                  <p align="center">
                    <v-chip
                      text-color="white"
                      label
                      color="indigo"
                      style="font-size:22px; width:100%"
                    >
                      Ajouter des lignes des besoins
                      <v-icon right>shopping_cart</v-icon>
                    </v-chip>
                  </p>
                </v-flex>
                <v-flex md1>
                  <v-btn
                    icons
                    color="primary"
                    @click="addOptionComm"
                    fab
                    small
                    dark
                  >
                    <v-icon>add</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>

              <v-layout
                row
                prop="optionCommande"
                v-for="(optionC) in FormComm.optionCommande"
                :key="optionC.key"
              >
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Produit</span>
                    <el-form-item>
                      <el-autocomplete
                        v-model="optionC.produit"
                        :fetch-suggestions="loadProduit"
                        name="produit"
                        placeholder="Produit"
                        required
                        style="width: 100%"
                      ></el-autocomplete>
                    </el-form-item>
                  </div>
                </v-flex>
                <v-flex md5>
                  <div class="block">
                    <span class="demonstration">Quantité</span>
                    <el-form-item>
                      <el-input
                        type="number"
                        min="1"
                        v-model="optionC.qte"
                      ></el-input>
                    </el-form-item>
                  </div>
                </v-flex>
                <v-flex md1>
                  <v-tooltip top>
                    <v-btn
                      slot="activator"
                      @click.prevent="removeOptionComm(optionC)"
                      fab
                      dark
                      small
                      color="red"
                    >
                      <v-icon dark>delete</v-icon> </v-btn
                    >Supprimer
                  </v-tooltip>
                </v-flex>
              </v-layout>

              <v-btn color="orange" @click.stop="dialogComm = false" dark>
                Annuler
                <v-icon right>close</v-icon>
              </v-btn>
              <v-btn icons color="primary"  :disabled="loading"  @click="submitComm('formComm')" dark>
                Enregistrer
                <v-icon right>save</v-icon>
              </v-btn>
            </el-form>
          </v-container>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT PLANIFIER PRODUIT -->
    <v-dialog
      v-model="dialogPlanifProduit"
      max-width="90%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span
              >Planification des Besoins Matériels / Matériaux pour la tâche
              {{ tacheCourante.libelle }}</span
            >
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogPlanifProduit = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-layout row>
            <v-flex md3>
              <div class="block">
                <span class="demonstration">Date de début de la tâche</span>
                <el-input
                  style="font-size:22px"
                  :value="tacheCourante.dateD"
                  v-model="tacheCourante.dateD"
                  disabled
                ></el-input>
              </div>
            </v-flex>
            <v-flex md3> </v-flex>
            <v-flex md3>
              <div class="block">
                <span class="demonstration">Date de fin de la tâche</span>
                <el-input
                  style="font-size:22px"
                  :value="tacheCourante.dateF"
                  v-model="tacheCourante.dateF"
                  disabled
                ></el-input>
              </div>
            </v-flex>
          </v-layout>

          <v-container fluid grid-list-md>
            <v-form
              v-model="valid"
              ref="formPlanifProduit"
              lazy-validation
              id="formPlanifProduit"
            >

              <v-layout row mt-3 mb-1>
                <v-flex md12>
                  <h6>
                    Veuillez Sélectionner les besoins en Matériels, Matériaux ,
                    Véhicules et la tâche
                  </h6>
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>

              <v-layout row>
                <!-- ligne vehicule -->
                <v-flex md18>
                  <v-layout row>
                    <v-flex md4>
                      <div class="block">
                        <span class="demonstration">Tâches*</span>
                        <el-select
                          filterable
                          v-model="tacheS"
                          placeholder="Tache"
                          style="width:100%"
                        >
                          <el-option
                            v-for="item in listeTacheTrx"
                            :key="item.idOptTrx"
                            :label="item.libelle"
                            :value="item.idOptTrx"
                          ></el-option>
                        </el-select>
                      </div>
                    </v-flex>
                      <v-flex xs12 class="text-xs-right">
                      <v-tooltip top>
                            <input
                              name="fileInputExcel"
                              type="file"
                              style="display:none"
                              ref="fileInputExcel"
                              accept="image/*"
                              v-on:change="onFileExcelPicked"
                            />
                            <v-btn
                                v-if="true"
                                slot="activator"
                                color="green"
                                @click.stop="$refs.fileInputExcel.click()"
                                dark
                            >
                                Importer
                                <v-icon right>file_download</v-icon>
                            </v-btn>Importer fichier excel
                      </v-tooltip>

                        <v-tooltip top>
                      <v-btn
                          v-if="true"
                          slot="activator"
                          color="orange"
                          @click.stop="dialogImport=true"
                          dark
                      >
                          Générer
                          <v-icon right>file_upload</v-icon>
                      </v-btn>Générer un modèle
                      </v-tooltip>
                  </v-flex>    
                  </v-layout>
                              
                    <v-flex>
                      <v-layout
                        row
                        v-for="(optionB, index) in optionVehicule"
                        :key="optionB.key"
                      >
                        <v-flex md5>
                          <div class="block">
                            <span class="demonstration">Vehicule/Engin *</span>
                            <el-autocomplete
                              @select="handleSelect"
                              clearable
                              v-model="optionB.value"
                              :fetch-suggestions="loadProdVehicule"
                              name="value"
                              placeholder="Produit"
                              :prop="'optionVehicule.' + index + '.value'"
                              required
                              style="width: 100%"
                            ></el-autocomplete>
                          </div>
                        </v-flex>
                        <v-flex md>
                          <div class="block">
                            <span class="demonstration">Quantité *</span>
                            <el-input
                              type="number"
                              :min="1"
                              value="qte"
                              :prop="'optionVehicule.' + index + '.qte'"
                              placeholder="Quantité"
                              v-model="optionB.qte"
                              style="width:100%"
                            ></el-input>
                          </div>
                        </v-flex>

                        <v-flex md3>
                          <div class="block">
                            <span class="demonstration">Priorité</span>*
                              <el-select
                                v-model="optionB.priorite"
                                 placeholder="Priorité"
                                :prop="'optionVehicule.' + index + '.priorite'"
                                :trigger-on-focus="true"
                              >
                                <el-option
                                  v-for="item in priorites"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
                                ></el-option>
                              </el-select>

                            <!-- <el-input
                              v-model="optionB.unite"
                              :prop="'optionVehicule.' + index + '.unite'"
                              required
                              placeholder="Unité"
                              :trigger-on-focus="true"
                              style="width: 100%"
                              :disabled="true"
                            ></el-input> -->
                          </div>
                        </v-flex>

                        <v-flex md6>
                          <div class="block">
                            <span class="demonstration">Période*</span>
                            <el-date-picker
                              style="width: 100%"
                              v-model="optionB.periode"
                              format="dd-MM-yyyy"
                              value-format="yyyy-MM-dd"
                              type="datetimerange"
                              range-separator="au"
                              start-placeholder="Début date"
                              end-placeholder="Fin date"
                            ></el-date-picker>
                          </div>
                        </v-flex>

                        <v-flex md1>
                          <v-tooltip top>
                            <v-btn
                              slot="activator"
                              @click.prevent="removeOptionBesoin(optionB)"
                              fab
                              dark
                              small
                              color="red"
                            >
                              <v-icon dark>delete</v-icon> </v-btn
                            >Supprimer
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex md1 class="text-xs-left">
                      <v-btn
                        icons
                        color="primary"
                        @click="addOptionV"
                        fab
                        small
                        dark
                      >
                        <v-icon>add</v-icon>
                      </v-btn>
                    </v-flex>
                  <v-layout row>
                    <v-flex md18>
                      <v-layout
                        row
                        v-for="(optionP,index) in optionProduit"
                        :key="optionP.key"
                      >
                        <v-flex md2>
                          <span class="demonstration">Type produit *</span>
                          <el-select
                            name="valeurSelect"
                            id="valeurSelect"
                            v-model="optionP.type"
                            filterable
                            v-on:change="loadTypeProduit(optionP.type)"
                            placeholder="Type produit"
                            style="width:100%"
                          >
                          <el-option v-for="item in listTypeRessource" :key="item.id" :label="item.libelle" :value="item.libelle">
                          </el-option>
                          </el-select>
                        </v-flex>
                        <v-flex md4>
                          <div class="block">
                            <span class="demonstration">Produit *</span>
                            <el-select
                              v-model="optionP.produit"
                              filterable
                              v-on:change="loadUniteProduit(optionP.produit)"
                              style="width:100%"
                            >
                              <el-option
                                v-for="item in listeProduitAffich"
                                :key="item.id"
                                :label="item.libelle"
                                :value="item.value"
                              ></el-option>
                            </el-select>
                          </div>
                        </v-flex>

                        <v-flex md2>
                          <div class="block">
                            <span class="demonstration">Quantité *</span>
                            <el-input
                              type="number"
                              min="1"
                              v-model="optionP.qte"
                            ></el-input>
                          </div>
                        </v-flex>
                         <v-flex md2>
                          <div class="block">
                            <span class="demonstration">Unité</span>
                         <el-select
                              name="valeurSelect"
                              id="valeurSelect"
                              v-model="optionP.unite"
                              :value="valeurUniteMateriel"
                              style="width:100%"
                            >
                              <el-option :value="valeurUniteMateriel"
                                >{{ valeurUniteMateriel }}
                              </el-option>
                            </el-select>
                            </div>
                        </v-flex>
                        <v-flex md2>
                          <div class="block">
                            <span class="demonstration">Priorité  *</span>
                              <el-select
                                v-model="optionP.priorite"
                                 placeholder="Priorité"
                                :prop="'optionVehicule.' + index + '.priorite'"
                                :trigger-on-focus="true"
                              >
                                <el-option
                                  v-for="item in priorites"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
                                ></el-option>
                              </el-select>
                          </div>
                        </v-flex>
                      <v-flex class="text-xs-right">
                          <v-tooltip top>
                            <v-btn
                              slot="activator"
                              @click.prevent="removeOptionP(optionP)"
                              fab
                              dark
                              small
                              color="red"
                            >
                              <v-icon dark>delete</v-icon> </v-btn
                            >Supprimer
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex md1 class="text-xs-left">
                      <v-btn
                        icons
                        color="primary"
                        @click="addOptionP"
                        fab
                        small
                        dark
                      >
                        <v-icon>add</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <!-- ligne produit -->
              </v-layout>

              <!-- ajouter planification -->
              <v-layout row mt-3 class="text-xs-right">
                <v-flex xs12>
                  <v-divider></v-divider>
                  <v-btn
                    color="grey"
                    @click.stop="dialogPlanifProduit = false"
                    dark
                  >
                    Annuler
                    <v-icon right>close</v-icon>
                  </v-btn>
                  <v-btn
                    icons
                    color="primary"
                     :disabled="loading"
                    @click="submitPlanifTacheProduit()"
                    dark
                  >
                    Enregistrer
                    <v-icon right>save</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT IMPORT PLANIFICATION -->
      <v-dialog
              v-model="showModalLoadPreparation"
              :overlay="true"
              scrollable
              persistent
              max-width="92%">
          <v-card>
              <v-toolbar dark color="primary">
                  <v-toolbar-title>Importation des ressources pour la planification de la tâche {{tacheCourante.libelle}} </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon dark @click="showModalLoadPreparation =false">
                      <v-icon>close</v-icon>
                  </v-btn>
              </v-toolbar>
              <v-card-text>
                  <v-layout row>
                      <v-flex>
                          <data-tables :data="lstPreparation" width="100%">
                              <el-table-column prop="tache" label="TACHES" width="500px">
                                  <template slot-scope="scope">
                                      <v-chip label text-color="white" color="primary">
                                          {{scope.row.tache}}
                                      </v-chip>
                                  </template>
                              </el-table-column>
                              <el-table-column prop="ressource" label="RESSOURCES" width="500px">
                                  <template slot-scope="scope">
                                      <v-chip label text-color="white" color="primary">
                                          {{scope.row.ressource}}
                                      </v-chip>
                                  </template>
                              </el-table-column>
                              <el-table-column prop="quantite" label="QUANTITE"  width="500px">
                                  <template slot-scope="scope">
                                      <v-chip label text-color="white" color="primary">
                                          {{scope.row.quantite}}
                                      </v-chip>
                                  </template>
                              </el-table-column>                            
                          </data-tables>
                      </v-flex>
                  </v-layout>
                    <v-btn @click="showModalLoadPreparation = false" color="orange" dark>
                      Annuler
                      <v-icon right>close</v-icon>
                    </v-btn>
                    <v-btn
                      icons
                      color="blue"
                      @click="saveListe()"
                      :disabled="loading"
                      dark
                    >
                      Enregistrer
                      <v-icon right>save</v-icon>
                    </v-btn>                 
              </v-card-text>
          </v-card>
      </v-dialog>

    <!-- MODAL IMPORTATION STOCK -->
    <v-dialog v-model="dialogImport" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-card-text text-xs-center>
          <h4 align="center">Nb: Le colonne 'TACHES' doit contenir uniquement les tâches à planifiées pour ce 'LOT'.</h4>
          <h4 align="center">La colonne 'RESSOURCE'  doit contenir uniquement les ressources qui figurent dans votre base de produit.</h4>        
          <p align="center">
            <v-btn @click.native="dialogImport = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
            <v-btn icons color="green" @click.stop="generateFileExcel()" dark>Généner <v-icon right>done</v-icon></v-btn>
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT EQUIPE -->
    <v-dialog
      v-model="dialogEquipe"
      max-width="90%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span v-if="dialogEdit !== true"
              >Définir les équipes en fonction des tâches
              {{ tacheCourant.libelle }}</span
            >
            <span v-if="dialogEdit"
              >Modifier le contrat de {{ equipeCourant.executant }}</span
            >
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogEquipe = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container fluid grid-list-md>
            <p align="center">
              <v-chip
                v-if="dialogEdit !== true"
                text-color="white"
                label
                color="primary"
                style="font-size:22px; width: 100%"
              >
                Attribuer des personnes à la tâche {{ tacheCourant.tache }}
                <v-icon right>person_add</v-icon>
              </v-chip>
              <v-chip
                v-if="dialogEdit"
                text-color="white"
                label
                color="primary"
                style="font-size:22px; width: 100%"
              >
                Modification du contrat de
                {{ equipeCourant.executant }} concernant la tâche
                {{ equipeCourant.tache }}
                <v-icon right>person_add</v-icon>
              </v-chip>
            </p>

            <v-layout row v-if="dialogEdit !== true">
              <v-flex md3>
                <div class="block">
                  <span class="demonstration">Tâche concerné</span>
                  <el-input
                    :value="tacheCourant.tacheLibelle"
                    v-model="tacheCourant.tacheLibelle"
                    disabled
                  ></el-input>
                </div>
              </v-flex>
              <v-flex md3>
                <div class="block">
                  <span class="demonstration">Travaux concerné</span>
                  <el-input
                    :value="tacheCourant.travaux"
                    v-model="tacheCourant.travaux"
                    disabled
                  ></el-input>
                </div>
              </v-flex>
              <v-flex md3>
                <div class="block">
                  <span class="demonstration">Date de début</span>
                  <el-input
                    style="font-size:22px"
                    :value="tacheCourant.dateDebut"
                    v-model="tacheCourant.dateDebut"
                    disabled
                  ></el-input>
                </div>
              </v-flex>
              <v-flex md3>
                <div class="block">
                  <span class="demonstration">Date de fin</span>
                  <el-input
                    style="font-size:22px"
                    :value="tacheCourant.dateFin"
                    v-model="tacheCourant.dateFin"
                    disabled
                  ></el-input>
                </div>
              </v-flex>
            </v-layout>

            <v-layout row v-if="dialogEdit !== true">
              <v-flex md3>
                <div class="block">
                  <span class="demonstration">Durée prévue (Jours)</span>
                  <el-input
                    :value="tacheCourant.duree"
                    v-model="tacheCourant.duree"
                    disabled
                  ></el-input>
                </div>
              </v-flex>
              <v-flex md3>
                <div class="block">
                  <span class="demonstration">Soustraitance</span>
                  <el-input
                    style="font-size:22px"
                    :value="tacheCourant.soutraiteLibelle"
                    v-model="tacheCourant.soutraiteLibelle"
                    disabled
                  ></el-input>
                </div>
              </v-flex>
              <v-flex md3>
                <div class="block">
                  <span class="demonstration">Sous-traitant</span>
                  <el-input
                    style="font-size:22px"
                    :value="tacheCourant.fournisseur"
                    v-model="tacheCourant.fournisseur"
                    disabled
                  ></el-input>
                </div>
              </v-flex>
            </v-layout>

            <v-layout v-if="dialogEdit !== true" row>
              <v-flex md11>
                <p align="center">
                  <v-chip
                    text-color="white"
                    label
                    color="primary"
                    style="font-size:22px; width:100%"
                  >
                    Ajouter des lignes
                    <v-icon right>person_add</v-icon>
                  </v-chip>
                  <!--<v-alert-->
                  <!--:value="true"-->
                  <!--type="warning">-->
                  <!--<v-icon right>report</v-icon> Attention ! Veuillez saisir  des dates comprises dans l'interval du {{tacheCourant.dateDebut}} au {{tacheCourant.dateFin }} .-->

                  <!--</v-alert>-->
                </p>
              </v-flex>

              <v-flex md1>
                <v-btn
                  icons
                  color="primary"
                  @click="addOptionEquipe"
                  fab
                  small
                  dark
                >
                  <v-icon>add</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>

            <v-form
              v-model="valid"
              ref="formEquipe"
              lazy-validation
              id="formEquipe"
            >
              <v-container fluid grid-list-md>
                <v-layout row>
                  <v-btn
                    color="primary"
                    class="white--text"
                    @click="showDialogAjoutOuvrier()"
                  >
                    Ressources techniques
                    <v-icon right dark>add</v-icon>
                  </v-btn>
                </v-layout>
                <v-layout
                  v-if="dialogEdit != true"
                  row
                  v-for="(optionE) in optionEquipe"
                  :key="optionE.key"
                >
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration">Type d'éxecutant</span>
                      <el-select
                        v-model="optionE.selectType"
                        placeholder="Type d'éxecutant"
                        style="width:100%"
                      >
                        <el-option
                          v-for="item in optionE.type"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                  </v-flex>
                  <v-flex md3 v-if="optionE.selectType === 1">
                    <div class="block">
                      <span class="demonstration">Fournisseur</span>
                      <el-select
                        clearable
                        v-model="optionE.fournisseur"
                        placeholder="Prestataire"
                        style="width:100%"
                      >
                        <el-option
                          v-for="item in listPrestataire"
                          :key="item.idPres"
                          :label="item.libelle"
                          :value="item.idPres"
                        ></el-option>
                      </el-select>
                    </div>
                  </v-flex>
                  <v-flex md3 v-if="optionE.selectType === 2">
                    <div class="block">
                      <span class="demonstration">Ouvrier/Manoeuvre</span>
                      <el-select
                        clearable
                        v-model="optionE.ouvrier"
                        placeholder="Ouvrier/Manoeuvre"
                        style="width:100%"
                      >
                        <el-option
                          v-for="item in listOuvrier"
                          :key="item.id"
                          :label="item.nom"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </div>
                  </v-flex>
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration">Durée</span>
                      <el-date-picker
                        name="duree"
                        range-separator="à"
                        format="dd-MM-yyyy"
                        value-format="dd-MM-yyyy"
                        v-model="optionE.duree"
                        type="daterange"
                        start-placeholder="Date de début"
                        end-placeholder="Date de fin"
                        required
                        style="width: 100%"
                      ></el-date-picker>
                    </div>
                  </v-flex>
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration"
                        >Montant journalier(Ouvrier) /
                        Forfait(Prestataire)</span
                      >
                      <el-input
                        type="number"
                        required
                        :min="0"
                        v-model="optionE.montant"
                      ></el-input>
                    </div>
                  </v-flex>
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration"
                        >Montant heures supplémentaires
                        (Ouvrier/Prestataire)</span
                      >
                      <el-input
                        type="number"
                        :min="0"
                        v-model="optionE.montantSupp"
                      ></el-input>
                    </div>
                  </v-flex>

                  <v-flex md1>
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click.prevent="removeOptionEquipe(optionE)"
                        fab
                        dark
                        small
                        color="red"
                      >
                        <v-icon dark>delete</v-icon> </v-btn
                      >Supprimer
                    </v-tooltip>
                  </v-flex>
                </v-layout>

                <v-layout row v-if="dialogEdit">
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration">Type d'exécutant</span>
                      <el-input
                        :value="equipeCourant.typeExec"
                        v-model="equipeCourant.typeExec"
                        disabled
                      ></el-input>
                    </div>
                  </v-flex>
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration">Exécutant</span>
                      <el-input
                        :value="equipeCourant.executant"
                        v-model="equipeCourant.executant"
                        disabled
                      ></el-input>
                    </div>
                  </v-flex>
                  <v-flex md2>
                    <div class="block">
                      <span class="demonstration">Date de début</span>
                      <el-date-picker
                        name="dateD"
                        value-format="dd-MM-yyyy"
                        v-model="dateDContrat"
                        type="date"
                        required
                        style="width: 100%"
                      ></el-date-picker>
                    </div>
                  </v-flex>
                  <v-flex md2>
                    <div class="block">
                      <span class="demonstration">Date de fin</span>
                      <el-date-picker
                        name="dateF"
                        format="dd-MM-yyyy"
                        value-format="dd-MM-yyyy"
                        v-model="dateFContrat"
                        type="date"
                        required
                        style="width: 100%"
                      ></el-date-picker>
                    </div>
                  </v-flex>
                  <v-flex md2>
                    <div class="block">
                      <span class="demonstration">Montant / Jour</span>
                      <el-input
                        name="montant"
                        type="number"
                        :min="0"
                        v-model="montantContrat"
                      ></el-input>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>

            <v-btn color="orange" @click.stop="dialogEquipe = false" dark>
              Annuler
              <v-icon right>close</v-icon>
            </v-btn>
            <v-btn
              v-if="dialogEdit !== true"
              icons
              color="primary"
               :disabled="loading"
              @click="submitEquipe()"
              dark
            >
              Enregistrer
              <v-icon right>save</v-icon>
            </v-btn>
            <v-btn
              v-if="
                dialogEdit &&
                  dateDContrat !== null &&
                  dateFContrat !== null &&
                  montantContrat !== 0
              "
              icons
              color="primary"
              @click="submitEquipe()"
              dark
            >
              Modifier
              <v-icon right>add</v-icon>
            </v-btn>
          </v-container>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL DUPLIQUER CHANTIER -->
    <v-dialog
      v-model="dialogDupliqueChantier"
      max-width="90%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="teal">
          <v-toolbar-title>
            <span
              >Dupliquer les chantier du projet suivant
              {{ projetCourant.libelle }}</span
            >
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogDupliqueChantier = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container fluid grid-list-md>
            <p align="center">
              <v-chip
                text-color="white"
                label
                color="teal"
                style="font-size:22px; width: 100%"
              >
                Dupliquer les chantiers sélectionnés
                <v-icon right>file_copy</v-icon>
              </v-chip>
            </p>

            <v-layout row>
              <v-flex md3>
                <div class="block">
                  <span class="demonstration">Projet concerné</span>
                  <el-input
                    style="font-size:22px"
                    :value="projetCourant.libelle"
                    v-model="projetCourant.libelle"
                    disabled
                  ></el-input>
                </div>
              </v-flex>
              <v-flex md3>
                <div class="block">
                  <span class="demonstration">Type de projet</span>
                  <el-input
                    style="font-size:22px"
                    :value="projetCourant.type"
                    v-model="projetCourant.type"
                    disabled
                  ></el-input>
                </div>
              </v-flex>
              <v-flex md3>
                <div class="block">
                  <span class="demonstration">Date de début *</span>
                  <el-input
                    style="font-size:22px"
                    :value="projetCourant.dateD"
                    v-model="projetCourant.dateD"
                    disabled
                  ></el-input>
                </div>
              </v-flex>
              <v-flex md3>
                <div class="block">
                  <span class="demonstration">Date de fin *</span>
                  <el-input
                    style="font-size:22px"
                    :value="projetCourant.dateF"
                    v-model="projetCourant.dateF"
                    disabled
                  ></el-input>
                </div>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12>
                <p align="center">
                  <v-chip
                    text-color="white"
                    label
                    color="orange"
                    style="font-size:22px; width:100%"
                  >
                    ATTENTION ! Cette action ne fait l'objet d'aucune remise a
                    niveau
                    <v-icon right>file_copy</v-icon>
                  </v-chip>
                </p>
              </v-flex>
            </v-layout>

            <v-form
              v-model="valid"
              ref="formDupliqueChantier"
              lazy-validation
              id="formDupliqueChantier"
            >
              <v-container fluid grid-list-md>
                <v-layout
                  row
                  v-for="(optionE) in optionDuplique"
                  :key="optionE.key"
                >
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration">Référence</span>
                      <el-input
                        type="text"
                        :value="optionE.ref"
                        v-model="optionE.ref"
                        style="width: 100%"
                        disabled
                      ></el-input>
                    </div>
                  </v-flex>
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration">Chantier</span>
                      <el-input
                        type="text"
                        :value="optionE.libelle"
                        v-model="optionE.libelle"
                        style="width: 100%"
                        disabled
                      ></el-input>
                    </div>
                  </v-flex>
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration">Date début</span>
                      <el-input
                        type="text"
                        :value="optionE.dateD"
                        v-model="optionE.dateD"
                        style="width: 100%"
                        disabled
                      ></el-input>
                    </div>
                  </v-flex>
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration">Date fin</span>
                      <el-input
                        type="text"
                        :value="optionE.dateF"
                        v-model="optionE.dateF"
                        style="width: 100%"
                        disabled
                      ></el-input>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
            <br />

            <v-btn
              color="orange"
              @click.stop="dialogDupliqueChantier = false"
              dark
            >
              Annuler
              <v-icon right>close</v-icon>
            </v-btn>
            <v-btn icons color="primary"  :disabled="loading"  @click="submitDupliqueChantier()" dark>
              Enregistrer
              <v-icon right>save</v-icon>
            </v-btn>
          </v-container>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL DEBUT DES CONTRATS -->
    <v-dialog
      v-model="dialogDemarer"
      max-width="80%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span>Démarrer de nouvelles tâches</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogDemarer = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form
            v-model="valid"
            ref="formDemarer"
            lazy-validation
            id="formDemarer"
          >
            <v-container fluid grid-list-md>
              <v-layout row>
                <v-flex md12>
                  <p align="center">
                    <v-chip
                      text-color="white"
                      label
                      color="primary"
                      style="font-size:22px; width:100%"
                    >
                      Marquer le démarrage des tâches des travaux
                      {{ travauxCourant.libelle }}
                      <v-icon right>touch_app</v-icon>
                    </v-chip>
                  </p>
                </v-flex>
              </v-layout>

              <v-layout
                row
                v-for="(optionD) in optionDemarer"
                :key="optionD.key"
              >
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Tâche</span>
                    <el-input
                      :value="optionD.tache"
                      placeholder="Tâche"
                      v-model="optionD.tache"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Type d'exécutant</span>
                    <el-input
                      :value="optionD.typeExec"
                      placeholder="Tâche"
                      v-model="optionD.typeExec"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md2>
                  <div class="block">
                    <span class="demonstration">Exécutant</span>
                    <el-input
                      :value="optionD.executant"
                      placeholder="Exécutant"
                      v-model="optionD.executant"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md2>
                  <div class="block">
                    <span class="demonstration">Durée (Jours)</span>
                    <el-input
                      :value="optionD.duree"
                      placeholder="Durée (Jours)"
                      v-model="optionD.duree"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Date de début</span>
                    <el-date-picker
                      format="dd-MM-yyyy"
                      value-format="dd-MM-yyyy"
                      v-model="optionD.date"
                      type="date"
                      required
                    ></el-date-picker>
                  </div>
                </v-flex>
              </v-layout>

              <br />
              <v-btn @click="dialogDemarer = false" color="orange" dark>
                Annuler
                <v-icon right>close</v-icon>
              </v-btn>
              <v-btn
                icons
                color="blue"
                @click="submitDemarrer()"
                 :disabled="loading"
                dark
              >
                Enregistrer
                <v-icon right>save</v-icon>
              </v-btn>
            </v-container>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL DEBUT DES TRAVAUX -->
    <v-dialog
      v-model="dialogDemarerTravaux"
      max-width="80%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span>Démarrer les travaux {{ travauxCourant.libelle }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogDemarerTravaux = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form
            v-model="valid"
            ref="formDemarerTravaux"
            lazy-validation
            id="formDemarerTravaux"
          >
            <v-container fluid grid-list-md>
              <v-layout row>
                <v-flex md12>
                  <p align="center">
                    <v-chip
                      text-color="white"
                      label
                      color="primary"
                      style="font-size:22px; width:100%"
                    >
                      Marquer le démarrage des travaux
                      {{ travauxCourant.libelle }}
                      <v-icon right>touch_app</v-icon>
                    </v-chip>
                  </p>
                </v-flex>
              </v-layout>

              <v-layout
                row
                v-for="(optionD) in optionDemarer"
                :key="optionD.key"
              >
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Tâche</span>
                    <el-input
                      :value="optionD.tacheLibelle"
                      placeholder="Tâche"
                      v-model="optionD.tacheLibelle"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Exécutant</span>
                    <el-input
                      :value="travauxCourant.fournisseur"
                      placeholder="Exécutant"
                      v-model="travauxCourant.fournisseur"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md2>
                  <div class="block">
                    <span class="demonstration">Durée (Jours)</span>
                    <el-input
                      :value="optionD.duree"
                      placeholder="Durée (Jours)"
                      v-model="optionD.duree"
                      disabled
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Date de début</span>
                    <el-date-picker
                      format="dd-MM-yyyy"
                      value-format="dd-MM-yyyy"
                      v-model="optionD.date"
                      type="date"
                      required
                    ></el-date-picker>
                  </div>
                </v-flex>
              </v-layout>

              <br />
              <v-btn @click="dialogDemarerTravaux = false" color="orange" dark>
                Annuler
                <v-icon right>close</v-icon>
              </v-btn>
              <v-btn
                icons
                color="blue"
                @click="submitDemarrerTravaux()"
                 :disabled="loading"
                dark
              >
                Enregistrer
                <v-icon right>save</v-icon>
              </v-btn>
            </v-container>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL RAPPORT DE TRAVAUX -->
    <v-dialog
      v-model="dialogRapport"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="orange">
          <v-toolbar-title>
            <span>Rapport de la journée de travail</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogRapport = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form
            v-model="valid"
            ref="formRapport"
            lazy-validation
            id="formRapport"
          >
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip
                  text-color="white"
                  label
                  color="orange"
                  style="font-size:22px; width:100%"
                >
                  Ajouter le rapport de cette journée de travail
                  <v-icon right>description</v-icon>
                </v-chip>
              </p>

              <v-layout row>
                <v-flex md12>
                  <div class="block">
                    <span class="demonstration"></span>
                    <el-slider
                      name="evolution"
                      v-model="evolution"
                      show-input
                      style="width:100%"
                    ></el-slider>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md12>
                  <div class="block">
                    <span class="demonstration">Description</span>
                    <el-input
                      name="description"
                      :rows="10"
                      v-model="description"
                      type="textarea"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md12>
                  <div class="block">
                    <span class="demonstration">Ajouter des fichiers</span>
                    <el-upload
                      class="upload-demo"
                      name="fichier[]"
                      action
                      ref="uploadRapport"
                      :auto-upload="false"
                      :file-list="fichier"
                      list-type="picture"
                      multiple
                    >
                      <el-button size="small" type="primary">
                        CLIQUER ICI
                        <i class="el-icon-picture"></i>
                      </el-button>
                    </el-upload>
                  </div>
                </v-flex>
              </v-layout>
              <br />

              <v-btn @click="dialogRapport = false" color="orange" dark>
                Annuler
                <v-icon right>close</v-icon>
              </v-btn>
              <v-btn
                v-if="description !== ''"
                icons
                color="blue"
                @click="submitRapport()"
                 :disabled="loading"
                dark
              >
                Enregistrer
                <v-icon right>save</v-icon>
              </v-btn>
            </v-container>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL RAPPORT MULTIPLE RAPPORT -->
    <v-dialog
      v-model="dialogMultipleRapport"
      max-width="90%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="orange">
          <v-toolbar-title>
            <span>Rapport multiple des travaux</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogMultipleRapport = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container fluid grid-list-md>
            <p align="center">
              <v-chip
                text-color="white"
                label
                color="orange"
                style="font-size:22px; width: 100%"
              >
                Sélectionner les travaux concernés
                <v-icon right>description</v-icon>
              </v-chip>
            </p>

            <!-- RECHERCHE CHANTIER ET TRAVAUX -->
            <div class="grid-content" style="padding:3px; margin:5px">
              <el-row>
                <v-container fluid grid-list-md>
                  <el-card class="box-card">
                    <v-form
                      v-model="valid"
                      ref="formSearchPlanifSuivi"
                      lazy-validation
                      id="formSearchPlanifSuivi"
                    >
                      <v-layout row>
                        <v-flex md4>
                          <el-select
                            clearable
                            v-on:change="loadTravauxSuivi()"
                            v-model="selectChantierRapport"
                            placeholder="Chantier"
                            style="width:100%"
                          >
                            <el-option
                              v-for="item in listChantier"
                              :key="item.id"
                              :label="item.libelle"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </v-flex>
                        <v-flex md4>
                          <el-select
                            clearable
                            v-model="selectTravauxRapport"
                            filterable
                            placeholder="Travaux"
                            style="width:100%"
                          >
                            <el-option
                              v-for="item in listTravaux"
                              :key="item.id"
                              :label="item.libelle"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </v-flex>

                        <v-flex md1>
                          <v-btn
                            icons
                            color="blue"
                            @click="loadTravauxSuivie()"
                            fab
                            dark
                            small
                          >
                            <v-icon>search</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </el-card>
                </v-container>
              </el-row>
            </div>

            <v-form
              v-model="valid"
              ref="formRapportMultiple"
              lazy-validation
              id="formRapportMultiple"
            >
              <v-container fluid grid-list-md>
                <v-layout
                  row
                  v-for="(optionR) in optionRapport"
                  :key="optionR.key"
                >
                  <v-flex md1>
                    <div class="block">
                      <span class="demonstration">Ordre</span>
                      <el-input
                        :value="optionR.ordre"
                        v-model="optionR.ordre"
                        style="width: 100%"
                        disabled
                      ></el-input>
                    </div>
                  </v-flex>
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration">Tâche</span>
                      <el-input
                        type="text"
                        :value="optionR.tache"
                        v-model="optionR.tache"
                        style="width: 100%"
                        disabled
                      ></el-input>
                    </div>
                  </v-flex>
                  <v-flex md4>
                    <div class="block">
                      <span class="demonstration">Evolution</span>
                      <el-slider
                        name="evolution"
                        v-model="optionR.evolution"
                        show-input
                        style="width:100%"
                      ></el-slider>
                    </div>
                  </v-flex>
                  <v-flex md4>
                    <div class="block">
                      <span class="demonstration">Description</span>
                      <el-input
                        name="description"
                        v-model="optionR.description"
                        type="textarea"
                      ></el-input>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
            <br />

            <v-btn
              color="orange"
              @click.stop="dialogMultipleRapport = false"
              dark
            >
              Annuler
              <v-icon right>close</v-icon>
            </v-btn>
            <v-btn
              icons
              color="primary"
              v-if="optionRapport.length != 0"
               :disabled="loading"
              @click="submitRapportMultiple()"
              dark
            >
              Enregistrer
              <v-icon right>save</v-icon>
            </v-btn>
          </v-container>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL VALIDATION DES TRAVAUX -->
    <v-dialog
      v-model="dialogValid"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="green">
          <v-toolbar-title>
            <span>Valider les travaux éffectués</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogValid = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form
            v-model="valid"
            ref="formValid"
            lazy-validation
            id="formValid"
          >
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip
                  text-color="white"
                  label
                  color="green"
                  style="font-size:22px; width:100%"
                >
                  Validation des travaux éffectués
                  <v-icon right>done_all</v-icon>
                </v-chip>
              </p>

              <v-layout row justify>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Réponse</span>
                    <el-select
                      v-model="selectReponse"
                      placeholder="Type d'éxecutant"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in reponseValid"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Description</span>
                    <el-input
                      name="description"
                      :rows="10"
                      v-model="description"
                      type="textarea"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <br />
              <v-btn @click="dialogValid = false" color="orange" dark>
                Annuler
                <v-icon right>close</v-icon>
              </v-btn>
              <v-btn
                v-if="selectReponse !== null"
                icons
                color="blue"
                @click="submitValid"
                 :disabled="loading"
                dark
              >
                Enregistrer
                <v-icon right>save</v-icon>
              </v-btn>
            </v-container>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL VALIDATION DES COMMANDES -->
    <v-dialog
      v-model="dialogValidCommande"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="green">
          <v-toolbar-title>
            <span
              >Valider le recueil de besoins {{ commandeCourant.libelle }}</span
            >
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogValidCommande = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form
            v-model="valid"
            ref="formValidCommande"
            lazy-validation
            id="formValidCommande"
          >
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip
                  text-color="white"
                  label
                  color="green"
                  style="font-size:22px; width:100%"
                >
                  Validation du recueil de besoin
                  <v-icon right>done_all</v-icon>
                </v-chip>
              </p>

              <v-layout row justify>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Réponse</span>
                    <el-select
                      v-model="selectReponse"
                      placeholder="Réponse"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in reponseValid"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Description</span>
                    <el-input
                      name="description"
                      :rows="5"
                      v-model="description"
                      type="textarea"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <br />
              <v-btn @click="dialogValidCommande = false" color="orange" dark>
                Annuler
                <v-icon right>close</v-icon>
              </v-btn>
              <v-btn
                v-if="selectReponse !== null"
                icons
                color="blue"
                @click="submitValidCommande"
                 :disabled="loading"
                dark
              >
                Enregistrer
                <v-icon right>save</v-icon>
              </v-btn>
            </v-container>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION PROJET -->
    <v-dialog
      v-model="dialogSupr"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h3 align="center">
            Voulez-vous vraiment supprimer cet enrégistrement ?
          </h3>
          <p align="center">
            <v-btn @click.native="dialogSupr = false" color="orange" dark>
              Annuler
              <v-icon right>close</v-icon>
            </v-btn>
            <v-btn icons color="red" @click.stop="deleteProjet()" dark>
              Supprimer
              <v-icon right>delete</v-icon>
            </v-btn>
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

     <!-- MODAL SUPPRESSION RESSOURCES -->
    <v-dialog
      v-model="dialogSuprRessource"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h3 align="center">
            Voulez-vous vraiment supprimer cet enrégistrement ?
          </h3>
          <p align="center">
            <v-btn @click.native="dialogSuprRessource = false" color="orange" dark>
              Annuler
              <v-icon right>close</v-icon>
            </v-btn>
            <v-btn icons color="red" @click.stop="deleteRessources()" dark>
              Supprimer
              <v-icon right>delete</v-icon>
            </v-btn>
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
     <!-- MODAL EDIT RESSOURCES -->
    <v-dialog
      v-model="dialogShowEditRessource"
      max-width="70%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title
            >Modifier la quantité du produit de la tâche
            {{ tacheSelectioner.tacheLibelle }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogShowEditRessource = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <el-row :gutter="20">
            <div class="grid-content" style=" padding: 3px">
              <el-row>
                <el-card class="box-card">
                  <div class="grid-content bg-purple">
                    <div class="text item">
                      <el-form
                        id="formEditRessource"
                        label-width="90px"
                        :model="formEditRessource"
                        ref="formEditRessource"
                        class="demo-form-inline"
                      >
                        <v-layout row justify>
                          <v-flex md6>
                            <el-form-item
                              label="Produit"
                              style="width:100%"
                            >
                             <el-input
                              type="text"
                              name="libelle"
                              disabled
                              v-model="formEditRessource.libelle"
                              style="width:100%"
                            ></el-input>
                            </el-form-item>
                          </v-flex>
                          <v-flex md6>
                            <el-form-item
                              label="Quantité"
                              required
                              style="width:100%"
                            >
                              <el-input
                              type="number"
                              name="qte"
                              :min=0
                              v-model="newQteRessource"
                              style="width:100%"
                            ></el-input>
                            </el-form-item>
                          </v-flex>
                        </v-layout>
                        <v-layout row justify v-if="tacheSelectioner.typeProduit == 'VEHICULE'">
                          <v-flex md6>
                            <el-form-item
                              required
                              label="Date debut"
                              style="width:100%"
                            >
                             <el-input
                              type="date"
                              name="dateD"
                              v-model="formEditRessource.dateD"
                              style="width:100%"
                            ></el-input>
                            </el-form-item>
                          </v-flex>
                          <v-flex md6>
                            <el-form-item
                              label="Date fin"
                              required
                              style="width:100%"
                            >
                              <el-input
                              type="date"
                              name="dateF"
                              v-model="formEditRessource.dateF"
                              style="width:100%"
                            ></el-input>
                            </el-form-item>
                          </v-flex>
                        </v-layout>
                      </el-form>
                    </div>
                  </div>
                </el-card>
              </el-row>
            </div>
            <br />
          </el-row>

          <v-tooltip top class="text-xs-right" >
            <v-btn
              slot="activator"
              icons
              color="orange"
              @click="resetFormEditRess()"
              dark
            >
              Fermer
              <v-icon right>close</v-icon> </v-btn
            >Fermer
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              slot="activator"
              icons
              color="primary"
               :disabled="loading"
              @click.stop="sumbitRessource(tacheSelectioner)"
              dark
            >
              Enregistrer
              <v-icon right>save</v-icon> </v-btn
            >Enregistrer
          </v-tooltip>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

     <!-- MODAL INFO RESSOURCES -->
    <v-dialog
      v-model="dialogShowInfoRessource"
      max-width="70%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title
            >Détails du produit de la tâche
            {{ tacheSelectioner.tacheLibelle }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogShowInfoRessource = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <el-row :gutter="20">
            <div class="grid-content" style=" padding: 3px">
              <el-row>
                <el-card class="box-card">
                  <div class="grid-content bg-purple">
                    <div class="text item">
                      <el-form
                        id="formInfoRessource"
                        label-width="90px"
                        :model="formInfoRessource"
                        ref="formInfoRessource"
                        class="demo-form-inline"
                      >
                        <v-layout row justify>
                          <v-flex md6>
                            <el-form-item
                              label="Produit"
                              style="width:100%"
                            >
                             <el-input
                              type="text"
                              name="libelle"
                              disabled
                              v-model="formInfoRessource.libelle"
                              style="width:100%"
                            ></el-input>
                            </el-form-item>
                          </v-flex>
                          <v-flex md6>
                            <el-form-item
                              label="Quantité"
                              style="width:100%"
                            >
                              <el-input
                              type="number"
                              name="qte"
                              :min=0
                              disabled
                              v-model="formInfoRessource.qte"
                              style="width:100%"
                            ></el-input>
                            </el-form-item>
                          </v-flex>
                        </v-layout>
                         <v-layout row justify>
                          <v-flex md6>
                            <el-form-item
                              label="Date debut"
                              style="width:100%"
                            >
                             <el-input
                              type="text"
                              name="dateD"
                              disabled
                              v-model="formInfoRessource.dateD"
                              style="width:100%"
                            ></el-input>
                            </el-form-item>
                          </v-flex>
                          <v-flex md6>
                            <el-form-item
                              label="Date fin"
                              style="width:100%"
                            >
                              <el-input
                              type="text"
                              name="dateF"
                              disabled
                              v-model="formInfoRessource.dateF"
                              style="width:100%"
                            ></el-input>
                            </el-form-item>
                          </v-flex>
                        </v-layout>
                      </el-form>
                    </div>
                  </div>
                </el-card>
              </el-row>
            </div>
            <br />
          </el-row>

          <v-tooltip top class="text-xs-right" >
            <v-btn
              slot="activator"
              icons
              color="orange"
              @click="resetFormInfoRess()"
              dark
            >
              Fermer
              <v-icon right>close</v-icon> </v-btn
            >Fermer
          </v-tooltip>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION CHANTIER -->
    <v-dialog
      v-model="dialogSuprChantier"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h3 align="center">
            Voulez-vous vraiment supprimer cet enrégistrement ?
          </h3>
          <p align="center">
            <v-btn
              @click.native="dialogSuprChantier = false"
              color="orange"
              dark
            >
              Annuler
              <v-icon right>remove_circle</v-icon>
            </v-btn>
            <v-btn icons color="red" @click.stop="deleteChantier()" dark>
              Supprimer
              <v-icon right>delete</v-icon>
            </v-btn>
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION TRAVAUX -->
    <v-dialog
      v-model="dialogSuprTravaux"
      v-if="droitAcces.delete_travaux"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h3 align="center">
            Voulez-vous vraiment supprimer cet enrégistrement ?
          </h3>
          <p align="center">
            <v-btn
              @click.native="dialogSuprTravaux = false"
              color="orange"
              dark
            >
              Annuler
              <v-icon right>remove_circle</v-icon>
            </v-btn>
            <v-btn icons color="red" @click.stop="deleteTravaux()" dark>
              Supprimer
              <v-icon right>delete</v-icon>
            </v-btn>
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION TACHE -->
    <v-dialog
      v-model="dialogSuprTache"
      v-if="droitAcces.delete_tache"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h3 align="center">
            Voulez-vous vraiment supprimer cet enrégistrement ?
          </h3>
          <p align="center">
            <v-btn @click.native="dialogSuprTache = false" color="orange" dark>
              Annuler
              <v-icon right>remove_circle</v-icon>
            </v-btn>
            <v-btn icons color="red" @click.stop="deleteTache()" dark>
              Supprimer
              <v-icon right>delete</v-icon>
            </v-btn>
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW OUVRIER -->
    <v-dialog v-model="dialogAjoutOuvrier" persistent max-width="70%">
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span>Ajouter une ressources technique</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutOuvrier = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <el-container>
            <el-form
              label-position="right"
              :model="formManoeuvre"
              :rules="rulesformManoeuvre"
              ref="formManoeuvre"
              id="formManoeuvre"
              label-width="120px"
            >
              <el-row>
                <el-col :span="4">
                  <a :href="logoOuvrier" target="_blank">
                    <v-avatar
                      :tile="true"
                      size="140px"
                      height="120px"
                      color="grey lighten-4"
                    >
                      <img :src="logoOuvrier" alt="avatar"/></v-avatar
                    ><br />
                  </a>
                  <input
                    name="photo"
                    type="file"
                    style="display:none"
                    ref="fileOuvrier"
                    accept="image/*"
                    @change="onFileImageOuvrierPicked"
                  />
                  <v-btn
                    color="primary"
                    class="white--text"
                    required
                    @click.native="$refs.fileOuvrier.click()"
                    >Photo <v-icon right dark>cloud_upload</v-icon></v-btn
                  ><br />
                </el-col>

                <el-col :span="18">
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="Domicile" prop="domicile">
                          <el-input v-model="formManoeuvre.domicile"></el-input>
                        </el-form-item>
                      </div>
                    </el-col>

                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="Nom" prop="nom">
                          <el-input v-model="formManoeuvre.nom"></el-input>
                        </el-form-item>
                      </div>
                    </el-col>

                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="Profession" prop="profession">
                          <el-input v-model="formManoeuvre.profession"></el-input>
                        </el-form-item>
                      </div>
                    </el-col>

                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="Type de piece" prop="piece">
                          <el-input v-model="formManoeuvre.piece"></el-input>
                        </el-form-item>
                      </div>
                    </el-col>

                    <el-col :span="12">
                      <el-form-item label="NumPiece" prop="numPiece">
                        <el-input v-model="formManoeuvre.numPiece"></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="12">
                      <el-form-item label="Contact" prop="contact">
                        <el-input v-model="formManoeuvre.contact"></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="12">
                      <el-form-item label="Date de naissance" prop="dateNaiss">
                        <el-date-picker
                          format="dd-MM-yyyy"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="Date de naissance"
                          v-model="formManoeuvre.dateNaiss"
                          style="width: 100%;"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <small class="red--text">*Champs obligatoire</small>
                  </el-row>
                </el-col>
              </el-row>
            </el-form>
          </el-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="dialogAjoutOuvrier = false">Fermer</v-btn>
          <v-btn color="primary"  :disabled="loading"  dark @click="submitformManoeuvre('formManoeuvre')"
            >Enregistrer<v-icon right>save</v-icon></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- MODAL MAP GOOGLE -->
    <v-expansion-panel>
      <v-expansion-panel-content class="blue lighten-4 elevation-18">
        <div slot="header">
          Cliquez pour afficher les chantiers la carte
          <v-icon>map</v-icon>
        </div>
        <v-card>
          <v-card-text>
            <ProjetMap
              :show="showModalMap"
              :listMarqueur="dataMarqueurProj"
              @close="showModalMap = false"
            ></ProjetMap>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <!-- MODAL MAP GOOGLE  -->
    <br />

    <!-- STATS DES PROJETS -->
    <!-- <v-layout row justify>
      <v-flex md4>
        <div
          id="chartEtatCommandeAll"
          style="width: 450px; height: 300px"
        ></div>
      </v-flex>
      <v-flex md4>
        <div id="chartEtatMontantAll" style="width: 450px; height: 300px"></div>
      </v-flex>
      <v-flex md4>
        <div
          id="chartEtatGeneralAll"
          style="width: 450px; height: 300px"
          align="center"
        ></div>
      </v-flex>
    </v-layout> -->

    <br />
    <!-- TABLEAU -->
    <v-card>
      <div>
        <v-chip text-color="white" label color="primary">
          LISTE DES PROJETS
          <v-icon right>terrain</v-icon>
        </v-chip>

        <!-- BTN AJOUT -->
        <v-spacer></v-spacer>
        <div class="text-xs-right">
          <v-layout row>
            <v-flex
              v-if="
                droitAcces.imprime_pdf_histo_liste_projet ||
                  droitAcces.imprime_exc_histo_liste_projet
              "
            >
              <el-popover
                ref="popProjet"
                placement="top"
                width="180"
                trigger="hover"
              >
                <p>Veuillez choisir le format d'impression ?</p>
                <div style="text-align: right; margin: 0">
                  <el-button
                    type="success"
                    size="mini"
                    v-if="droitAcces.imprime_pdf_histo_liste_projet"
                    @click="imprimeListeHisProjets('PDF')"
                    >PDF</el-button
                  >
                  <el-button
                    type="primary"
                    size="mini"
                    v-if="droitAcces.imprime_exc_histo_liste_projet"
                    @click="imprimeListeHisProjets('EXC')"
                    >EXCEL</el-button
                  >
                </div>
              </el-popover>
              <div>
                <el-button
                  v-popover:popProjet
                  type="warning"
                  :disabled="disabledBtnPop"
                  icon="el-icon-printer"
                  >Rapport</el-button
                >
              </div>
            </v-flex>

            <v-flex>
              <v-tooltip top>
                <v-btn
                  slot="activator"
                  icons
                  color="primary"
                  v-if="droitAcces.new_projet"
                  @click.stop="
                    ajoutProjet('new');loadCaisse()
                    logoProjet = '/static/img-doc.png';
                  "
                  dark
                >
                  Ajouter
                  <v-icon right>add</v-icon> </v-btn
                >Ajouter un nouveau projet
              </v-tooltip>

              <v-btn
                @click="
                  dialogAide = listTravauxProjet;
                  fichierProj.splice(0);
                "
                fab
                color="primary"
                small
                dark
              >
                <v-icon>help_outline</v-icon>
              </v-btn>
              <!-- MODAL OPTION AIDE -->
              <v-bottom-sheet v-model="dialogAide">
                <v-list>
                  <v-subheader>Creer un projet</v-subheader>
                  <v-list-tile>
                    <v-list-tile-title>1-Creer un projet</v-list-tile-title>
                  </v-list-tile>
                </v-list>

                <v-list>
                  <v-subheader>Menu preparation Chantier</v-subheader>
                  <v-list-tile>
                    <v-list-tile-title>2-Creer les chantiers</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-bottom-sheet>
            </v-flex>
          </v-layout>
        </div>

        <div
          class="grid-content"
          style="padding:3px; margin:5px"
          v-if="
            droitAcces.projet_index ||
              droitAcces.projet_index_chefProjet ||
              droitAcces.projet_index_chefEtude ||
              droitAcces.projet_index_chefControle ||
              droitAcces.projet_index_user
          "
        >
          <el-row>
            <v-container fluid grid-list-md>
              <el-card class="box-card">
                <v-form
                  v-model="valid"
                  ref="formSearchProjet"
                  lazy-validation
                  id="formSearchProjet"
                >
                  <v-layout row>
                    <v-flex md6>
                      <el-select
                        filterable
                        clearable
                        v-model="selectSearchProjet"
                        placeholder="Projet"
                        style="width:100%"
                      >
                        <el-option
                          v-for="item in items"
                          :key="item.id"
                          :label="item.libelle"
                          :value="item.id"
                        >
                          <span style="float: left">{{
                            item.libelle.toUpperCase()
                          }}</span>
                          <span
                            style="float: right; color: #8492a6; font-size: 13px"
                            >{{ item.type.toUpperCase() }} - ({{
                              item.nbChantier
                            }}) chantier(s)</span
                          >
                        </el-option>
                      </el-select>
                    </v-flex>

                    <v-flex md1>
                      <v-btn
                        icons
                        :disabled="
                          selectSearchProjet == undefined ||
                            selectSearchProjet == ''
                        "
                        color="primary"
                        @click="loadProjet()"
                        small
                      >
                        VALIDER
                        <v-icon right>search</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-form>
              </el-card>
            </v-container>
          </el-row>
        </div>

        <v-card-text
          v-if="
            (listProjetResult.length !== 0 && droitAcces.projet_index) ||
              droitAcces.projet_index_chefProjet ||
              droitAcces.projet_index_chefEtude ||
              droitAcces.projet_index_chefControle ||
              droitAcces.projet_index_user ||
              droitAcces.projet_all_index
          "
        >
          <data-tables :data="listProjetResult" style="width: 100%">
            <el-table-column
              prop="libelle"
              label="Libellé"
              width="370"
              fixed="left"
            >
              <template slot-scope="scope">
                <v-chip text-color="white" label color="primary">{{
                  scope.row.libelle
                }}</v-chip>
                <v-chip outline text-color="primary" label color="primary">
                  {{ scope.row.adresse }}
                  <v-icon right>location_on</v-icon>
                </v-chip>
              </template>
            </el-table-column>
            <el-table-column prop="chef" label="Chef de projet">
              <template slot-scope="scope">
                <v-chip outline text-color="indigo" label color="indigo">
                  {{ scope.row.chef }}
                  <v-icon right>person</v-icon>
                </v-chip>
              </template>
            </el-table-column>
            <el-table-column prop="evolution" label="Evolution">
              <template slot-scope="scope">
                <v-progress-circular
                  :size="85"
                  :width="15"
                  :rotate="360"
                  :value="scope.row.evolution"
                  color="primary"
                  >{{ scope.row.evolutionNbr }} %</v-progress-circular
                >
              </template>
            </el-table-column>
            <el-table-column prop="created" label="Date de création">
              <template slot-scope="scope">
                <v-chip text-color="white" color="orange">{{
                  scope.row.created
                }}</v-chip>
              </template>
            </el-table-column>
            <el-table-column label="Action" fixed="right">
              <template slot-scope="scope">
                <div class="text-xs-center">
                  <!-- <v-tooltip top>
                    <v-btn slot="activator" @click="modalDashboardProjet(scope.row)" fab dark small color="blue">
                      <v-icon dark>dashboard</v-icon>
                    </v-btn>
                    Dashboard projet...
                  </v-tooltip>-->
                  <v-tooltip top>
                    <v-btn
                      slot="activator"
                      v-if="droitAcces.show_projet"
                      @click.stop="
                        tab = '0';
                        showProjet(scope.row);
                        loadChantier(scope.row);
                        loadProjetTache(scope.row);
                        loadProjetContrat(scope.row);
                        loadProduitTravaux(scope.row);
                        loadPlanningProjet(scope.row);
                        modalDashboardProjet(scope.row);
                        loadClient();
                        loadUser();
                        loadPrestaire();

                      "
                      fab
                      dark
                      small
                      color="green"
                    >
                      <v-badge color="red">
                        <span v-if="nbChantier == 0" slot="badge">!</span>
                        <v-icon dark>folder_open</v-icon>
                      </v-badge> </v-btn
                    >Détails
                  </v-tooltip>

                  <v-tooltip top>
                    <v-btn
                      slot="activator"
                      v-if="droitAcces.new_projet"
                      @click="ajoutProjet('edit', scope.row)"
                      fab
                      dark
                      small
                      color="primary"
                    >
                      <v-icon dark>edit</v-icon> </v-btn
                    >Modifier
                  </v-tooltip>
                  <v-tooltip top>
                    <v-btn
                      slot="activator"
                      v-if="droitAcces.delete_projets"
                      @click="
                        dialogSupr = true;
                        idProjet = scope.row.id;
                      "
                      fab
                      dark
                      small
                      color="red"
                    >
                      <v-icon dark>delete</v-icon> </v-btn
                    >Supprimer
                  </v-tooltip>
                </div>
              </template>
            </el-table-column>
          </data-tables>
        </v-card-text>
        <p
          align="center"
          v-if="
            !droitAcces.projet_index ||
              !droitAcces.projet_index_chefProjet ||
              !droitAcces.projet_index_chefEtude ||
              !droitAcces.projet_index_chefControle ||
              droitAcces.projet_all_index
          "
        >
          <!-- <v-chip text-color="white" label color="red" style="width: 100%; font-size: 22px">
            VOUS N'AVEZ PAS LES AUTORISATIONS REQUISES POUR CONSULTER LA LISTE DES PROJETS.
            <v-icon dark right>stop_screen_share</v-icon>
          </v-chip>-->
        </p>
      </div>
    </v-card>

    <!-- info enregitrement planification -->
    <!-- CONFIRMATION VALIDATION -->
    <v-layout row justify-center>
      <v-dialog v-model="dialogInfoPlan" persistent max-width="500">
        <v-card>
          <v-card-title class="headline"
            >Validation des besoins Matériels</v-card-title
          >
          <v-card-text>
            <p>
              La liste besoins énumerés sera soumise pour validation au chef de
              projet, vous serez informez par notification
            </p>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              flat
              @click.native="dialogInfoPlan = false"
              >Ok</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <!-- MODAL DEMARRER TACHE -->
    <v-dialog v-model="dialogDemarrer" max-width="600" :persistent="true">
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-toolbar-title
            >Démarrer une tâche: {{ tacheSel.libelle }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="dialogDemarrer = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <el-form
            id="formDemarrer"
            label-width="90px"
            :model="formDemarrer"
            ref="formDemarrer"
            class="demo-form-inline"
          >
            <el-form-item label="Debut" required>
              <el-col :span="11">
                <el-form-item prop="dateDbt">
                  <el-date-picker
                    type="date"
                    placeholder="Choisir une date de debut"
                    format="dd-MM-yyyy"
                    v-model="formDemarrer.dateDbt"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-form-item prop="hrDbt">
                  <el-time-picker
                    type="fixed-time"
                    placeholder="Choisir une heure de debut"
                    v-model="formDemarrer.hrDbt"
                    style="width: 100%;"
                  ></el-time-picker>
                </el-form-item>
              </el-col>
            </el-form-item>

            <el-form-item class="text-xs-right">
              <v-btn color="grey" @click="resetForm('formDemarrer')" dark>
                Annuler
                <v-icon right>remove_circle</v-icon>
              </v-btn>
              <v-btn
                icons
                dark
                color="green"
                :disabled="loading"
                @click="submitFormDemarrer('formDemarrer')"
              >
                Enregistrer
                <v-icon right>save</v-icon>
              </v-btn>
            </el-form-item>
          </el-form>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
    <!-- MODAL DEMARRER TACHE-->

    <!-- MODAL SHOW REGLEMENT -->
    <v-dialog
      v-model="dialogShowReglement"
      max-width="70%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title
            >Modifier les dates de la tache
            {{ travauxCourant.libelle }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon @click="resetFormVersion()" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <el-row :gutter="20">
            <div class="grid-content" style=" padding: 3px">
              <el-row>
                <el-card class="box-card">
                  <div class="grid-content bg-purple">
                    <div class="text item">
                      <el-form
                        id="formTacheDemarrer"
                        label-width="90px"
                        :model="formTacheDemarrer"
                        ref="formTacheDemarrer"
                        class="demo-form-inline"
                      >
                        <v-layout row justify>
                          <v-flex md6>
                            <el-form-item
                              label="Debut"
                              required
                              style="width:100%"
                            >
                              <el-date-picker
                                v-model="formTacheDemarrer.dateDbtache"
                                value-format="dd-MM-yyyy"
                                type="date"
                                id="dateDbtache"
                                name="dateDbtache"
                                placeholder="Date"
                                style="width:100%"
                              >
                              </el-date-picker>
                            </el-form-item>

                            <!-- <p>
                              <b>Daye de debut :</b>
                            </p>
                            <el-date-picker
                              type="date"
                              placeholder="Choisir une date de debut"
                              format="dd-MM-yyyy"
                              v-model="formTacheDemarrer.dateDbtache"
                              style="width: 100%;"
                            ></el-date-picker> -->
                          </v-flex>
                          <v-flex md6>
                            <el-form-item
                              label="Fin"
                              required
                              style="width:100%"
                            >
                              <el-date-picker
                                v-model="formTacheDemarrer.dateFintache"
                                value-format="dd-MM-yyyy"
                                type="date"
                                id="dateFintache"
                                name="dateFintache"
                                placeholder="Date"
                                style="width:100%"
                              >
                              </el-date-picker>
                            </el-form-item>
                            <!-- <p>
                              <b>Date de fin :</b>
                            </p>
                            <el-date-picker
                              type="date"
                              placeholder="Choisir une date de fin"
                              format="dd-MM-yyyy"
                              v-model="formTacheDemarrer.dateFintache"
                              style="width: 100%;"
                            ></el-date-picker> -->
                          </v-flex>
                        </v-layout>
                      </el-form>
                    </div>
                  </div>
                </el-card>
              </el-row>
            </div>
            <br />
          </el-row>
        <v-flex xs12 class="text-xs-right">
          <v-tooltip top>
            <v-btn
              slot="activator"
              icons
              color="orange"
              @click="resetFormVersion()"
              dark
            >
              Fermer
              <v-icon right>close</v-icon> </v-btn
            >Fermer
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              slot="activator"
              icons
              color="primary"
              :disabled="loading"
              @click.stop="editDateTache('formTacheDemarrer')"
              dark
            >
              Enregistrer
              <v-icon right>save</v-icon> </v-btn
            >Enregistrer
          </v-tooltip>
           </v-flex>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- DASHBOARD CHANTIER-->
    <DashboardChantierProjet
      :detailChantier="detailChantier"
      :show="showDetailChantier"
      @close="showDetailChantier = false"
    ></DashboardChantierProjet>
    <!-- DASHBOARD CHANTIER -->

    <!-- DASHBOARD CHANTIER-->
    <IndexTache
      :detailTrx="detailTravaux"
      :show="showDetailTache"
      @close="showDetailTache = false"
      @reloadTrx="$emit('reloadListeTravaux')"
    ></IndexTache>
    <!-- DASHBOARD CHANTIER -->

    <!--LISTE OUVRIERS -->
    <IndexOuvrierTrx
      :tacheSelect="tacheSel"
      :show="showSelTache"
      @close="showSelTache = false"
    ></IndexOuvrierTrx>
    <!-- LISTE OUVRIERS -->

<!--DUPLIQUER CHANTIER -->
     <v-dialog v-model="showDialogDupTrx" persistent max-width="900">
        <v-card>
        <v-card-title class="headline">Duplication du chantier : {{libelleSelect.libelle}}</v-card-title>
        <v-card-text class="mb-5" >
            <el-alert
                :title="'Voulez-vous duppliquer tous les travaux, les planifications des tâches et la budgétisation de ce chantier?'"
                type="warning"
                center
                :closable="false"
                show-icon>
            </el-alert>
        </v-card-text>
        <v-card-actions >
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-btn  flat @click.native="showDialogDupTrx = false">Annuler</v-btn>
            <v-btn  color="green darken-1" @click="validDuplique(libelleSelect)" flat >Confirmer</v-btn>
        </v-card-actions>
        </v-card>
    </v-dialog>

  </div>
</template>

<script>
var echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/bar");
require("echarts/lib/chart/pictorialBar");
require("echarts/lib/chart/funnel");
require("echarts/lib/chart/sankey");
require("echarts/lib/chart/scatter");
require("echarts/lib/chart/pie");
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");

import Loading from "@/components/Loading";
import ProjetMap from "@/components/map/ProjetMap";
import "dhtmlx-gantt";
import DashboardOngletPrj from "@/components/boardProjet/dashboardOngletPrj";
import DashboardChantierProjet from "@/components/boardChantier/DashboardChantierProjet";
import IndexTache from "@/components/boardChantier/index_tache_chantier";
import IndexOuvrierTrx from "@/components/boardTravaux/IndexOuvrierTrx";
import MatriceContract from "@/components/projet/MatriceContract";
import CompteExploitationProjet from "@/components/projet/CompteExploitationProjet";

export default {
  components: {
    Loading,
    ProjetMap,
    DashboardOngletPrj,
    DashboardChantierProjet,
    IndexTache,
    IndexOuvrierTrx,
    MatriceContract,
    CompteExploitationProjet
  },
  name: "projet",
  data() {
    return {
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      valid: true,
      choix: true,
      etat: false,
      choixTravux: true,
      choixChantier: true,
      dialogImport: false,
      racourcis: [
        { path: "/", text: "Accueil", disabled: false },
        { path: "/projet", text: "Liste des projets", disabled: true }
      ],
      tabb: "0",
      tab: "0",
      logoProjet: "/static/img-doc.png",
      logoChantier: "/static/img-doc.png",
      fileLogo: "",
      logoOuvrier: "/static/img-doc.png",

      activeSuivie: "taches",
      activeCom: "avalider",
      activeEngin: "engin",
      activeTacheChantier: "tacheChantier",
      activeComChantier: "avalider",
      dialogPlan: false,
      dialogTravaux: false,
      dialogComm: false,
      dialogPlanifProduit: false,
      dialogEquipe: false,
      showDialogDupTrx: false,
      libelleSelect:[],
      formTacheDemarrer: {
        dateDbtache:'',
        dateFintache:'',
      },
      dialogShowReglement: false,
      dialogShowEditRessource: false,
      dialogShowInfoRessource: false,
      dialogDemarer: false,
      dialogDemarerTravaux: false,
      dialogRapport: false,
      dialogValid: false,
      dialogValidCommande: false,
      dialogShowProjet: false,
      dialogShowTravaux: false,
      dialogShowTache: false,
      dialogShowCommande: false,
      dialogEdit: false,
      dialogSupr: false,
      dialogSuprChantier: false,
      dialogSuprTravaux: false,
      dialogSuprTache: false,
      dialogSuprRessource: false,
      dialogDupliqueChantier: false,
      dialogMultipleRapport: false,
      activDerouler: false,
      idProjet: "",
      idChantier: "",
      idTravaux: "",
      idTache: "",
      idRessour: "",
      UniteVehicule: "",
      projetCourant: [],
      detailProjet: [],
      selectBanques: [],
      optionE:[],
      texteP: "",
      priorites: [
      {
        value: 1,
        label: "Faible"
      },
      {
        value: 2,
        label: "Normal"
      },
      {
        value: 3,
        label: "Urgent"
      }
    ],
      formEditRessource: {
        id:'',
        libelle:'',
        qte:0,
        dateF:'',
        dateD:''
      },
      newQteRessource:0,
       formManoeuvre: {
        nom: "",
        domicile: "",
        profession: "",
        piece: "",
        numPiece: "",
        contact: "",
        dateNaiss: ""
      },
      formInfoRessource: {
         id:'',
        libelle:'',
        qte:0,
        dateD:'',
        dateF:'',
      },
      form: {
        id: "",
        etat: false,
        type: "",
        description: "",
        libelle: "",
        adresse: "",
        chef: "",
        chefEtude: "",
        chefControle: "",
        architect: "",
        caisse: "",
        banque: "",
        nbrHeure: 1,
        maitre_ouvrage: ""
      },
      liste: [],
      type: { etat: false },
      selected: [],
      items: [],
      optionChantier: [
        {
          key: 1,
          libelle: "",
          dateD: "",
          dateF: "",
          montant: 0,
          idChef: "",
          id: ""
        }
      ],
      libelleRules: [
        v => !!v || "Veuillez renseigner le libellé obligatoirement"
      ],
      listChantier: [],
      chantierCourant: [],
      travauxCourant: [],
      optionTache: [
        {
          key: 1,
          unite: "",
          dateDebut: "",
          dateFin: "",
          tache: "",
          qte: 1,
          prix: 0,
          total: 0,
          id: ""
        }
      ],
      users: [],
      usersRules: [
        v => !!v || "Veuillez renseigner le libellé obligatoirement"
      ],
      listPrestataire: [],
      listOuvrier: [],
      listTravaux: [],
      listTypeProjet: [],
      listTravauxProjet: [],
      rulesZone: {
        ville: [
          {
            required: true,
            message: "Veuillez renseigner la ville",
            trigger: "blur"
          }
        ],
        commune: [
          {
            required: true,
            message: "Veuillez renseigner la commune",
            trigger: "change"
          }
        ],
        quartier: [
          {
            required: true,
            message: "Veuillez renseigner le quartier",
            trigger: "change"
          }
        ]
      },
      listEtat: [
        { id: 1, libelle: "En cours" },
        { id: 2, libelle: "Arret du chantier" },
        { id: 3, libelle: "Termine" }
      ],
      selectZone: "",
      selectEtat: "",
      travauxCourant: [],
      FormComm: {
        fournisseur: "",
        optionCommande: [{ key: 1, produit: "", qte: 1, id: "" }]
      },
      rulesComm: {
        optionCommande: [
          {
            produit: [
              {
                required: true,
                message: "Veuillez renseigner la ville",
                trigger: "blur"
              }
            ],
            prix: [
              {
                required: true,
                message: "Veuillez renseigner la commune",
                trigger: "change"
              }
            ],
            qte: [
              {
                required: true,
                message: "Veuillez renseigner le quartier",
                trigger: "change"
              }
            ],
            tva: [
              {
                required: true,
                message: "Veuillez renseigner le quartier",
                trigger: "change"
              }
            ]
          }
        ]
      },
      listProd: [],
      detailTravaux: [],
      detailPlanifProduit: [],
      etape: 1,
      descriptionTravaux: "",
      selectChefTravaux: "",
      optionEquipe: [
        {
          key: 1,
          type: [
            { text: "Prestataire", value: 1 },
            { text: "Ouvrier/Manoeuvre", value: 2 }
          ],
          selectType: "",
          fournisseur: "",
          ouvrier: "",
          duree: "",
          montant: 0,
          montantSupp: 0,
          id: ""
        }
      ],
      tacheCourant: [],
      equipeCourant: [],
      tacheSelectioner: [],
      listEquipe: [],
      multipleSelection: [],
      optionDemarer: [{ key: 1, date: "", id: "" }],
      dateDContrat: "",
      dateFContrat: "",
      montantContrat: 0,
      evolution: 0,
      description: "",
      dateD: "",
      dateDbtache: "",
      dateFintache: "",
      dateF: "",
      listProjetTache: [],
      listProjetContrat: [],
      fichier: [{ name: "", url: "" }],
      reponseValid: [
        { text: "VALIDER", value: 1 },
        { text: "REFUSE", value: 2 }
      ],
      selectReponse: "",
      listProjetAValid: [],
      listProjetAll: [],
      listProjetValid: [],
      commandeCourant: [],
      detailCommande: [],
      listProjetAlivre: [],
      listProjetlivre: [],
      listCaisse: [],
      listBanque: [],
      listEngin: [],
      listeProduitAffich: [],
      listProduiTravaux: [],
      selectTravaux: "",
      tasks: {
        data: [],
        links: []
      },
      libProjet: "",
      chefProjet: "",
      libChantier: "",
      chefChantier: "",
      showModalMap: false,
      longitude: 0,
      latitude: 0,
      montant: 0,
      libelle: "",
      mapName: "chantier-map",
      markers: [],
      listeTacheSupp:[],
      chantier: {},
      idChantMod: "",
      disabledBtnPop: false,
      //Data ouvrier
      dialogAjoutOuvrier: false,
      fileExcel: [],

      rulesformManoeuvre: {
        nom: [{ required: true, message: "Saisir un nom", trigger: "blur" }],

        piece: [
          {
            required: true,
            message: "Saisir le type de piece",
            trigger: "blur"
          }
        ],
        numPiece: [
          {
            required: true,
            message: "Saisir le numero de la piece",
            trigger: "blur"
          }
        ],
        contact: [
          {
            required: true,
            message: "Saisir un numéro de téléphone",
            trigger: "blur"
          }
        ]
      },
      selectPrestataire: "",
      lstPreparation:[],
      showModalLoadPreparation: false,
      selectSoustraite: "",
      etatSoutraitance: [{ text: "NON", value: 0 }, { text: "OUI", value: 1 }],
      montantSoustraitance: 0,
      montantEstime: 0,
      listChantierSuivie: [],
      listTravauxSuivie: [],
      tacheCourant: [],
      detailTache: [],
      projetSelect: "",
      selectSearchChantier: "",
      selectSearchEtat: "",
      selectSearchProjet: "",
      dateSearch: "",
      etatSearch: [
        { text: "En attente", value: 0 },
        { text: "En cours", value: 1 },
        { text: "Terminé", value: 2 }
      ],
      typeSearch: [
        { text: "Par chantier", value: 1 },
        { text: "Par travaux", value: 2 }
      ],
      selectTypeSearch: 1,
      selectSearchTravaux: "",
      listProjetResult: [],
      listChantierResult: [],
      listTravauxResult: [],
      selectSearchChantierFind: "",
      selectTypeSearchSuivi: 1,
      selectSearchTravauxSuivi: "",
      selectSearchChantierSuivi: "",
      selectSearchChantierFindSuivi: "",
      typeRapport: [
        { text: "Etat général", value: 1 },
        { text: "Valeur financiere", value: 2 },
        { text: "Commande", value: 3 },
        //{ text: 'Ressource humaine', value: 4 },
        { text: "Mission", value: 4 },
        { text: "Produit", value: 5 }
      ],
      selectTypeRapport: "",
      colorx: "#8B0000",
      searchResultEtat: [],
      searchResultEtatMontant: [],
      searchResultList: [],
      searchResultTravauxList: [],
      searchProduitChantierList: [],
      searchResultEtatCommande: [],
      libelleEtatResult: "",
      totalCommande: 0,
      totalDepense: 0,
      optionDuplique: [],
      selectChantierRapport: "",
      selectTravauxRapport: "",
      optionRapport: [{ evolution: 0, description: "", fichier: [] }],
      statsGeneralAll: [],
      statsMontantAll: [],
      statsCommandeAll: [],
      optionProduit: [{ type: "", produit: "", qte: 1, priorite: "" }],
      optionVehicule: [{ vehicule: "", qte: 1, priorite: "", periode: "" }],
      //marquer projet
      dataMarqueurProj: [],
      dialogAide: false,
      nbChantier: 0,
      uniteAffic: "",
      listProdPlan: [],
      typeProduit: "",
      listTypeRessource: [],

      listVehPlan: [],
      dialogInfoPlan: false,
      showMatrice: false,

      //dashboard projet
      detailProjet: {},
      showDetailProjet: false,

      //dashboard chantier
      detailChantier: {},
      showDetailChantier: false,

      //TACHE TRAVAUX
      detailTravaux: {},
      showDetailTache: false,

      //IMAGE PROJET
      imageProjet: "/static/avatar_proj.png",
      fileProj: "",
      fichierProj: [],

      //INDEXOUVRIER
      tacheSel: {},
      showSelTache: false,

      //DEMARRER UNE TACHE
      dialogDemarrer: false,
      formDemarrer: {},
      readBtnModTrx: false,

      totalHT: 0,
      tacheCourante: {},

      valeurUniteMateriel: "",

      //TACHE PLANIFICATION
      listeTacheTrx: [],
      tacheS: "",
      listClient: [],
      selectUsers:[],
      detailPlanifCourant: [],

      listTravauxRow: [],
      listCommandesRow: [],
      listTachesRow: [],
      listRessourcesRow: [],

      // listeBudget:[],
      // formBudget:{
      //   libelle: "",
      //     montantAdecaisse:5
      //
      // },
      listeProduitBudget: [],
      tableBudget: [],

      //COMPTE EXPLOIT
      showCompteExploit: false
    };
  },
  created() {
    this.loadMarqueurProjet();
  },
  mounted() {
    this.loadProjetAll()
    this.loadTypeRessource()
    // this.statsAllProjet();
  },
  methods: {
    handleChangeSoustraitant(soustraite) {
      if (soustraite == 0) {
        this.chantier.prestataire = null;
        this.chantier.montantSoustraitance = 0;
      }
    },

    //budget
    loadProduitBudget() {
      this.loading = true;
      let url = this.domaine + "product/product-travaux-list/all/type";
      let formdata = new FormData();
      formdata.append("user", this.user.id);
      formdata.append("typeTacheProjet", this.form.type);
      this.listeProduitBudget.splice(0);
      this.$http.post(url, formdata).then(
        response => {
          if (response.body) {
            this.loading = false;
            this.listeProduitBudget = response.body.produits;
          }
        },
        response => {
          this.loading = false;
        }
      );
    },
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },

    addListBudget(item) {
      //verifier si l'item n'et pas deja enregistrer dans le tableau
      let eltProd = this.tableBudget.find(elt => elt == item.libelle.libelle);
      if (eltProd != null) {
        this.$message.error("Cet element a déjà été ajouté à la liste");
        return;
      }

      this.tableBudget.push({
        libelle: item.libelle.libelle,
        montantAdecaisse: item.montantAdecaisse,
        type: item.libelle.typeBudget,
        id: item.libelle.id
      });
    },

    loadTacheTrx() {
      this.loading = true;
      this.tacheS = "";
      this.listeTacheTrx.splice(0);
      if (this.travauxS != "" || this.travauxS !== undefined) {
        let url = this.domaine + "tache/travaux/" + this.tacheCourante.id;
        this.$http.get(url).then(response => {
          this.listeTacheTrx = response.body.taches;
          this.loading = false;
          if (this.listeTacheTrx.length <= 0) {
            this.dialogPlanifProduit = false;
            this.$message.error("Veuillez definir des taches pour se travaux");
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner une tache");
        this.loading = false;
      }
    },

    closeDialogProjet() {
      this.showMatrice = false;
      this.dialogShowProjet = false;
      this.showCompteExploit = false;
    },

    calculTotalTache(index) {
      let item = this.optionTache[index];
      let oldTotal = this.optionTache[index].total;
      if (oldTotal != undefined) {
        this.totalHT -= oldTotal;
      }

      let total = item.qte * item.prix;
      if (total != undefined) {
        this.optionTache[index].total = total;
        this.totalHT += total;
      }
    },

    calculMntTache() {
      this.totalHT = 0;
      for (let index in this.optionTache) {
        let item = this.optionTache[index];
        let total = item.qte * item.prix;
        if (total != undefined) {
          this.totalHT += total;
          this.optionTache[index].total = total;
        }
      }
    },

    handleTabClick(tab) {
      this.showMatrice = false;
      switch (tab) {
        case "1":
          this.showCompteExploit = true;
          this.showMatrice = false;
          break;
        case "2":
          this.showMatrice = true;
          this.showCompteExploit = false;
          break;
        default:
          this.showMatrice = false;
          this.showCompteExploit = false;
          break;
      }
    },
    handleTabClickTravaux(obj, e) {
      let item = obj.$attrs.idTravau
      this.listTravauxRow = []
      this.listTachesRow = []
      this.listCommandesRow = []
      this.listRessourcesRow = []
     this.loadTravauxRow(item)
    },
    handleTabClickTaches(tab) {
      let item = this.listTravauxRow.idTrx
       switch (tab.index) {
        case "0":
         this.loadTachesTravaux(item)
        break;
        case "1":
            this.loadRessourcesTravaux(item)
          break;
        case "2":
          this.loadCommandesTravaux(item)
        break;
      }

    },
    loadTravauxRow(idTravaux) {
    this.loading = true;
      // this.listTravauxRow = []
       let url =
          this.domaine +
          "projet/chantier/" +
          this.selectSearchChantierFindSuivi +
          "/travaux/"+idTravaux;
        this.$http.get(url).then(response => {
          if (response.body) {
            this.loading = false;
            this.listTravauxRow = response.body.travaux;
          }
        }, error => {
            this.loading = false;
            this.$message.error("L'opération a echouée");
          });
    },
    loadTachesTravaux(idTravaux) {
      this.loading = true;
      // this.listTravauxRow = []
       let url =
          this.domaine +
          "projet/chantier/" +
          this.selectSearchChantierFindSuivi +
          "/travaux/"+idTravaux+"/taches";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.loading = false;
            this.listTachesRow = response.body.taches;
          }
        }, error => {
            this.loading = false;
            this.$message.error("L'opération a echouée");
          });
    },
    loadRessourcesTravaux(idTravaux) {
       this.loading = true;
      // this.listTravauxRow = []
       let url =
          this.domaine +
          "projet/chantier/" +
          this.selectSearchChantierFindSuivi +
          "/travaux/"+idTravaux+"/ressources";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.loading = false;
            this.listRessourcesRow = response.body.ressources;
          }
          }, error => {
            this.loading = false;
            this.$message.error("L'opération a echouée");
          }
          );
    },
    loadTypeRessource() {          
          let url =this.domaine + "product/typeRessource";
            this.$http.get(url).then(response => {
              if (response.body) {
                this.listTypeRessource = response.body.types;
                this.loading = false;
              }
            });
      },
    loadCommandesTravaux(idTravaux) {
       this.loading = true;
      // this.listTravauxRow = []
       let url =
          this.domaine +
          "projet/chantier/" +
          this.selectSearchChantierFindSuivi +
          "/travaux/"+idTravaux+"/commandes";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.loading = false;
            this.listCommandesRow = response.body.commandes;
          }
        });
    },
    //demarrer une tache
    submitFormDemarrer(formName) {
      if (
        this.formDemarrer.dateDbt != "undefined" &&
        this.formDemarrer.hrDbt != null &&
        (this.formDemarrer.hrDbt != "undefined" &&
          this.formDemarrer.hrDbt != null)
      ) {
        this.loading = true;
        let url =
          this.domaine + "tache/demarrer/optionTrx/" + this.tacheSel.idOpt;
        let data = new FormData();

        let dateDbt =
          this.formDemarrer.dateDbt.getFullYear() +
          "-" +
          this.formDemarrer.dateDbt.getMonth() +
          "-" +
          this.formDemarrer.dateDbt.getDate();
        let hrDbt =
          this.formDemarrer.hrDbt.getHours() +
          ":" +
          this.formDemarrer.hrDbt.getMinutes();

        data.append("dateDbt", dateDbt);
        data.append("hrDbt", hrDbt);
        data.append("idUser",this.user.id);
        this.$http.post(url, data).then(
          response => {
            this.loading = false;
            //reinitialiser le formulaire
            this.dialogDemarrer = false;
            let mess = response.body.message;
            this.loadChantierSuivie();
            this.$notify({
              title: "ENREGISTREMENT REUSSI",
              message: mess,
              type: "success",
              position: "top-center"
            });
          },
          erreur => {
            //reinitialiser le formulaire
            this.resetForm("formDemarrer");
            this.loading = false;
            this.$message.error("L'opération a echouée");
          }
        );
      } // verifie champs date
      else {
        this.$message.error(
          "Veuillez remplir correctement la date et l'heure svp..."
        );
      }
    },

    //Liste ouvrier
    showOuvrier(tache) {
      this.showSelTache = false;
      this.tacheSel = tache;
      this.showSelTache = true;
    },

    //image projet
    onFileProjPicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }
      if (files[0].size > 1048576) {
        this.$message.error("La taille du fichier est supérieur à 1024 ko");
        return;
      }

      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.imageProjet = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.fichierProj.push(files[0]);
    },

    //TACHES TRAVAUX
    showModalTache(trx) {
      this.detailTravaux = trx;
      this.showDetailTache = true;
    },
    //DASHBOARD PROJET
    modalDashboardProjet(item) {
      this.detailProjet = item;
      this.showDetailProjet = true;
    },
    //DASHBOARD CHANTIER
    modalDashboardChantier(item) {
      this.detailChantier = item;
      this.showDetailChantier = true;
    },

    //CHARGEMENT DES MARQUEURS DE LA CARTE
    loadMarqueurProjet() {
      this.loading = true;
      let url = this.domaine + "projet/index";
      this.$http.get(url).then(
        response => {
          this.loading = false;
          const items = response.body.projet;
          for (var i = 0; i < items.length; i++) {
            this.dataMarqueurProj.push({
              lat: items[i].lat,
              lng: items[i].lng,
              evolutionNbr: items[i].evolutionNbr,
              dateD: items[i].dateD,
              dateF: items[i].dateF,
              adresse: items[i].adresse,
              couleurMarker: items[i].couleurMarker,
              libelle: items[i].libelle,
              urlImage: items[i].urlImage,
              mntMarche: items[i].mntMarche,
              montantTotalDepenseNbr: items[i].montantTotalDepenseNbr,
              marge: items[i].marge
            });
          }
        },
        response => {
          this.loading = false;
          this.$message.error(
            "erreur lors du chargement des coordonnees des projets"
          );
        }
      );
    },
    //Controlle de l'activation du boutton deroulez
    activationDerouler() {
      this.activDerouler
        ? (this.activDerouler = false)
        : (this.activDerouler = true);
    },
    statsAllProjet() {
      this.loading = true;
      let url = this.domaine + "projet/stats/all/projet";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.statsGeneralAll = response.body.pie;
          this.statsMontantAll = response.body.piemontant;
          this.statsCommandeAll = response.body.piecom;
          this.statEtatGeneralAll();
          this.statEtatMontantAll();
          this.statEtatCommandeAll();
          this.loading = false;
        }
      });
    },
    statEtatGeneralAll() {
      let option = {
        title: {
          text: this.statsGeneralAll.libelle,
          subtext: this.statsGeneralAll.libelleSub,
          x: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: ["EN ATTENTE", "EN COURS", "TERMINE"]
        },
        series: [
          {
            name: this.statsGeneralAll.libelleSub,
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: [
              { value: this.statsGeneralAll.enAttente, name: "EN ATTENTE" },
              { value: this.statsGeneralAll.enCours, name: "EN COURS" },
              { value: this.statsGeneralAll.termine, name: "TERMINE" }
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      };

      let chartEtatGeneralAll = echarts.init(
        document.getElementById("chartEtatGeneralAll")
      );
      chartEtatGeneralAll.setOption(option);
    },
    statEtatMontantAll() {
      let option = {
        title: {
          text: this.statsMontantAll.libelle,
          subtext: this.statsMontantAll.libelleSub,
          x: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: ["MAIN D'OEUVRE", "COMMANDE", "MISSION"]
        },
        series: [
          {
            name: this.statsMontantAll.libelleSub,
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: [
              { value: this.statsMontantAll.mainOuvre, name: "MAIN D'OEUVRE" },
              { value: this.statsMontantAll.commande, name: "COMMANDE" },
              { value: this.statsMontantAll.mission, name: "MISSION" }
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      };

      let chartEtatMontantAll = echarts.init(
        document.getElementById("chartEtatMontantAll")
      );
      chartEtatMontantAll.setOption(option);
    },
    statEtatCommandeAll() {
      let optionCom = {
        title: {
          text: this.statsCommandeAll.libelle,
          subtext: this.statsCommandeAll.libelleSub,
          x: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: ["NON LIVRE", "LIVRE"]
        },
        series: [
          {
            name: this.statsCommandeAll.libelleSub,
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: [
              { value: this.statsCommandeAll.nonLivre, name: "NON LIVRE" },
              { value: this.statsCommandeAll.livre, name: "LIVRE" }
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      };

      let chartEtatCommandeAll = echarts.init(
        document.getElementById("chartEtatCommandeAll")
      );
      chartEtatCommandeAll.setOption(optionCom);
    },
    statEtatGeneral() {
      let option = {
        title: {
          text: this.searchResultEtat.libelle,
          subtext: this.searchResultEtat.libelleSub,
          x: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: ["EN ATTENTE", "EN COURS", "TERMINE"]
        },
        series: [
          {
            name: this.searchResultEtat.libelleSub,
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: [
              { value: this.searchResultEtat.enAttente, name: "EN ATTENTE" },
              { value: this.searchResultEtat.enCours, name: "EN COURS" },
              { value: this.searchResultEtat.termine, name: "TERMINE" }
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      };

      let chartEtatGeneral = echarts.init(
        document.getElementById("chartEtatGeneral")
      );
      chartEtatGeneral.setOption(option);
    },
    statEtatMontant() {
      let option = {
        title: {
          text: this.searchResultEtatMontant.libelle,
          subtext: this.searchResultEtatMontant.libelleSub,
          x: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: ["MAIN D'OEUVRE", "COMMANDE", "MISSION"]
        },
        series: [
          {
            name: this.searchResultEtatMontant.libelleSub,
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: [
              {
                value: this.searchResultEtatMontant.mainOuvre,
                name: "MAIN D'OEUVRE"
              },
              {
                value: this.searchResultEtatMontant.commande,
                name: "COMMANDE"
              },
              { value: this.searchResultEtatMontant.mission, name: "MISSION" }
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      };

      let chartEtatMontant = echarts.init(
        document.getElementById("chartEtatMontant")
      );
      chartEtatMontant.setOption(option);
    },
    statEtatCommande() {
      let optionCom = {
        title: {
          text: this.searchResultEtatCommande.libelle,
          subtext: this.searchResultEtatCommande.libelleSub,
          x: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: ["NON LIVRE", "LIVRE"]
        },
        series: [
          {
            name: this.searchResultEtatCommande.libelleSub,
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: [
              {
                value: this.searchResultEtatCommande.nonLivre,
                name: "NON LIVRE"
              },
              { value: this.searchResultEtatCommande.livre, name: "LIVRE" }
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      };

      let chartEtatCommande = echarts.init(
        document.getElementById("chartEtatCommande")
      );
      chartEtatCommande.setOption(optionCom);
    },
    submitformManoeuvre(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          // enregistrement des ouvriers
          let url = this.domaine + "ouvrier/new";
          var form = document.getElementById("formManoeuvre");
          var data = new FormData(form);
          data.append("nom", this.formManoeuvre.nom);
          data.append("domicile", this.formManoeuvre.domicile);
          data.append("profession", this.formManoeuvre.profession);
          data.append("piece", this.formManoeuvre.piece);
          data.append("contact", this.formManoeuvre.contact);
          data.append("numPiece", this.formManoeuvre.numPiece);
          data.append("dateNaiss", this.formManoeuvre.dateNaiss);
          this.$http.post(url, data).then(
            response => {
              this.loadOuvrier();
              this.loading = false;
              this.dialogAjoutOuvrier = false;

              this.$message({
                message: "L'enregistrement sest deroule avec succes ",
                type: "success"
              });
            },
            response => {
              this.loading = false;
              this.$message.error(
                "Erreur lors de l'enregistrement d'un manoeuvre "
              );
            }
          );
        }
      });
    },
    showDialogAjoutOuvrier() {
      this.dialogAjoutOuvrier = true;
      this.formManoeuvre.nom = "";
      this.formManoeuvre.domicile = "";
      this.formManoeuvre.profession = "";
      this.formManoeuvre.contact = "";
      this.formManoeuvre.piece = "";
      this.formManoeuvre.numPiece = "";
      this.formManoeuvre.dateNaiss = "";
      this.logoOuvrier = "/static/img-doc.png";
      this.optionE.selectType = "";
      this.optionE.fournisseur = "";
      this.optionE.ouvrier = "";
      this.optionE.duree = "";
      this.optionE.montant = "";
      this.optionE.montantSupp = "";
    },
    querySearchOuvrier(queryString, cb) {
      var links = this.listOuvrier;
      var results = queryString
        ? links.filter(this.createFilterOuvrier(queryString))
        : links;
      // call callback function to return suggestions
      cb(results);
    },
    isValidDateTrx() {
      if (this.idChantMod != null) {
        return false;
      }

      if (
        this.chantierCourant.dateD != null &&
        this.chantierCourant.dateF != null
      ) {
        let tabDateDbt = this.chantierCourant.dateD.split("-"); //["16","08","2018 00:00:00"]
        let jr = tabDateDbt[0];
        let mois = tabDateDbt[1];
        let annee = tabDateDbt[2].split(" ")[0];
        let hr = tabDateDbt[2].split(" ")[1];
        let dateDbt = annee + "-" + mois + "-" + jr + "T" + hr;
        let dateChtDbt = new Date(dateDbt);
        let tabDateFin = this.chantierCourant.dateF.split("-");
        let jrF = tabDateFin[0];
        let moisF = tabDateFin[1];
        let anneeF = tabDateFin[2].split(" ")[0];
        let hrF = tabDateFin[2].split(" ")[1];
        let dateFin = anneeF + "-" + moisF + "-" + jrF + "T" + hrF;
        let dateChtFin = new Date(dateFin);

        if (
          this.selectTravaux != "" &&
          this.selectChefTravaux != "" &&
          this.dateD != null &&
          this.dateF != null &&
          (this.dateF <= dateChtFin && this.dateF >= dateChtDbt) &&
          (this.dateD <= dateChtFin && this.dateD >= dateChtDbt) &&
          this.dateF >= this.dateD
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    loadGanttParam() {
      //planning de gantt
      gantt.config.fit_tasks = true;
      gantt.config.readonly = true;
      gantt.attachEvent("onTaskSelected", id => {
        let task = gantt.getTask(id);
        this.$emit("task-selected", task);
      });

      gantt.config.scale_unit = "month";
      gantt.config.date_scale = "%F, %Y";

      //default columns definition
      gantt.config.columns = [
        { name: "text", label: "Projet", width: "*", tree: true },
        { name: "start_date", label: "Date initiale", align: "center" },
        { name: "duration", label: "Durée", align: "center" }
      ];

      //langue
      gantt.locale = {
        date: {
          month_full: [
            "Janvier",
            "Février",
            "Mars",
            "Avril",
            "Mai",
            "Juin",
            "Juillet",
            "Août",
            "Septembre",
            "Octobre",
            "Novembre",
            "Décembre"
          ],
          month_short: [
            "Jan",
            "Fév",
            "Mar",
            "Avr",
            "Mai",
            "Juin",
            "Juil",
            "Aôu",
            "Sep",
            "Oct",
            "Nov",
            "Déc"
          ],
          day_full: [
            "Dimanche",
            "Lundi",
            "Mardi",
            "Mercredi",
            "Jeudi",
            "Vendredi",
            "Samedi"
          ],
          day_short: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"]
        },
        labels: {
          new_task: "Tâche neuve",
          icon_save: "Enregistrer",
          icon_cancel: "Annuler",
          icon_details: "Détails",
          icon_edit: "Modifier",
          icon_delete: "Effacer",
          confirm_closing: "", //Vos modifications seront perdus, êtes-vous sûr ?
          confirm_deleting:
            "L'événement sera effacé sans appel, êtes-vous sûr ?",

          section_description: "Description",
          section_time: "Période",
          section_type: "Type",

          /* grid columns */
          column_text: "Tâche neuve",
          column_start_date: "Date initiale",
          column_duration: "Durée",
          column_add: "",

          /* link confirmation */
          confirm_link_deleting: "seront supprimées",
          link_start: "(début)",
          link_end: "(fin)",

          type_task: "Task",
          type_project: "Project",
          type_milestone: "Milestone",

          minutes: "Minutes",
          hours: "Heures",
          days: "Jours",
          weeks: "Semaine",
          months: "Mois",
          years: "Années"
        }
      };
      gantt.init(this.$refs.gantt);
      gantt.clearAll();
      gantt.parse(this.tasks);
    },
    loadPage() {
      this.loading = true;
    },
    showPlanning(idChantier) {
      this.loadPlanning(idChantier);
    },
    loadPlanning(idChantier) {
      this.loading = true;
      let url = this.domaine + "chantier/planning/" + idChantier;
      this.$http.get(url).then(
        response => {
          this.libProjet = response.body.libProjet;
          this.chefProjet = response.body.chefProjet;
          this.libChantier = response.body.libChantier;
          this.chefChantier = response.body.chefChantier;
          this.tasks.data.splice(0);

          if (
            response.body.data != undefined &&
            response.body.data.length > 0
          ) {
            let data = response.body.data;
            this.tasks.data.push(...data);
            let tabTrx = [];
            let link = response.body.data.map(elt => {
              if (elt.start_date == undefined) {
                tabTrx.push(elt.id);
                if (tabTrx[tabTrx.length - 2] != undefined) {
                  let idPrec = tabTrx[tabTrx.length - 2];
                  let idlast = tabTrx[tabTrx.length - 1];
                  return {
                    id: elt.id,
                    source: idPrec,
                    target: idlast,
                    type: "1"
                  };
                }
                return {};
              } else {
                return {
                  id: elt.id,
                  source: elt.id,
                  target: elt.id + 1,
                  type: "1"
                };
              }
            });

            this.tasks.links.push(...link);
            this.loading = false;
          } else {
            this.tasks.data.splice(0);
            this.loading = false;
          }

          this.$router.push({
            name: "Planning",
            params: {
              id: idChantier,
              libProjet: this.libProjet,
              chefProjet: this.chefProjet,
              libChantier: this.libChantier,
              chefChantier: this.chefChantier,
              tasks: this.tasks
            }
          });
        },
        response => {
          this.loading = false;
          this.$message.error("erreur lors du chargement des travaux");
        }
      );
    },
    loadPlanningProjet(ligne) {
      this.loading = true;
      let url = this.domaine + "projet/planning/" + ligne.id;
      this.$http.get(url).then(
        response => {
          this.tasks.data.splice(0);
          this.tasks.links.splice(0);
          if (
            response.body.data !== undefined &&
            response.body.data.length > 0
          ) {
            let data = response.body.data;
            this.tasks.data.push(...data);
            let tabTrx = [];
            let link = response.body.data.map(elt => {
              if (elt.start_date === undefined) {
                tabTrx.push(elt.id);
                if (tabTrx[tabTrx.length - 2] !== undefined) {
                  let idPrec = tabTrx[tabTrx.length - 2];
                  let idlast = tabTrx[tabTrx.length - 1];
                  return {
                    id: elt.id,
                    source: idPrec,
                    target: idlast,
                    type: "1"
                  };
                }
                return {};
              } else {
                return {
                  id: elt.id,
                  source: elt.id,
                  target: elt.id + 1,
                  type: "1"
                };
              }
            });

            this.tasks.links.push(...link);
            //this.loadGanttParam()
            this.loading = false;
          } else {
            this.tasks.data.splice(0);
            this.tasks.links.splice(0);
            this.loading = false;
          }
        },
        response => {
          this.loading = false;
          this.$message.error("erreur lors du chargement des chantiers");
        }
      );
    },
    loadUser() {
      this.loading = true;
      let url = this.domaine + "userCreate/user-list";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.users = response.body;
          this.loading = false;
        }
      });
    },
    loadUniteProduit(item) {
      let valeur;
      this.valeurUniteMateriel =''
      valeur = this.listeProduitAffich.find(function(element) {
        if (element.value == item) {
          return element.unite;
        }
      });
      this.valeurUniteMateriel = valeur.unite;
    },
    loadTypeProduit(item) {
      if (this.$refs.typeProduit == "") {
        return;
      }
      this.loading = true;
      let url = this.domaine + "product/productSelect/type/" + item;
      this.$http.get(url).then(
        response => {
          this.loading = false;
          this.listeProduitAffich = response.body.produits;
        },
        errRep => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement de la liste du chntier"
          );
        }
      );
    },
    loadPrestaire() {
      this.loading = true;
      let url = this.domaine + "fournisseur/listePrestataire/index";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listPrestataire = response.body.prestataire;
          this.loading = false;
        }
      });
    },
    loadClient() {
      this.loading = true;
      let url = this.domaine + "client/projet/index";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listClient = response.body.client;
          this.loading = false;
        }
      });
    },
    onFileImageChantPicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.logoChantier = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoChantier = files[0];
    },
    onFileImageLogoPicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.logoProjet = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoProjet = files[0];
    },
    onFileImageOuvrierPicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.logoOuvrier = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoOuvrier = files[0];
    },
    loadProduit(queryString, cb) {
      let url = this.domaine + "product/product-list";
      var formdata = new FormData();
      formdata.append("user", this.user.id);
      formdata.append("tag", queryString);
      this.$http.post(url, formdata).then(
        response => {
          if (response.body) {
            this.listProd = response.body;
            var links = response.body;
            var results = queryString
              ? links.filter(this.createFilter(queryString))
              : links;
            cb(results);
          }
        },
        response => {}
      );
    },
    loadProduitPlan() {
      this.loading = true;
      let url = this.domaine + "product/product-list/type";
      var formdata = new FormData();
      formdata.append("user", this.user.id);
      this.$http.post(url, formdata).then(
        response => {
          if (response.body) {
            this.loading = false;
            this.listProdPlan = response.body.produits;
            this.listVehPlan = response.body.vehicules;
          }
        },
        response => {
          this.loading = false;
        }
      );
    },
    loadProdVehicule(queryString, cb) {
      let url = this.domaine + "product/productVehicule-list";
      var formdata = new FormData();
      formdata.append("user", this.user.id);
      formdata.append("tag", queryString);
      this.$http.post(url, formdata).then(
        response => {
          if (response.body) {
            this.listProd = response.body;
            var links = response.body;
            var results = queryString
              ? links.filter(this.createFilter(queryString))
              : links;
            cb(results);
          }
        },
        response => {}
      );
    },

    loadCaisse() {
      let url = this.domaine + "caisse/caisse_banque_projet";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listCaisse = response.body.listeCaisse;
          this.listBanque = response.body.listeBanque;
        }
      });
    },
    loadOuvrier() {
      let url = this.domaine + "ouvrier/index";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listOuvrier = response.body.ouvrier;
        }
      });
    },
    loadOuvrierSelect(queryString, cb) {
      let url = this.domaine + "ouvrier/index";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listOuvrier = response.body.ouvrier;

          var links = response.body.ouvrier;
          var results = queryString
            ? links.filter(this.createFilter(queryString))
            : links;
          cb(results);
        }
      });
    },
    loadTypeProjet() {
      let url = this.domaine + "projet/index/type/projet";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listTypeProjet = response.body.type;
        }
      });
    },
       generateFileExcel() {
         this.dialogImport = false
        let url = this.domaine + "projet/generer/planification/modele";
        window.open(url);
      },
      onFileExcelPicked(event) {
        this.fileExcel.splice(0, 1);
        // this.dialogAjoutBudget = false

        const files = event.target.files;
        let filename = files[0].name;
        if (filename.lastIndexOf(".xls") <= 0) {
          return alert("Veuillez selectionner un fichier excel valide ");
        }
        if (files[0].size > 1048576) {
          this.$message.error("La taille du fichier est supérieur à 1024 ko");
          return;
        }
        const fileReader = new FileReader();
        fileReader.addEventListener("load", () => {
          this.fileExcel.push(fileReader.result);
        });
        fileReader.readAsDataURL(files[0]);

        let url = this.domaine + "projet/loadPreparation/excel";
        let data = new FormData();
        data.append("fichierExcel", files[0], files[0][name]);
        this.$http.post(url, data).then(
          resp => {
            this.loading = false;
            this.$notify({
              title: "Chargement liste des ressources à importer",
              message: "Chargement effectué",
              type: "success",
              position: "top-right",
              duration: 7000
            });
            this.showModalLoadPreparation = true;

            this.lstPreparation = resp.body.listePreration;            
          },
          error => {
            this.loading = false;
            this.$message.error("Erreur lors de l'importation du fichier");
          }
        );
      },
    saveListe(){
            // this.loadPage()
            this.loading = true
            let succesEnreg = true;
            let url = this.domaine + "projet/save/preparation/excel/"+this.tacheCourante.id;
            let nbData = 10;
            let nbReq = 1;
            let ligne = null;

            let nbRest
            if (this.lstPreparation.length > 10) {
              nbData = 10;
              nbReq = Math.round(this.lstPreparation.length / nbData);
              nbRest = this.lstPreparation.length % nbData;
              if (nbRest > 0) {
                nbReq += 1;
              }
            }
            for(let i=0; i<nbReq;i++)
            {
                let initJ = i*nbData;
                let finJ = (i + 1) * nbData;
                let dataLot = [];
                if(this.lstPreparation.length > 0){
                    for(let j = initJ;j < finJ;j++){
                        if(this.lstPreparation[j] == undefined){
                            break ;
                        }
                        dataLot.push(this.lstPreparation[j]);
                    }
                }
                let data = new FormData();
                for (let prop in dataLot) {
                    ligne = dataLot[prop];
                    data.append("option[tache][]", ligne.tache);
                    data.append("option[ressource][]", ligne.ressource);
                    data.append("option[quantite][]", ligne.quantite);
                    // data.append("option[unite][]", ligne.unite);
                    // // data.append("option[date][]", ligne.date);
                  }                
                data.append('idUser', this.user.id)
                data.append('idTypeTravaux', this.tacheCourante.idTypeTravaux)
                data.append('travaux', this.tacheCourante.idTrx)
                this.$http.post(url, data).then(
                    resp => {
                  this.showModalLoadPreparation = false
                  this.dialogPlanifProduit = false
                    this.loading = false
                    if(resp.code === 2) {
                        succesEnreg = false                          
                        this.$notify({
                        title: "Enregistrement",
                        message: "La liste a ete enregistre avec succes",
                        type: "success",
                        position: "top-right",
                        duration: 7000
                    });
                    }else {
                        succesEnreg = false                          
                        this.$notify({
                        title: "Erreur",
                        message: resp.message,
                        type: "info",
                        position: "top-right",
                        duration: 7000
                    });
                    }                      
                    },
                    error => {
                        this.loading = false;
                        succesEnreg = false
                        this.$message.error(
                            "Erreur lors de l'enregistrement des types travaux"
                        );
                    }
                )
            }
    },

    loadTache() {
      this.loading = true;
      this.optionTache = [];
      if (this.selectTravaux != "") {
        let url =
          this.domaine + "projet/" + this.selectTravaux + "/index/tache";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.optionTache = response.body.tache;
            this.calculMntTache();
            this.loading = false;
          }
        });
      } else {
        this.$notify({
          title: "ATTENTION",
          message: "Veuillez sélectionner des travaux.",
          type: "warning"
        });
        this.loading = false;
      }
    },
    loadTacheParTravaux() {
      this.loading = true;
      this.optionTache = [];
      if (this.selectTravaux != "") {
        let url =
          this.domaine +
          "projet/travaux_tache/" +
          this.travauxCourant.id +
          "/index/tache";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.optionTache = response.body.tache;
            this.calculMntTache();
            this.loading = false;
          }
        });
      } else {
        this.$notify({
          title: "ATTENTION",
          message: "Veuillez sélectionner des travaux.",
          type: "warning"
        });
        this.loading = false;
      }
    },
    loadTravaux() {
      this.loading = true;
      this.selectSearchTravaux = "";
      this.listTravaux = [];

      if (this.selectSearchChantier !== "") {
        let url =
          this.domaine +
          "projet/" +
          this.selectSearchChantier +
          "/index/chantier/travaux";
        this.$http.get(url).then(response => {
          this.listTravaux = response.body.travaux;
          this.loading = false;
        });
      } else {
        this.$message.error("Veuillez sélectionner un chantier");
        this.loading = false;
      }
    },
    loadTravauxSuivi() {
      if (
        this.selectSearchChantierSuivi !== "" ||
        this.selectSearchChantier !== "" ||
        this.selectChantierRapport !== ""
      ) {
        this.loading = true;
        this.selectSearchTravauxSuivi = "";
        this.selectTravauxRapport = "";
        this.listTravaux = [];
        this.listTacheRapport = [];
        let idChantierSearch = "";
        if (this.selectSearchChantierSuivi !== "") {
          this.selectSearchChantier = "";
          this.selectChantierRapport;
          idChantierSearch = this.selectSearchChantierSuivi;
        } else if (this.selectSearchChantier !== "") {
          this.selectSearchChantierSuivi = "";
          this.selectChantierRapport;
          idChantierSearch = this.selectSearchChantier;
        } else if (this.selectChantierRapport !== "") {
          this.selectSearchChantierSuivi = "";
          this.selectSearchChantier = "";
          idChantierSearch = this.selectChantierRapport;
        }

        if (this.idChantierSearch !== "") {
          let url =
            this.domaine +
            "projet/" +
            idChantierSearch +
            "/index/chantier/travaux";
          this.$http.get(url).then(response => {
            this.listTravaux = response.body.travaux;
            this.loading = false;
          });
        } else {
          this.$message.error("Veuillez sélectionner un chantier");
          this.loading = false;
        }
      }
    },
    loadTravauxSearch() {
      this.loading = true;
      this.selectSearchChantierFind = "";
      this.listChantierResult = [];
      this.listTravauxResult = [];
      if (
        this.$refs.formSearchPlanif.validate() &&
        this.selectSearchTravaux != ""
      ) {
        let url = this.domaine + "projet/index/travaux/result";
        var form = document.getElementById("formSearchPlanif");
        var data = new FormData(form);
        data.append("id", this.selectSearchTravaux);
        this.$http.post(url, data).then(response => {
          if (response.body) {
            this.listTravauxResult = response.body.travaux;
            this.loading = false;
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner les travaux");
        this.loading = false;
      }
    },
    loadTravauxSuivie() {
      this.loading = true;
      this.selectSearchChantierFindSuivi = "";
      this.listChantierSuivie = [];
      this.listTravauxSuivie = [];
       this.listTravauxRow = []
      this.listTachesRow = []
      this.listCommandesRow = []
      this.listRessourcesRow = []
      this.optionRapport = [];
      let idTravauxResult = "";
      if (this.selectSearchTravauxSuivi !== "") {
        this.selectTravauxRapport = "";
        idTravauxResult = this.selectSearchTravauxSuivi;
      } else if (this.selectTravauxRapport !== "") {
        this.selectSearchTravauxSuivi = "";
        idTravauxResult = this.selectTravauxRapport;
      }
      if (
        this.$refs.formSearchPlanifSuivi.validate() &&
        idTravauxResult != ""
      ) {
        let url =
          this.domaine + "projet/" + idTravauxResult + "/index/travaux/suivi";
        this.$http.get(url).then(response => {
          if (response.body) {
            let msg = "";
            let typeN = "";
            this.listTravauxSuivie = response.body.travaux;
            this.optionRapport = response.body.tache;
            if (
              this.listTravauxSuivie === undefined ||
              this.listTravauxSuivie.length == 0
            ) {
              this.disabledBtnCP = true;
            } else {
              this.disabledBtnCP = false;
            }

            if (this.optionRapport.length == 0) {
              this.$notify({
                title: "RESULTATS",
                message:
                  "Aucune tâche en cours d'execution ou démarré n'a été retrouvé pour ces travaux.",
                type: "warning",
                position: "top-center"
              });
            } else if (this.optionRapport.length > 0) {
              this.$notify({
                title: "RESULTATS",
                message: this.optionRapport.length + " tâche(s) trouvée(s).",
                type: "success",
                position: "top-center"
              });
            }

            this.loading = false;
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner les travaux.");
        this.loading = false;
      }
    },
    loadTravauxProjet(
      item //charge le types de travaux lie au chantier ou au projet
    ) {
      this.loading = true;
      this.projetCourant = item;
      let url =
        this.domaine +
        "projet/" +
        this.projetCourant.id +
        "/index/travaux/projet";

      if (this.projetCourant.type != null) {
        url =
          this.domaine +
          "projet/" +
          this.projetCourant.id +
          "/index/travaux/projet";
      } else {
        url =
          this.domaine + "chantier/" + this.chantierCourant.id + "/typeTravaux";
      }

      this.$http.get(url).then(
        response => {
          if (response.body) {
            this.listTravauxProjet = response.body.travaux;
            this.loading = false;
          }
        },
        response => {}
      );
    },

    loadTravauxChantier(item) {
      this.loading = true;
      this.chantierCourant = item;
      let url = "";
      if (this.chantierCourant.typeChantier != null) {
        url =
          this.domaine +
          "chantier/" +
          this.chantierCourant.idChantier +
          "/typeTravaux";
      } else {
        url =
          this.domaine +
          "projet/typetrx/chantier/" +
          this.chantierCourant.idChantier;
      }
      this.$http.get(url).then(
        response => {
          if (response.body) {
            this.listTravauxProjet = response.body.travaux;
            this.loading = false;
          }
        },
        response => {}
      );
    },
    loadEditTravaux(idChantier) {
      this.loading = true;
      let url = this.domaine + "projet/typetrx/all/chantier/" + idChantier;
      this.$http.get(url).then(
        response => {
          if (response.body) {
            this.listTravauxProjet = response.body.travaux;
            this.loading = false;
          }
        },
        response => {}
      );
    },
    loadProjetAll() {
      this.loading = true;
      let url = "";
      if (this.droitAcces.projet_all_index) {
        //vérification pour un user
        url = this.domaine + "projet/index-projet-all";
      } else if (this.droitAcces.projet_index) {
        url = this.domaine + "projet/index";
      } else if (this.droitAcces.projet_index_chefProjet) {
        //vérification pour le chef de projet
        url = this.domaine + "projet/" + this.user.id + "/chefProjet/index";
      } else if (this.droitAcces.projet_index_chefEtude) {
        //vérification pour le chef d'Etude
        url = this.domaine + "projet/" + this.user.id + "/chefEtude/index";
      } else if (this.droitAcces.projet_index_chefControle) {
        //vérification pour le chef d'Etude
        url = this.domaine + "projet/" + this.user.id + "/chefControle/index";
      }
      this.$http.get(url).then(response => {
        if (response.body) {
          this.items = response.body.projet;
          this.loading = false;
        }
      });
    },
    loadProjet() {
      this.loading = true;
      this.listProjetResult = [];
      if (this.$refs.formSearchProjet.validate()) {
        let url = "";
        url = this.domaine + "projet/index";
        // if (this.droitAcces.projet_index) {
        //   url = this.domaine + "projet/index";
        // } else if (this.droitAcces.projet_index_chefProjet) {
        //   //vérification pour le chef de projet
        //   url = this.domaine + "projet/" + this.user.id + "/chefProjet/index";
        // } else if (this.droitAcces.projet_index_chefEtude) {
        //   //vérification pour le chef d'Etude
        //   url = this.domaine + "projet/" + this.user.id + "/chefEtude/index";
        // } else if (this.droitAcces.projet_index_chefControle) {
        //   //vérification pour le chef d'Etude
        //   url = this.domaine + "projet/" + this.user.id + "/chefControle/index";
        // }

        var form = document.getElementById("formSearchProjet");
        var data = new FormData(form);
        data.append("id", this.selectSearchProjet);
        this.$http.post(url, data).then(response => {
          this.loading = false;
          if (response.body.projet.length > 0) {
            this.listProjetResult = response.body.projet;
            this.nbChantier = response.body.projet[0].nbChantier;

            if (
              this.notif === "active" &&
              response.body.progression === false
            ) {
              this.$vs.notify({
                title: "PROGRESSION",
                text:
                  "Les progressions journalières des différentes tâches attendent",
                type: "warning",
                position: "top-right",
                icon: "timeline",
                duration: 5000
              });
            }

            if (this.notif === "active" && response.body.rapport === true) {
              this.$vs.notify({
                title: "RAPPORT",
                text:
                  "Les rapports journaliers des différentes tâches attendent",
                color: "danger",
                position: "top-right",
                icon: "description",
                duration: 5000
              });
            }

            this.loading = false;
          }
        });
      }
    },

    loadListeProjet() {
      this.loading = true;
      this.listProjetResult = [];
      if (this.$refs.formSearchProjet.validate()) {
        let url = "";
        if (this.droitAcces.projet_all_index) {
          //vérification pour un user
          url = this.domaine + "projet/index-projet-all";
        } else if (this.droitAcces.projet_index_chefProjet) {
          //vérification pour le chef de projet
          url = this.domaine + "projet/" + this.user.id + "/chefProjet/index";
        } else if (this.droitAcces.projet_index_user) {
          //vérification pour un user
          url = this.domaine + "projet/" + this.user.id + "/index";
        } else if (this.droitAcces.projet_index) {
          url = this.domaine + "projet/index";
        } else if (this.droitAcces.projet_index_chefEtude) {
          //vérification pour le chef d'Etude
          url = this.domaine + "projet/" + this.user.id + "/chefEtude/index";
        } else if (this.droitAcces.projet_index_chefControle) {
          //vérification pour le chef d'Etude
          url = this.domaine + "projet/" + this.user.id + "/chefControle/index";
        }

        var form = document.getElementById("formSearchProjet");
        var data = new FormData(form);
        data.append("id", this.selectSearchProjet);
        this.$http.post(url, data).then(response => {
          if (response.body) {
            this.loading = false;
            this.items = response.body.projet;
            if (
              this.notif === "active" &&
              response.body.progression === false
            ) {
              this.$vs.notify({
                title: "PROGRESSION",
                text:
                  "Les progressions journalières des différentes tâches attendent",
                type: "warning",
                position: "top-right",
                icon: "timeline",
                duration: 5000
              });
            }
            if ((this.notif = "active" && response.body.rapport === true)) {
              this.$vs.notify({
                title: "RAPPORT",
                text:
                  "Les rapports journalières des différentes tâches attendent",
                color: "danger",
                position: "top-right",
                icon: "description",
                duration: 5000
              });
            }
          }
        });
      }
    },
    loadChantier(item) {
      this.loading = true;
      this.projetCourant = item;
      let url =
        this.domaine + "projet/" + this.projetCourant.id + "/index/chantier";
      const element = document.getElementById(this.mapName);
      const options = {
        zoom: 7.0,
        gestureHandling: "greedy",
        center: new google.maps.LatLng(
          this.projetCourant.latitude,
          this.projetCourant.longitude
        )
      };
      const map = new google.maps.Map(element, options);

      this.$http.get(url).then(response => {
        if (response.body) {
          this.listChantier = response.body.chantier;
          if (
            this.listChantier === undefined ||
            this.listChantier.length == 0
          ) {
            this.disabledBtnCP = true;
          } else {
            this.disabledBtnCP = false;
          }

          for (var i = 0; i < this.listChantier.length; i++) {
            const marker = {
              lat: this.listChantier[i].latitude,
              lng: this.listChantier[i].longitude,
              lib:
                " <b style='font-weight: bold'>Adresse: </b>" +
                this.listChantier[i].adresse +
                " <br/>   <b style='font-weight: bold'>Projet: </b>" +
                this.listChantier[i].projet +
                "<br/> <b style='font-weight: bold'>Chantier: </b>" +
                this.listChantier[i].libelle +
                " <br/> <b style='font-weight: bold'>Date début: </b>" +
                this.listChantier[i].dateD +
                " <br/><b style='font-weight: bold'> Date de fin: </b>" +
                this.listChantier[i].dateF +
                " <br/><b style='font-weight: bold'> Etat d'avancement : </b> <b style='font-weight: bold; color:blue'>" +
                this.listChantier[i].evolutionNbr +
                " %</b> <br/> <b style='font-weight: bold'>Lat/Lng: </b>" +
                this.listChantier[i].latitude +
                "/" +
                this.listChantier[i].longitude,
              couleurMk: this.listChantier[i].couleurMarker
            };
            this.markers.push(marker);
          }

          //Ajout des markers
          this.markers.forEach(coord => {
            const position = new google.maps.LatLng(coord.lat, coord.lng);
            const libelle = coord.lib;
            const marker = new google.maps.Marker({
              position,
              map,
              icon: {
                path:
                  "M256,0C153.755,0,70.573,83.182,70.573,185.426c0,126.888,165.939,313.167,173.004,321.035    c6.636,7.391,18.222,7.378,24.846,0c7.065-7.868,173.004-194.147,173.004-321.035C441.425,83.182,358.244,0,256,0z M256,278.719    c-51.442,0-93.292-41.851-93.292-93.293S204.559,92.134,256,92.134s93.291,41.851,93.291,93.293S307.441,278.719,256,278.719z",
                fillColor: coord.couleurMk,
                fillOpacity: 0.8,
                scale: 0.05,
                strokeColor: coord.couleurMk,
                strokeWeight: 1
              }
            });
            this.attachSecretMessage(marker, libelle);
          });
          this.loading = false;
        }
      });
    },
    loadChantierSearch() {
      this.loading = true;
      this.selectSearchChantier = "";
      this.listTravauxResult = [];
      this.listChantierResult = [];
      if (
        this.$refs.formSearchPlanif.validate() &&
        this.selectSearchChantierFind != ""
      ) {
        let url =
          this.domaine +
          "projet/" +
          this.selectSearchChantierFind +
          "/index/chantier/search";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listChantierResult = response.body.chantier;
            this.loading = false;
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner le chantier");
        this.loading = false;
      }
    },
    loadAffSupTravaux(item) {
      this.loading = true;
      this.selectSearchChantier = "";
      this.listTravauxResult = [];
      this.listChantierResult = [];
        let url = this.domaine +"projet/" +item+"/index/chantier/search";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listChantierResult = response.body.chantier;
            this.loading = false;
          }
        });
    },
    loadChantierSuivie() {
      this.loading = true;
      this.selectSearchChantierSuivi = "";
      this.listChantierSuivie = [];
      this.listTravauxSuivie = [];
      this.listTravauxRow = []
      this.listTachesRow = []
      this.listCommandesRow = []
      this.listRessourcesRow = []
      if (
        this.$refs.formSearchPlanifSuivi.validate() &&
        this.selectSearchChantierFindSuivi != ""
      ) {
        let url =
          this.domaine +
          "projet/" +
          this.selectSearchChantierFindSuivi +
          "/index/chantier/suivi";
        this.$http.get(url).then(response => {
          this.loading = false;
          if (response.body) {
            this.loading = false;
            this.listChantierSuivie = response.body.chantier;
            if (
              this.listChantierSuivie === undefined ||
              this.listChantierSuivie.length == 0
            ) {
              this.disabledBtnCP = true;
            } else {
              this.disabledBtnCP = false;
            }

          }
        });
      } else {
        this.$message.error("Veuillez sélectionner le chantier.");
        this.loading = false;
      }
    },
    loadEquipe(item) {
      this.loading = true;
      this.travauxCourant = item;
      let url =
        this.domaine + "projet/" + this.travauxCourant.id + "/index/equipe";
      this.loading = true;
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listEquipe = response.body.equipe;
          this.loading = false;
        }
      });
    },
    loadProjetTache(item) {
      this.loading = true;
      this.projetCourant = item;
      let url =
        this.domaine +
        "projet/" +
        this.projetCourant.id +
        "/index/projet/tache";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listProjetTache = response.body.tache;
          if (
            this.listProjetTache === undefined ||
            this.listProjetTache.length == 0
          ) {
            this.disabledBtnSCTach = true;
          } else {
            this.disabledBtnSCTach = false;
          }
          this.loading = false;
        }
      });
    },
    loadProjetContrat(item) {
      this.projetCourant = item;
      let url =
        this.domaine +
        "projet/" +
        this.projetCourant.id +
        "/index/projet/contrat";
      this.loading = true;
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listProjetContrat = response.body.contrat;
          if (
            this.listProjetContrat === undefined ||
            this.listProjetContrat.length == 0
          ) {
            this.disabledBtnSCont = true;
          } else {
            this.disabledBtnSCont = false;
          }
          this.loading = false;
        }
      });
    },
    loadCommandeAValid(item) {
      this.loading = true;
      this.projetCourant = item;
      let url =
        this.domaine +
        "projet/" +
        this.projetCourant.id +
        "/index/projet/commande/avalid";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listProjetAValid = response.body.commande;
          if (
            this.listProjetAValid === undefined ||
            this.listProjetAValid.length == 0
          ) {
            this.disabledBtnSCmdeAvalid = true;
          } else {
            this.disabledBtnSCmdeAvalid = false;
          }
          this.loading = false;
        }
      });
    },
    loadCommandeAll(item) {
      this.loading = true;
      this.projetCourant = item;
      let url =
        this.domaine +
        "projet/" +
        this.projetCourant.id +
        "/index/projet/commande/all";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listProjetAll = response.body.commande;
          if (
            this.listProjetAll === undefined ||
            this.listProjetAll.length == 0
          ) {
            this.disabledBtnSCmdeAll = true;
          } else {
            this.disabledBtnSCmdeAll = false;
          }
          this.loading = false;
        }
      });
    },
    loadCommandeValid(item) {
      this.loading = true;
      this.projetCourant = item;
      let url =
        this.domaine +
        "projet/" +
        this.projetCourant.id +
        "/index/projet/commande/valid";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listProjetValid = response.body.commande;
          if (
            this.listProjetValid === undefined ||
            this.listProjetValid.length == 0
          ) {
            this.disabledBtnSCmdeValid = true;
          } else {
            this.disabledBtnSCmdeValid = false;
          }
          this.loading = false;
        }
      });
    },
    loadCommandeALivre(item) {
      this.projetCourant = item;
      let url =
        this.domaine +
        "projet/" +
        this.projetCourant.id +
        "/index/projet/commande/alivre";
      this.loading = true;
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listProjetAlivre = response.body.commande;
          if (
            this.listProjetAlivre === undefined ||
            this.listProjetAlivre.length == 0
          ) {
            this.disabledBtnSCmdeAliv = true;
          } else {
            this.disabledBtnSCmdeAliv = false;
          }
          this.loading = false;
        }
      });
    },
    loadCommandeLivre(item) {
      this.projetCourant = item;
      let url =
        this.domaine +
        "projet/" +
        this.projetCourant.id +
        "/index/projet/commande/livre";
      this.loading = true;
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listProjetlivre = response.body.commande;
          if (
            this.listProjetlivre === undefined ||
            this.listProjetlivre.length == 0
          ) {
            this.disabledBtnSCmdLiv = true;
          } else {
            this.disabledBtnSCmdLiv = false;
          }
          this.loading = false;
        }
      });
    },
    loadEngin(item) {
      this.projetCourant = item;
      let url =
        this.domaine +
        "projet/" +
        this.projetCourant.id +
        "/index/projet/engin";
      this.loading = true;
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listEngin = response.body.mission;
          if (this.listEngin === undefined || this.listEngin.length == 0) {
            this.disabledBtnSVeh = true;
          } else {
            this.disabledBtnSVeh = false;
          }
          this.loading = false;
        }
      });
    },
    loadProduitTravaux(item) {
      this.projetCourant = item;
      let url =
        this.domaine +
        "projet/" +
        this.projetCourant.id +
        "/index/projet/materiel";
      this.loading = true;
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listProduiTravaux = response.body.produit;
          if (
            this.listProduiTravaux === undefined ||
            this.listProduiTravaux.length == 0
          ) {
            this.disabledBtnSMat = true;
          } else {
            this.disabledBtnSMat = false;
          }
          this.loading = false;
        }
      });
    },
    showProjet(idProjet) {
      this.loading = true;
      this.dialogShowProjet = true;
      let url = this.domaine + "projet/" + idProjet.id + "/show";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.detailProjet = response.body.projet;
          if (this.notif === "active" && response.body.progression === false) {
            this.$vs.notify({
              title: "PROGRESSION " + this.detailProjet.libelle,
              text:
                "Les progressions journalières des différentes tâches attendent",
              type: "warning",
              position: "top-right",
              icon: "timeline",
              duration: 5000,
              click: () => {
                (this.tabb = "suivie"),
                  (this.activeSuivie = "taches"),
                  this.$vs.notify({
                    title: "TÂCHES",
                    text: "Veuillez marquer la progression",
                    color: "success",
                    icon: "timeline"
                  });
              }
            });
          }
          if (this.notif === "active" && response.body.rapport === true) {
            this.$vs.notify({
              title: "RAPPORT",
              text:
                "Les rapports journalières des différentes tâches attendent",
              color: "danger",
              position: "top-right",
              icon: "description",
              duration: 5000,
              click: () => {
                (this.tabb = "suivie"),
                  (this.activeSuivie = "taches"),
                  this.$vs.notify({
                    title: "RAPPORT",
                    text: "Veuillez faire les rapports",
                    color: "success",
                    icon: "description"
                  });
              }
            });
          }

          this.loading = false;
        }
      });
    },
    showTravaux(item) {
      this.loading = true;
      this.dialogShowTravaux = true;
      this.travauxCourant = item;
      let url =
      this.domaine + "projet/" + this.travauxCourant.id + "/travaux/show";
      this.$http.get(url).then(response => {
        if (response.body) {
        this.loading = false;
         this.detailTravaux = response.body.travaux
        }
      });
    },
      showTravauxRessource(item) {
      this.loading = true;
      this.dialogShowTravaux = true;
      this.travauxCourant = item;
      let url =
      this.domaine + "projet/" + this.travauxCourant.idTravaux + "/travaux/show";
      this.$http.get(url).then(response => {
        if (response.body) {
        this.loading = false;
         this.detailTravaux = response.body.travaux
        }
      });
    },
    showTache(item) {
      this.loading = true;
      this.tacheCourant = item;
      this.dialogShowTache = true;
      let url = this.domaine + "projet/" + this.tacheCourant.id + "/tache/show";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.detailTache = response.body.tache;
          this.loading = false;
        }
      });
    },
    showCommande(item) {
      this.commandeCourant = item;
      this.dialogShowCommande = true;
      let url =
        this.domaine +
        "fournisseur/" +
        this.commandeCourant.id +
        "/show/commande";
      this.loading = true;
      this.$http.get(url).then(response => {
        if (response.body) {
          this.detailCommande = response.body.commande;
          this.loading = false;
        }
      });
    },
    deleteRessources() {
      this.loading = true;
       let url = this.domaine + "projet/delete/ressources/" + this.idRessour+"/travaux/"+ this.detailTravaux.id;
      this.$http.get(url).then(response => {
        if (response.body) {
          this.$notify({
            title: "SUPPRESSION",
            message: "Ressource supprimé avec succès.",
            type: "success",
            position: "top-center"
          });
          this.loading = false;
          this.dialogSuprRessource = false;
          this.dialogShowTravaux = false
        }
      }, error => {
          this.loading = false;
          this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          // this.loading = false;
        });
    },

    showInfoRessources(ligne) {
      this.dialogShowInfoRessource = true
      this.tacheSelectioner = ligne;
      this.formInfoRessource.libelle = ligne.produit
      this.formInfoRessource.qte = ligne.qte
      this.formInfoRessource.dateD = ligne.dateDUtilisation
      this.formInfoRessource.dateF = ligne.dateFUtilisation
    },

    editRessources(ligne) {
      this.dialogShowEditRessource = true
      this.tacheSelectioner = ligne;
      this.formEditRessource.libelle = ligne.produit
      // this.formEditRessource.qte = ligne.qte
      this.newQteRessource = ligne.qte
      this.formEditRessource.dateD = ligne.dateDUtilisation
      this.formEditRessource.dateF = ligne.dateFUtilisation
    },
    sumbitRessource(ligne) {
       this.loading = true;
      var form = document.getElementById("formEditRessource");
      var data = new FormData(form);
      let url = "";
      // data.append("dataForm", JSON.stringify(this.formEditRessource))
      data.append("idOptBesoin",ligne.idOptBesoin)
      data.append("idOptTravaux",ligne.id)
      data.append("newQteRessource",this.newQteRessource)

      url = this.domaine + "projet/travaux/"+this.detailTravaux.id+ "/ressources/edit";
      this.$http.post(url, data).then(
        response => {
          this.loading = false;
          if (response.body) {
            let verif = response.body;
            this.loading = false;
            if (verif.code === 1) {
              this.$notify({
                title: "MODIFICATION REUSSI",
                message: response.body.message,
                type: "success",
                position: "top-center"
              });
               this.loading = false;
               this.dialogSuprRessource = false;
               this.dialogShowEditRessource = false;
                this.dialogShowTravaux = false
               this.formEditRessource.dateD = ''
               this.formEditRessource.dateD = ''
               this.newQteRessource = 0
               this.handleTabClick('2')
              //  this.showTravaux(ligne)
              this.showTravauxRessource(ligne)
            }
          }
        },
        error => {
          this.loading = false;
          this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          // this.loading = false;
        }
      )
    },
    resetFormInfoRess() {
      this.formInfoRessource= {}
      this.dialogShowInfoRessource = false
    },
    resetFormEditRess() {
      this.formEditRessource= {}
      this.newQteRessource = 0
      this.dialogShowEditRessource = false
    },
    editTache(ligne) {

      this.dialogShowReglement = true;
      this.formTacheDemarrer.dateDbtache = ligne.dateDFormat;
      this.formTacheDemarrer.dateFintache = ligne.dateFFormat;
      this.tacheSelectioner = ligne.idTrx;
      this.travauxCourant = ligne;
      // this.projetCourant = ligne;
    },
    editDateTache() {
      this.loading = true;
      var form = document.getElementById("formTacheDemarrer");
      var data = new FormData(form);
      let url = "";
      data.append("idUser", this.user.id);
      data.append("idtache", this.tacheSelectioner);
      data.append("dateDbtache", this.formTacheDemarrer.dateDbtache);
      data.append("dateFintache", this.formTacheDemarrer.dateFintache);

      url = this.domaine + "projet/" + this.chantierCourant.id + "/edit/tache";
      this.$http.post(url, data).then(
        response => {
          this.loading = false;
          if (response.body) {
            let verif = response.body;
            this.loading = false;
            if (verif.code === 1) {
              this.$notify({
                title: "MODIFICATION REUSSI",
                message: response.body.message,
                type: "success",
                position: "top-center"
              });

              this.loadChantier(this.projetCourant);

              this.loadProjetTache(this.projetCourant);
              this.loadProjet();
              this.dialogShowReglement = false
              this.dialogPlan = false;

              this.formTacheDemarrer.dateDbtache = "";
              this.formTacheDemarrer.dateFintache = "";
            } else {
              this.loading = false;
              this.$notify.error({
                title: "ERREUR D'ENREGISTREMENT",
                message: verif.message,
                position: "top-center"
              });
              // this.loading = false;
            }
          } else {
            this.loading = false;
            this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            // this.loading = false;
          }
        },
        response => {
          this.loading = false;
          this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          // this.loading = false;
        }
      );
    },
    resetFormVersion() {
      this.dialogShowReglement = false;
      //  this.$refs['formTacheDemarrer'].resetFields();

      this.formTacheDemarrer.dateDbtache = "";
      this.formTacheDemarrer.dateFintache = "";
    },
    ajoutProjet(type, item) {
      if (type === "edit") {
        this.projetSelect = item;
        this.form.id = item.id;
        this.form.type = item.idType;
        this.form.etatBudget = item.budget.etat;
        this.tableBudget = item.budget.budgets;
        this.form.libelle = item.libelle;
        this.form.chef = item.idChef;
        this.form.maitre_ouvrage = item.idMaitreO;
        this.form.chefEtude = item.idChefEtud;
        this.form.chefControle = item.idChefCon;
        this.form.architect = item.idArcht;
        this.form.description = item.description;
        this.form.adresse = item.adresse;
        this.form.nbrHeure = item.nbrHeure;
        this.form.prix = item.mntMarcheNormal;
        this.form.caisse = item.idCaisse;
        this.selectBanques = item.idBanque
        this.selectUsers = item.idParticipant;

        this.loadCaisse()
        // this.form.banque = item.idBanque;
        this.logoProjet = item.urlImage;
        //this.form.caisse = item.idCaisse;
        this.dateD = item.dateD;
        this.dateF = item.dateF;
        this.latitude = item.latitude;
        this.longitude = item.longitude;
        this.texteP = "Modifier le projet " + item.libelle;
      } else {
        //this.tableBudget.splice(0);
        this.form.etatBudget = false;
        this.logoProjet = "/static/img-doc.png";
        this.form.id = "";
        this.form.type = "";
        this.form.libelle = "";
        this.form.chef = "";
        this.form.maitre_ouvrage = "";
        this.form.chefEtude = "";
        this.form.chefControle = "";
        this.form.architect = "";
        this.form.description = "";
        this.form.adresse = "";
        this.form.nbrHeure = 1;
        this.form.caisse = "";
        // this.form.banque = "";
        this.selectBanques = []
        this.selectUsers = [],
        this.form.prix = "";
        this.dateD = "";
        this.dateF = "";
        this.latitude = 0;
        this.longitude = 0;
        this.texteP = "Ajouter un nouveau projet";
      }
       this.loadClient();
      this.loadUser();
      this.loadPrestaire();
      this.form.etat = true;
    },
    newChantier(item) {
      this.chantierCourant.id = "";
      this.chantier = {};
      this.projetCourant = item;
      this.dialogPlan = true;
      this.dialogEdit = false;
      this.logoChantier = "/static/img-doc.png";
      this.selectZone = "";
      this.latitude = 0;
      this.longitude = 0;
      this.optionChantier = [
        {
          key: 1,
          libelle: "",
          dateD: "",
          dateF: "",
          montant: 0,
          idChef: "", 
          id: ""
        }
      ];
    },
    newTravaux(item) {
      this.readBtnModTrx = false;
      this.chantierCourant = item;
      this.travauxCourant.id = "";
      this.detailPlanifCourant = item;
      this.loadTravauxChantier(item)
      this.dialogTravaux = true;
      this.dialogEdit = false;
      this.optionTache = [];
      this.selectTravaux = "";
      this.dateD = "";
      this.dateF = "";
      this.selectSoustraite = "";
      this.selectPrestataire = "";
      this.montantSoustraitance = 0;
      this.etape = 1;
      this.descriptionTravaux = "";
    },
    newCommande(item, ligne) {
      this.travauxCourant = item;
      this.dialogComm = true;
      this.dialogEdit = false;
      this.FormComm.optionCommande = [
        {
          key: 1,
          produit: "",
          qte: 1,
          id: ""
        }
      ];
      this.FormComm.fournisseur = "";
    },
    newEquipe(item) {
      this.tacheCourant = item;
      this.equipeCourant.id = "";

      if (this.tacheCourant.soutraite == 1) {
        //tache deja soutraite par un prestataire
        this.$alert(
          "Cette tache est déjà soustraitée par le prestataire "+ this.tacheCourant.fournisseur,
          "Tache soustraitée ",
          {
            confirmButtonText: "OK",
            callback: action => {
              return;
            }
          }
        );
        return;

        // this.optionEquipe = [
        //     {
        //         key: 1,
        //         type: [{ text: "Prestataire", value: 1 }],
        //         selectType: 1,
        //         fournisseur: this.tacheCourant.idFour,
        //         ouvrier: "",
        //         duree: "",
        //         montant: 0,
        //         id: ""
        //     }
        // ];
      } else {
        this.dialogEquipe = true;
        this.dialogEdit = false;
        this.optionEquipe = [
          {
            key: 1,
            type: [
              { text: "Prestataire", value: 1 },
              { text: "Ouvrier/Manoeuvre", value: 2 }
            ],
            selectType: "",
            fournisseur: "",
            ouvrier: "",
            duree: "",
            montant: 0,
            montantSupp: 0,
            id: ""
          }
        ];
      }
    },
    newDemarer(item) {
      this.travauxCourant = item;
      this.dialogDemarer = true;
      this.optionDemarer = this.multipleSelection;
    },
    newDemarerTravaux(item) {
      this.travauxCourant = item;
      this.dialogDemarerTravaux = true;
      this.optionDemarer = this.multipleSelection;
    },
    newRapport(item) {
      this.tacheCourant = item;
      this.evolution = this.tacheCourant.evolution;
      this.dialogRapport = true;
      this.description = "";
      this.fichier = [];
    },
    newValid(item) {
      this.tacheCourant = item;
      this.dialogValid = true;
      this.description = this.tacheCourant.descriptionValid;
      this.selectReponse = null;
    },
    newValidCommande(item) {
      this.commandeCourant = item;
      this.dialogValidCommande = true;
      this.description = this.commandeCourant.description;
      this.selectReponse = null;
    },
    newDupliqueChantier(item) {
      this.projetCourant = item;
      this.dialogDupliqueChantier = true;
      this.optionDuplique = this.multipleSelection;
    },
    newRapportTravaux() {
      this.dialogMultipleRapport = true;
      this.optionRapport = [];
      this.selectChantierRapport = "";
      this.selectTravauxRapport = "";
    },

    newPlanifProduit(item) {
      this.dialogPlanifProduit = true;
      this.tacheCourante = item;
      this.loadTacheTrx();
      this.optionProduit = [{ type: "", produit: "", qte: 1, priorite: "" }];
      this.optionVehicule = [{ vehicule: "", qte: 1, priorite: "", periode: "" }];
      this.valeurUniteMateriel=""

      this.loadProduitPlan();
    },
    editChantier(item) {
      this.chantier = item;
      this.chantier.dateD = item.dateD2;
      this.chantier.type = item.typeChantier;
      this.chantier.dateF = item.dateF2;
      this.chantierCourant = item;
      this.travauxCourant = item.travaux;
      this.dialogPlan = true;
      this.dialogEdit = true;
      this.selectZone = this.chantierCourant.idZone;
      this.libelle = this.chantierCourant.libelle;
      this.dateD = this.chantierCourant.dateD;
      this.dateF = this.chantierCourant.dateF;
      this.montant = this.chantierCourant.montant;
      this.latitude = this.chantierCourant.latitude;
      this.longitude = this.chantierCourant.longitude;
      // this.selectUsers = this.chantierCourant.idChef;
      this.logoChantier = item.urlImage;
      this.handleChangeSoustraitant(item.soutraite);
    },
    editTravaux(item, item2, listChantierResult) {
      this.listeTacheSupp = [];
      this.detailPlanifCourant = item;
      this.readBtnModTrx = true;
      this.travauxCourant = item;
      this.dialogTravaux = true;
      this.dialogEdit = true;
      this.selectTravaux = item.idTypeTravaux;
      this.loadTacheParTravaux();
      this.descriptionTravaux = this.travauxCourant.description;
      this.selectChefTravaux = this.travauxCourant.idChef;
      this.dateD = this.travauxCourant.dateDebutF;
      this.dateF = this.travauxCourant.dateFinF;
      this.etape = 1;
      this.selectSoustraite = this.travauxCourant.soutraite;
      this.selectPrestataire = this.travauxCourant.idFour;
      this.optionTache = item2.option;
      this.montantSoustraitance = this.travauxCourant.montantSoustraitance;
    },
    editEquipe(item) {
      this.equipeCourant = item;
      this.dialogEquipe = true;
      this.dialogEdit = true;
      this.montantContrat = this.equipeCourant.montantNbr;
      this.dateDContrat = this.equipeCourant.dateD;
      this.dateFContrat = this.equipeCourant.dateF;
    },
    editCommande(ligne) {
      this.loading = false;
      this.commandeCourant = ligne;
      this.travauxCourant.id = ligne.idTrav;
      this.dialogComm = true;
      this.dialogEdit = true;
      this.FormComm.optionCommande = this.commandeCourant.option;
      this.FormComm.fournisseur = this.commandeCourant.fournisseur;
    },
    submit() {
      let dbt = this.dateD.split("-");
      let fin = this.dateF.split("-");
      let dateDFormat = new Date(dbt[2] + "-" + dbt[1] + "-" + dbt[0]);

      let dateFFormat = new Date(fin[2] + "-" + fin[1] + "-" + fin[0]);
      if (
        this.$refs.formProjet.validate() &&
        //this.form.caisse !== "" &&
        (this.form.nbrHeure > 0 && this.form.nbrHeure <= 24) &&
        this.form.chef !== "" &&
        this.form.maitre_ouvrage !== "" &&
        this.form.adresse !== "" &&
        this.form.libelle !== "" &&
        this.longitude !== 0 &&
        this.latitude !== 0 &&
        this.form.caisse !== "" &&
        this.selectBanques.length != 0
      ) {
        if (dateDFormat <= dateFFormat) {
          var form = document.getElementById("formProjet");
          var data = new FormData(form);
          data.append("id", this.form.id);
          //data.append("type", this.form.type);
          data.append("type", "N/A"); //ne pas supprimer pour eviter des erreurs
          data.append("chef", this.form.chef);
          data.append("chefEtude", this.form.chefEtude);
          data.append("maitre_ouvrage", this.form.maitre_ouvrage);
          data.append("chefControle", this.form.chefControle);
          data.append("architect", this.form.architect);
          data.append("caisse", this.form.caisse);
          // data.append("banque", this.form.banque);
          data.append("prix", this.form.prix);
          data.append("idUser", this.user.id);
          data.append("banque", this.selectBanques);
          data.append("Users", this.selectUsers);

          let url = this.domaine + "projet/new";
          // this.loading = true;
          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                if (response.body.code == 1) {
                  this.$notify({
                    title: "NOTIFICATION PROJET",
                    message: response.body.message,
                    type: "success",
                    duration: 3000,
                    position: "top-center"
                  });
                  this.form.etat = false;;
                  // this.loadListeProjet()
                  this.loadProjetAll()
                  this.form.etat = false;

                  this.loading = false;
                }
                if (response.body.code == 2) {
                  this.$notify({
                    title: "ENREGISTREMENT PROJET",
                    message: "le nom du projet existe déjà.",
                    type: "Warning",
                    position: "top-center",
                    duration: 5000
                  });
                  this.loading = false;
                }
              }
            },
            response => {
              this.loading = false;
            }
          );
        } else {
          this.$notify({
            title: "ERREUR CONCERNANT LES DATES",
            message: "La de fin ne doit pas être supérieur à la date de début.",
            type: "warning",
            position: "top-center"
          });
          this.loading = false;
        }
      } else {
        this.$message.error("veuillez compléter le formulaire  correctement!");
        this.loading = false;
      }
    },

    isValidDateChantier() {
      if (
        this.projetCourant.dateD != null &&
        this.projetCourant.dateD != null
      ) {
        let tabDateDbt = this.projetCourant.dateD.split("-");
        let dateDbt = tabDateDbt.reverse();
        let datePrjDbt = new Date(dateDbt);
        let tabDateFin = this.projetCourant.dateF.split("-");
        let dateFin = tabDateFin.reverse();
        let datePrjFin = new Date(dateFin);

        if (
          this.chantier.latitude == null ||
          this.chantier.longitude == null ||
          this.chantier.libelle == null ||
          this.chantier.montant == null ||
          this.chantier.dateD < datePrjDbt ||
          this.chantier.dateD > datePrjFin ||
          this.chantier.dateD > this.chantier.dateF ||
          this.chantier.dateF < datePrjDbt ||
          this.chantier.dateF > datePrjFin ||
          this.chantier.dateF == null ||
          this.chantier.dateD == null ||
          this.chantier.idChef == null
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    functionTime(dateR) {
      var date = "";
      var splittedDate = dateR.split("-");

      //on verifie si la date est au format Y-m-d
      if (splittedDate[2].length == 4) {
        date = [splittedDate[2], splittedDate[1], splittedDate[0]].join("-");
        var dateObject = new Date(date);
      } else {
        var dateObject = new Date(dateR);
      }
      return dateObject;
    },
    submitPlan() {
      this.loading = true;
      // this.chantierCourant = null;
      let Dchantier = this.functionTime(this.chantier.dateD);
      let Fchantier = this.functionTime(this.chantier.dateF);
      let Dprojet = this.functionTime(this.projetCourant.dateD);
      let Fprojet = this.functionTime(this.projetCourant.dateF);

      if (
        Dprojet.getTime() <= Dchantier.getTime() &&
        Fprojet.getTime() >= Fchantier.getTime()
      ) {
        if (
          // this.$refs.formProjet.validate() &&
          this.chantier.longitude != 0 &&
          this.chantier.latitude != 0 &&
          this.chantier.libelle != "" &&
          // this.chantier.montant != 0 &&
          this.chantier.dateD != "" &&
          this.chantier.dateF != "" &&
          this.chantier.idChef != "" &&
          this.chantier.type !== ""
        ) {
          var form = document.getElementById("formPlan");
          var data = new FormData(form);
          let url = "";
          if (this.chantierCourant.id != "") {
            url =
              this.domaine + "projet/" + this.chantierCourant.id + "/edit/plan";
            data.append("etat", this.chantier.etat);
          } else {
            url =
              this.domaine + "projet/" + this.projetCourant.id + "/new/plan";
          }

          data.append("idUser", this.user.id);
          data.append("idChef", this.chantier.idChef);
          data.append("type", this.chantier.type);
          data.append("soutraite", this.chantier.soutraite);
          data.append("prestataire", this.chantier.prestataire);
          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                let verif = response.body;
                if (verif.code === 1) {
                  if (this.chantierCourant.id) {
                    this.$notify({
                      title: "MODIFICATION REUSSI",
                      message: response.body.message,
                      type: "success",
                      position: "top-center"
                    });
                  } else {
                    this.chantierCourant = response.body.chantier
                    this.$notify({
                      title: "ENREGISTREMENT REUSSI",
                      message: response.body.message,
                      type: "success",
                      position: "top-center"
                    });
                  }

                  this.showProjet(this.projetCourant);
                  this.loadChantier(this.projetCourant);
                  this.loadProjet();
                  this.dialogPlan = false;
                  this.loading = false;
                } else if (verif.code === 0) {
                  this.$message.error(verif.message);
                  this.loading = false;
                }
              } else {
                this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                this.loading = false;
              }
            },
            response => {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          );
        } else {
          this.$message.error(
            "veuillez compléter le formulaire  correctement!"
          );
          this.loading = false;
        }
      } else {
        this.$message.error(
          "Les dates pour la réalisation du chantier doivent être  comprise  entre les dates du projet"
        );
        this.loading = false;
      }
    },

    validDuplique(chantier){

      let url = "";
      url =this.domaine +"projet/new_duplicate/chantier/"+chantier.idChantier;
      var data = new FormData();
      data.append("idUser", this.user.id);
      this.$http.post(url, data).then(
      response => {
                    this.$notify({
                      title: "Duplication Chantier",
                      message: "Le  chantier , les travaux et tâches ont été dupliqués",
                      type: "success",
                      position: "top-center"
                    });
                  this.loading = false;
                  this.loadChantier(this.projetCourant);
                  this.showDialogDupTrx = false
                  //this.$refs.formEquipe.reset();
            },
            response => {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          );
    },

    duplicateTravauxChantier(oldChantier,newChantier){
      this.chantier = oldChantier;
      var data = new FormData();
      data.append("oldChantier", oldChantier.idChantier);
      data.append("newChantierId", newChantier.idChantier);


      let url = "";
      url =this.domaine +"projet/duplicate/chantier/new_travaux_chantier";
      this.$http.post(url, data).then(
      response => {
          this.$notify({
            title: "OPERATION REUSSI",
            message: "Duplication avec succès.",
            type: "success",
            position: "top-center"
          });
        this.loading = false;
            },
            response => {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          );



    },
    isValidDateOptionTache() {
      this.dateD.setSeconds(0);
      this.dateF.setSeconds(0);

      for (let indexOption in this.optionTache) {
        let option = this.optionTache[indexOption];

        if (option.dateDebut != null && option.dateFin != null) {
          option.dateDebut.setSeconds(0);
          option.dateFin.setSeconds(0);
          //verification des dates
          if (
            option.dateDebut > option.dateFin ||
            option.dateDebut > this.dateF ||
            option.dateDebut < this.dateD ||
            option.dateFin < this.dateD ||
            option.dateFin > this.dateF
          ) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      }
    },
    isValidDateOptionEquipe() {
      let result = false;
      if (
        this.tacheCourant.dateDebut != null &&
        this.tacheCourant.dateFin != null
      ) {
        let tabDateDbt = this.tacheCourant.dateDebut.split("-"); //["16","08","2018 00:00:00"]
        let jr = tabDateDbt[0];
        let mois = tabDateDbt[1];
        let annee = tabDateDbt[2].split(" ")[0];
        let hr = tabDateDbt[2].split(" ")[1];
        let dateDbt = annee + "-" + mois + "-" + jr + "T" + hr;
        let dateChtDbt = new Date(dateDbt);

        let tabDateFin = this.tacheCourant.dateFin.split("-");
        let jrF = tabDateFin[0];
        let moisF = tabDateFin[1];
        let anneeF = tabDateFin[2].split(" ")[0];
        let hrF = tabDateFin[2].split(" ")[1];
        let dateFin = anneeF + "-" + moisF + "-" + jrF + "T" + hrF;
        let dateChtFin = new Date(dateFin);

        //this.tacheCourant.setSeconds(0)
        //this.dateF.setSeconds(0)
        if (this.optionEquipe.length == 0) {
          this.$message.error("Veuillez Ajouter un manoeuvre pour la tache");
          result = false;
        } else {
          for (let indexOption in this.optionEquipe) {
            let option = this.optionEquipe[indexOption];

            if (option.duree[0] != null && option.duree[1] != null) {
              if (
                option.duree[0] > option.duree[1] ||
                option.duree[0] > dateChtFin ||
                option.duree[0] < dateChtDbt ||
                option.duree[1] < dateChtDbt ||
                option.duree[1] > dateChtFin ||
                option.montant <= 0
              ) {
                this.$message.error(
                  "Veuillez verifier les dates et le montant saisi a la ligne " +
                    (parseInt(indexOption, 10) + 1)
                );

                result = false;
                break;
              } else {
                result = true;
              }
            } else {
              this.$message.error(
                "Veuillez verifier les dates et le montant saisi a la ligne " +
                  (indexOption + 1)
              );

              result = false;
              break;
            }
          }
        }
      }

      return result;
    },
    submitSearch() {
      this.loading = true;
      this.searchResultList = [];
      this.searchResultTravauxList = [];
      this.searchResultEtat = [];
      this.searchResultEtatCommande = [];
      this.searchResultEtatMontant = [];
      if (
        this.$refs.formSearchTypeRapport.validate() &&
        this.selectTypeRapport != ""
      ) {
        var form = document.getElementById("formSearchTypeRapport");
        var data = new FormData(form);
        let url = this.domaine + "projet/rapport/search";
        data.append("idUser", this.user.id);
        data.append("type", this.selectTypeRapport);
        data.append("chantier", this.selectSearchChantier);
        data.append("travaux", this.selectSearchTravauxSuivi);
        data.append("etat", this.selectSearchEtat);

        this.$http.post(url, data).then(
          response => {
            if (response.body) {
              let verif = response.body;
              this.searchResultList = verif.table;
              this.searchResultTravauxList = verif.table2;
              this.searchResultEtatMontant = verif.piemontant;
              this.searchResultEtatCommande = verif.piecom;
              this.searchResultEtat = verif.pie;
              this.totalCommande = verif.totalCommande;
              this.totalDepense = verif.totalDepense;
              if (verif.code === 1) {
                this.$notify({
                  title: "RESULTATS DES RECHERCHES",
                  message: "Nous avons trouvé.",
                  type: "success",
                  position: "top-center"
                });

                if (this.selectTypeRapport == 1) {
                  this.statEtatGeneral();
                } else if (this.selectTypeRapport == 2) {
                  this.statEtatMontant();
                } else if (this.selectTypeRapport == 3) {
                  this.statEtatCommande();
                }

                this.loading = false;
              } else if (verif.code === 0) {
                this.$message.error(verif.message);
                this.loading = false;
              }
            } else {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          },
          response => {
            this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            this.loading = false;
          }
        );
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Les travaux n'ont pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    submitTravaux()
    {
      this.loading = true;
       let statut = false
        for (let prop in this.optionTache)
        {
            let ligne = this.optionTache[prop];
            if (ligne.dateDebut == null && ligne.dateFin == null)
            {
              this.loading = false
              this.$message.error("Veuillez renseigner les champs obligatoires");
              return;
            }
        }
      if (this.$refs.formTravaux.validate()) {
        let form = document.getElementById("formTravaux");
        var data = new FormData(form);
        let etat = false;
        let url = "";
        if(this.chantierCourant.id !=''){
         url =this.domaine +"projet/" +this.chantierCourant.id +"/new/travaux";
        }else{
         url =this.domaine +"projet/" +this.chantierCourant.idChant +"/new/travaux";
        }

          let ligne = null;

          let nbData = 10;
          let nbReq = 1;
          let nbRest
          if (this.optionTache.length > 10) {
            nbData = 10;
             nbReq = Math.round(this.optionTache.length / nbData);
            let nbRest = this.optionTache.length % nbData;
            if (nbRest > 0) {
              nbReq += 1;
            }
          }
           for (let i=0; i<nbReq; i++) {

              let initJ = i * nbData;
              let finJ = (i + 1) * nbData;
              let dataLot = [];
              if (this.optionTache.length > 0) {
                for (let j = initJ; j < finJ; j++) {
                  if (this.optionTache[j] == undefined) {
                    break;
                  }
                  dataLot.push(this.optionTache[j]);
                }
              }
              var data = new FormData(form);

              for (let prop in dataLot) {
                  ligne = dataLot[prop];
                  data.append("option[id][]", ligne.id);
                  data.append("option[dateD][]", ligne.dateDebut);
                  data.append("option[dateF][]", ligne.dateFin);
                  data.append("option[ordre][]", ligne.ordre);
                  data.append("option[prix][]", ligne.prix);
                  data.append("option[qte][]", ligne.qte);
                  data.append("option[total][]", ligne.total);
                  etat = true;
              }

                  data.append("listeSupp", JSON.stringify(this.listeTacheSupp));

                  data.append("idUser", this.user.id);
                  data.append("chef", this.selectChefTravaux);
                  data.append("montantEstime", this.montantEstime);
                  data.append("montantSoustraitance", this.montantSoustraitance);
                  data.append("travaux", this.selectTravaux);
                  if (this.chantierCourant.soutraite == 1) {
                    data.append("idFour", this.chantierCourant.idFour);
                    data.append("soutraite", this.chantierCourant.soutraite);
                  } else {
                    data.append("idFour", this.selectPrestataire);
                    data.append("soutraite", this.selectSoustraite);
                  }

                  data.append("totalHT", this.totalHT);

                this.$http.post(url, data).then(
                  response => {
                    this.loading = false;
                    if (response.body) {
                      let verif = response.body;
                      if (verif.code === 1) {

                        this.$notify({
                          title: "ENREGISTREMENT REUSSI",
                          message: "Travaux enregistré avec succès.",
                          type: "success",
                          position: "top-center"
                        });

                        this.showProjet(this.projetCourant);
                        this.loadChantier(this.projetCourant);
                        this.dialogTravaux = false;
                        this.loading = false;
                        this.$refs.formTravaux.reset();
                      } else {
                        this.loading = false;
                        this.$notify.error({
                          title: "ERREUR D'ENREGISTREMENT",
                          message: verif.message,
                          position: "top-center"
                        });
                      }
                    } else {
                      this.loading = false;
                      this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");

                    }
                  },
                  response => {
                    this.loading = false;
                    this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                  }
                );
              }
      } else {
        this.loading = false;
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Les travaux n'ont pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },

    submitEditTravaux(idTrx) {
      this.loading = true;
      let statut = false
       for (let prop in this.optionTache) {
            let ligne = this.optionTache[prop];
            if (ligne.dateDebut == null && ligne.dateFin == null)
            {
              this.loading = false
              this.$message.error("Veuillez renseigner les champs obligatoires");
              return;
            }
        }

          if (this.$refs.formTravaux.validate()) {

            var form = document.getElementById("formTravaux");

            var data = new FormData(form);
            let url = this.domaine + "projet/" + idTrx + "/edit/travaux";
            let ligne = null;
            let nbData = 10;
            let nbReq = 1;
            let nbRest
            if (this.optionTache.length > 10) {
              nbData = 10;
              nbReq = Math.round(this.optionTache.length / nbData);
              nbRest = this.optionTache.length % nbData;
              if (nbRest > 0) {
                nbReq += 1;
              }
            }
            for (let i=0; i<nbReq; i++) {
               let initJ = i * nbData;
                    let finJ = (i + 1) * nbData;
                    let dataLot = [];
                    if (this.optionTache.length > 0) {
                      for (let j = initJ; j < finJ; j++) {
                        if (this.optionTache[j] == undefined) {
                          break;
                        }
                        dataLot.push(this.optionTache[j]);
                      }
                    }
                    var data = new FormData(form);
                    for (let prop in dataLot) {
                        ligne = dataLot[prop];
                        data.append("option[id][]", ligne.id);
                        data.append("option[dateD][]", ligne.dateDebut);
                        data.append("option[dateF][]", ligne.dateFin);
                        data.append("option[ordre][]", ligne.ordre);
                        data.append("option[tache][]", ligne.tache !='' ? ligne.tache : ligne.libelle);
                        data.append("option[prix][]", ligne.prix);
                        data.append("option[unite][]", ligne.unite);
                        data.append("option[qte][]", ligne.qte);
                        data.append("option[total][]", ligne.total);
                      }

                    data.append("listeSupp", JSON.stringify(this.listeTacheSupp));
                    data.append("totalHT", this.totalHT);
                    data.append("chef", this.selectChefTravaux);
                    data.append("montantEstime", this.montantEstime);
                    data.append("soustraite", this.selectSoustraite);
                    data.append("mntSoutraite", this.montantSoustraitance);
                    data.append("description", this.descriptionTravaux);
                    data.append("dateDebut", this.travauxCourant.dateDebut);
                    data.append("dateFin", this.travauxCourant.dateFin);
                    data.append("idFour", this.selectPrestataire);
                    data.append("soutraite", this.selectSoustraite);
                    data.append("travaux", this.selectTravaux);
                    data.append("idUser", this.user.id);
                    this.$http.post(url, data).then(
                      resp => {
                         this.handleTabClick('2')
                        this.dialogShowTravaux = false;
                        this.loading = false;
                        if(resp.body.code == 2 && i == (nbReq-1) ){
                            this.$notify({
                                title: 'Suppression Taches',
                                duration:5000,
                                message: resp.body.message,
                                type: 'warning'
                            });
                        }else{
                          this.$notify({
                          title: "ENREGISTREMENT REUSSI",
                          message: "Les travaux ont ete enregistre",
                          type: "success",
                          position: "top-center"
                        });
                        }

                      },
                      error => {
                        this.loading = false;
                        this.$message.error(
                          "Echec de l'operation veuillez verifier la connexion"
                        );
                      }
                    );

            }

              this.showProjet(this.projetCourant);
              this.loadChantier(this.projetCourant);
              this.dialogTravaux = false;
              this.loading = false
              const loading = this.$loading({
                        lock: true,
                        text: 'Veuillez patientez ...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    })
                    setTimeout(() => {
                        loading.close()
                        // this.loading = false
                      if(succesEnreg == true){
                        this.$notify({
                            title: "Enregistrement",
                            message: "La liste a ete enregistre avec succes",
                            type: "success",
                            position: "top-right",
                            duration: 5000
                        });
                        this.$emit("close")
                    }
                    }, 7000)
          } //data formulaire inexacte
          else {
            this.loading = false
            this.$message.error("Veuillez renseigner les champs obligatoires");
          }
    },
    submitComm(formComm) {
      this.loading = true;
      this.$refs[formComm].validate(valid => {
        let etat = false;
        if (this.FormComm.optionCommande.length > 0) {
          for (let prop in this.FormComm.optionCommande) {
            let item = this.FormComm.optionCommande[prop];
            if (item.produit != "" && item.qte > 0) {
              etat = true;
            }
          }
        }

        if (etat == true) {
          var form = document.getElementById("formComm");
          var data = new FormData(form);
          let url =
            this.domaine + "projet/" + this.travauxCourant.id + "/new/commande";
          data.append("idUser", this.user.id);
          data.append("idPres", this.FormComm.fournisseur);
          let ligne = null;
          for (let prop in this.FormComm.optionCommande) {
            ligne = this.FormComm.optionCommande[prop];
            data.append("options[id][]", ligne.id);
            data.append("options[produit][]", ligne.produit);
            data.append("options[qte][]", ligne.qte);
          }

          if (this.commandeCourant.id) {
            data.append("id", this.commandeCourant.id);
          } else {
            data.append("id", "");
          }

          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                let verif = response.body;
                if (verif.code === 1) {
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Commande enregistré avec succès.",
                    type: "success",
                    position: "top-center"
                  });
                  this.showProjet(this.projetCourant);
                  this.loadChantier(this.projetCourant);
                  this.loadCommandeAValid(this.projetCourant);
                  this.dialogComm = false;
                  this.loading = false;
                } else if (verif.code === 0) {
                  this.$message.error(verif.message);
                  this.loading = false;
                }
              } else {
                this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                this.loading = false;
              }
            },
            response => {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          );
        } else {
          this.$notify({
            title: "ATTENTION",
            message: "Veuillez renseigner les lignes de la commande.",
            type: "warning",
            position: "top-center"
          });
          this.loading = false;
        }
      });
    },
    submitEquipe() {
      this.loading = true;
      if (this.$refs.formEquipe.validate()) {
        let etat = false;
        var form = document.getElementById("formEquipe");
        var data = new FormData(form);
        let url = "";
        if (this.equipeCourant.id != "") {
          url =
            this.domaine + "projet/" + this.equipeCourant.id + "/edit/contrat";
          etat = true;
        } else {
          url = this.domaine + "projet/" + this.tacheCourant.id + "/new/equipe";
          let ligne = null;
          for (let prop in this.optionEquipe) {
            ligne = this.optionEquipe[prop];
            if (
              (ligne.selectType !== null &&
                ligne.duree !== null &&
                ligne.ouvrier !== null) ||
              ligne.fournisseur !== ""
            ) {
              etat = true;
              data.append("option[id][]", ligne.id);
              data.append("option[type][]", ligne.selectType);
              data.append("option[ouvrier][]", ligne.ouvrier);
              data.append("option[fournisseur][]", ligne.fournisseur);
              data.append("option[duree][]", ligne.duree);
              data.append("option[montant][]", ligne.montant);
              data.append("option[montantSupp][]", ligne.montantSupp);
            } else {
              etat = false;
            }
          }
        }
        data.append("idUser", this.user.id);
        if (etat) {
          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                let verif = response.body;
                if (verif.code === 1) {
                  if (this.equipeCourant.id) {
                    this.$notify({
                      title: "MODIFICATION REUSSI",
                      message: "Contrat modifié avec succès.",
                      type: "success",
                      position: "top-center"
                    });
                  } else {
                    this.$notify({
                      title: "ENREGISTREMENT REUSSI",
                      message: "Equipe enregistré avec succès.",
                      type: "success",
                      position: "top-center"
                    });
                  }

                  this.loadChantier(this.projetCourant);
                  this.loadEquipe(this.travauxCourant);
                  this.dialogEquipe = false;
                  this.loading = false;
                  this.$refs.formEquipe.reset();
                } else if (verif.code === 0) {
                  this.$message.error(verif.message);
                  this.loading = false;
                }
              } else {
                this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                this.loading = false;
              }
            },
            response => {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          );
        } else {
          this.$notify({
            title: "ATTENTION",
            message: "Veuillez renseigner correctement tout les champs.",
            type: "warning",
            position: "top-center"
          });

          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Equipe n'ont pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    submitDupliqueChantier() {
      this.loading = true;
      if (this.$refs.formDupliqueChantier.validate()) {
        let etat = false;
        var form = document.getElementById("formDupliqueChantier");
        var data = new FormData(form);
        let url =
          this.domaine +
          "projet/" +
          this.projetCourant.id +
          "/new/dupliquer/chantier";
        let ligne = null;
        for (let prop in this.optionDuplique) {
          ligne = this.optionDuplique[prop];
          if (ligne.id !== null && ligne.id !== "") {
            etat = true;
            data.append("option[id][]", ligne.id);
          } else {
            etat = false;
          }
        }

        data.append("idUser", this.user.id);
        if (etat) {
          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                let verif = response.body;
                if (verif.code === 1) {
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Copie réussi avec succès.",
                    type: "success",
                    position: "top-center"
                  });

                  this.loadChantier(this.projetCourant);
                  this.dialogDupliqueChantier = false;
                  this.loading = false;
                  this.$refs.formDupliqueChantier.reset();
                } else if (verif.code === 0) {
                  this.$message.error(verif.message);
                  this.loading = false;
                }
              } else {
                this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                this.loading = false;
              }
            },
            response => {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          );
        } else {
          this.$notify({
            title: "ATTENTION",
            message: "Veuillez renseigner correctement tout les champs.",
            type: "warning",
            position: "top-center"
          });

          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Equipe n'ont pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    submitDemarrer() {
      this.loading = true;
      if (this.$refs.formDemarer.validate()) {
        let etat = false;
        var form = document.getElementById("formDemarer");
        var data = new FormData(form);
        let url =
          this.domaine + "projet/" + this.travauxCourant.id + "/new/contrat";
        data.append("idUser", this.user.id);
        let ligne = null;
        for (let prop in this.optionDemarer) {
          ligne = this.optionDemarer[prop];
          if (ligne.date !== null) {
            etat = true;
            data.append("option[id][]", ligne.id);
            data.append("option[date][]", ligne.date);
          } else {
            etat = false;
          }
        }
        if (etat) {
          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                let verif = response.body;
                if (verif.code === 1) {
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Contrat démarrer avec succès.",
                    type: "success",
                    position: "top-center"
                  });
                  this.showTravaux(this.travauxCourant, this.chantierCourant);
                  this.loadEquipe(this.travauxCourant);
                  this.dialogDemarer = false;
                  this.loading = false;
                  this.$refs.formDemarer.reset();
                } else {
                  this.$message.error(verif.message);
                  this.loading = false;
                }
              } else {
                this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                this.loading = false;
              }
            },
            response => {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          );
        } else {
          this.$notify({
            title: "ATTENTION",
            message: "Veuillez renseigner correctement tout les champs.",
            type: "warning",
            position: "top-center"
          });

          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "L'action n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    imprimeAllTresorerie(item) {
      let url = this.domaine + "caisse/impression/liste/tresor";
      window.open(url);
    },
    addTacheComm () {
      this.optionTache.push({
          ordre: this.optionTache.length + 1,
          tache: '',
          libelle:'',
          unite: '',
          dateDebut: '',
          dateFin: '',
          qte: 1,
          prix: 0,
          total: 0,
      })
          // this.totComLigneTTC += 5
      },
    submitDemarrerTravaux() {
      this.loading = true;
      if (this.$refs.formDemarerTravaux.validate()) {
        let etat = false;
        var form = document.getElementById("formDemarerTravaux");
        var data = new FormData(form);
        let url =
          this.domaine +
          "projet/" +
          this.travauxCourant.id +
          "/demarrer/travaux";
        data.append("idUser", this.user.id);
        let ligne = null;
        for (let prop in this.optionDemarer) {
          ligne = this.optionDemarer[prop];
          if (ligne.date !== "") {
            etat = true;
            data.append("option[id][]", ligne.id);
            data.append("option[date][]", ligne.date);
          } else {
            etat = false;
          }
        }
        if (etat) {
          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                let verif = response.body;
                if (verif.code === 1) {
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Travaux démarrer avec succès.",
                    type: "success",
                    position: "top-center"
                  });
                  this.showTravaux(this.travauxCourant, this.chantierCourant);
                  this.loadEquipe(this.travauxCourant);
                  this.dialogDemarerTravaux = false;
                  this.loading = false;
                  this.$refs.formDemarerTravaux.reset();
                } else {
                  this.$message.error(verif.message);
                  this.loading = false;
                }
              } else {
                this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                this.loading = false;
              }
            },
            response => {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          );
        } else {
          this.$notify({
            title: "ATTENTION",
            message: "Veuillez renseigner correctement tout les champs.",
            type: "warning",
            position: "top-center"
          });

          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "L'action n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    submitRapport() {
      this.loading = true;
      if (this.$refs.formRapport.validate()) {
        let etat = false;
        var form = document.getElementById("formRapport");
        var data = new FormData(form);
        let url =
          this.domaine + "projet/" + this.tacheCourant.id + "/new/rapport";
        data.append("idUser", this.user.id);
        data.append("evolution", this.evolution);

        this.$http.post(url, data).then(
          response => {
            if (response.body) {
              let verif = response.body;
              if (verif.code === 1) {
                this.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Rapport enregistré avec succès.",
                  type: "success",
                  position: "top-center"
                });
                this.showProjet(this.projetCourant);
                this.loadChantier(this.projetCourant);
                this.loadProjetTache(this.projetCourant);
                this.loadProjet();
                this.dialogShowTravaux = false;
               this.handleTabClick('2')

                this.dialogRapport = false;
                this.loading = false;
                this.$refs.formRapport.reset();
              } else {
                this.$message.error(verif.message);
                this.loading = false;
              }
            } else {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          },
          response => {
            this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            this.loading = false;
          }
        );
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Le rapport n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    submitRapportMultiple() {
      this.loading = true;
      if (this.$refs.formRapportMultiple.validate()) {
        let etat = false;
        var form = document.getElementById("formRapportMultiple");
        var data = new FormData(form);
        let url = this.domaine + "projet/new/rapport/multiple";
        data.append("idUser", this.user.id);
        let ligne = null;
        for (let prop in this.optionRapport) {
          ligne = this.optionRapport[prop];
          if (ligne.id != "") {
            etat = true;
            data.append("option[id][]", ligne.id);
            data.append("option[evolution][]", ligne.evolution);
            data.append("option[description][]", ligne.description);
            data.append("option[fichier][]", ligne.fichier);
          } else {
            etat = false;
          }
        }

        if (etat) {
          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                let verif = response.body;
                if (verif.code === 1) {
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Rapport enregistré avec succès.",
                    type: "success",
                    position: "top-center"
                  });

                  this.showProjet(this.projetCourant);
                  this.loadChantier(this.projetCourant);
                  this.loadProjetTache(this.projetCourant);
                  this.loadProjet();
                  this.dialogMultipleRapport = false;
                  this.loading = false;
                  this.$refs.formRapportMultiple.reset();
                } else {
                  this.$message.error(verif.message);
                  this.loading = false;
                }
              } else {
                this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                this.loading = false;
              }
            },
            response => {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          );
        } else {
          this.$notify({
            title: "ATTENTION",
            message: "Veuillez renseigner correctement tout les champs.",
            type: "warning",
            position: "top-center"
          });

          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Le rapport n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    handleSelect(produit) {
      let index = this.optionVehicule.indexOf(produit);
      this.optionVehicule.splice(index, 3, produit);
    },
    submitValid() {
      this.loading = true;
      if (this.$refs.formValid.validate()) {
        var form = document.getElementById("formValid");
        var data = new FormData(form);
        let url =
          this.domaine + "projet/" + this.tacheCourant.id + "/new/valid";
        data.append("idUser", this.user.id);
        data.append("reponse", this.selectReponse);

        this.$http.post(url, data).then(
          response => {
            if (response.body) {
              let verif = response.body;
              if (verif.code === 1) {
                this.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Validation enregistré avec succès.",
                  type: "success",
                  position: "top-center"
                });
                this.showProjet(this.projetCourant);
                this.loadChantier(this.projetCourant);
                this.loadProjetTache(this.projetCourant);
                this.loadCommandeAValid(this.projetCourant);
                this.loadCommandeValid(this.projetCourant);
                this.loadCommandeALivre(this.projetCourant);
                this.loadCommandeLivre(this.projetCourant);
                this.loadProjet();
                this.dialogValid = false;
                this.loading = false;
                this.$refs.formValid.reset();
              } else if (verif.code === 0) {
                this.$message.error(verif.message);
                this.loading = false;
              }
            } else {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          },
          response => {
            this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            this.loading = false;
          }
        );
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La validation n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    submitValidCommande() {
      this.loading = true;
      if (this.$refs.formValidCommande.validate()) {
        var form = document.getElementById("formValidCommande");
        var data = new FormData(form);
        let url =
          this.domaine +
          "projet/" +
          this.commandeCourant.id +
          "/new/valid/commande";
        data.append("idUser", this.user.id);
        data.append("reponse", this.selectReponse);

        this.$http.post(url, data).then(
          response => {
            if (response.body) {
              let verif = response.body;
              if (verif.code === 1) {
                this.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Validation enregistré avec succès.",
                  type: "success",
                  position: "top-center"
                });
                this.showProjet(this.projetCourant);
                this.loadChantier(this.projetCourant);
                this.loadProjetTache(this.projetCourant);
                this.loadCommandeValid(this.projetCourant);
                this.loadProjet();
                this.dialogValidCommande = false;
                this.loading = false;
                this.$refs.formValidCommande.reset();
              } else if (verif.code === 0) {
                this.$message.error(verif.message);
                this.loading = false;
              }
            } else {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          },
          response => {
            this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            this.loading = false;
          }
        );
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La validation n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    submitPlanifProduit() {
      this.loading = true;

      let etat = true;
      let etatVeh = true;
      var form = document.getElementById("formPlanifProduit");
      var data = new FormData(form);
      let url =
        this.domaine +
        "projet/" +
        this.travauxCourant.id +
        "/new/planification/produit/travaux";
      data.append("idUser", this.user.id);
      let ligne = null;
      for (let prop in this.optionProduit) {
        let ligne = this.optionProduit[prop];
        if (ligne.produit != "" && ligne.qte != 0) {
          //etat = true;
          data.append("option[produit][]", ligne.produit);
          data.append("option[qte][]", ligne.qte);
          data.append("option[priorite][]", ligne.priorite);
        } else {
          etat = false;
        }
      }

      for (let prop in this.optionVehicule) {
        let ligne = this.optionVehicule[prop];
        if (ligne.vehicule != "" && ligne.qte != 0 && ligne.duree != 0) {
          //etatVeh = true;
          data.append("optionVeh[vehicule][]", ligne.vehicule);
          data.append("optionVeh[qte][]", ligne.qte);
          data.append("optionVeh[priorite][]", ligne.priorite);
          data.append("optionVeh[periode][]", ligne.periode);
        } else {
          etatVeh = false;
        }
      }

      if (etat == true && etatVeh == true) {
        this.$http.post(url, data).then(
          response => {
            if (response.body) {
              let verif = response.body;
              if (verif.code === 1) {
                this.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: response.body.message,
                  type: "success",
                  position: "top-center"
                });
                //affichage message info
                this.dialogInfoPlan = true;

                this.showProjet(this.projetCourant);
                this.loadChantier(this.projetCourant);
                this.loadProjetTache(this.projetCourant);
                this.dialogPlanifProduit = false;
                this.loading = false;
                this.$refs.formPlanifProduit.reset();
              } else if (verif.code === 0) {
                this.$message.error(verif.message);
                this.loading = false;
              }
            } else {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          },
          response => {
            this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            this.loading = false;
          }
        );
      } else {
        this.$message.error("Veuillez renseigner correctement les champs.");
        this.loading = false;
      }
      // } else {
      //   this.$message.error("Veuillez renseigner les champs obligatoires");
      //   this.$notify.error({
      //     title: "ERREUR D'ENREGISTREMENT",
      //     message: "La validation n'a pas été enregistré.",
      //     position: "top-center"
      //   });
      //   this.loading = false;
      // }
    },

    submitPlanifTacheProduit() {
      this.loading = true;
      let etat = true;
      let etatVeh = true;
      var form = document.getElementById("formPlanifProduit");
      var data = new FormData(form);
      let url = this.domaine + "tache/planification/" + this.tacheS;
      data.append("idUser", this.user.id);
      // let ligne = null;
      for (let prop in this.optionProduit) {
        let ligne = this.optionProduit[prop];
        if (ligne.produit != "" && ligne.qte != 0) {
          //etat = true;
          data.append("option[produit][]", ligne.produit);
          data.append("option[qte][]", ligne.qte);
          data.append("option[priorite][]", ligne.priorite);
        } else {
          etat = false;
        }
      }

      for (let prop in this.optionVehicule) {
        let ligne = this.optionVehicule[prop];
        if (ligne.value != "" && ligne.qte != 0 && ligne.periode != "") {
          //etatVeh = true;
          data.append("optionVeh[vehicule][]", ligne.value);
          data.append("optionVeh[qte][]", ligne.qte);
          data.append("optionVeh[unite][]", ligne.unite);
          data.append("optionVeh[periode][]", ligne.periode);
        } else {
          etatVeh = false;
        }
      }

      if (etat == true && etatVeh == true) {
        this.$http.post(url, data).then(
          response => {
            if (response.body) {
              let verif = response.body;
              if (verif.code === 1) {
                this.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Planification de produit enregistré avec succès.",
                  type: "success",
                  position: "top-center"
                });
                //affichage message info
                this.dialogInfoPlan = true;

                //this.showProjet(this.projetCourant);
                //this.loadChantier(this.projetCourant);
                //this.loadProjetTache(this.projetCourant);
                this.dialogPlanifProduit = false;
                this.loading = false;
                this.$refs.formPlanifProduit.reset();
              } else if (verif.code === 0) {
                this.$message.error(verif.message);
                this.loading = false;
              }
            } else {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          },
          response => {
            this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            this.loading = false;
          }
        );
      } else {
        this.$message.error("Veuillez renseigner correctement les champs.");
        this.loading = false;
      }
    },
    imprimerRapportGeneral(item, type, chantier, travaux, date, etat) {
      if (type == "") {
        type = null;
      }
      if (chantier == "") {
        chantier = null;
      }
      if (travaux == "") {
        travaux = null;
      }
      if (date == "") {
        date = null;
      }
      if (etat == "") {
        etat = null;
      }
      let url = "";
      if (item == "PDF") {
        url =
          this.domaine +
          "projet/" +
          type +
          "/" +
          chantier +
          "/" +
          travaux +
          "/" +
          date +
          "/" +
          etat +
          "/imprimer/rapport";
      } else {
        url =
          this.domaine +
          "projet/" +
          type +
          "/" +
          chantier +
          "/" +
          travaux +
          "/" +
          date +
          "/" +
          etat +
          "/excel/rapport";
      }
      this.$http.get(url).then(response => {
        if (response.body) {
        }
      });
      window.open(url);
    },
    imprimerContrat(ligne) {
      this.equipeCourant = ligne;
      let url =
        this.domaine + "projet/" + this.equipeCourant.id + "/imprimer/contrat";
      this.$http.get(url).then(response => {
        if (response.body) {
        }
      });
      window.open(url);
    },
    imprimerTravaux(ligne) {
      this.travauxCourant = ligne;
      let url =
        this.domaine + "projet/" + this.travauxCourant.id + "/imprimer/travaux";
      this.$http.get(url).then(response => {
        if (response.body) {
        }
      });
      window.open(url);
    },
    imprimerTache(ligne) {
      this.tacheCourant = ligne;
      let url =
        this.domaine +
        "projet/" +
        this.tacheCourant.id +
        "/imprimer/tache/travaux";
      this.$http.get(url).then(response => {
        if (response.body) {
        }
      });
      window.open(url);
    },
    imprimerTacheTravaux(ligne) {
      this.travauxCourant = ligne;
      let url =
        this.domaine +
        "projet/" +
        this.travauxCourant.id +
        "/imprimer/tache/travaux/all";
      this.$http.get(url).then(response => {
        if (response.body) {
        }
      });
      window.open(url);
    },
    imprimerContratTravaux(ligne) {
      this.travauxCourant = ligne;
      let url =
        this.domaine +
        "projet/" +
        this.travauxCourant.id +
        "/imprimer/contrat/travaux/all";
      this.$http.get(url).then(response => {
        if (response.body) {
        }
      });
      window.open(url);
    },
    mapGoogle() {
      window.open("https://www.google.com/maps/@?api=1&map_action=map");
    },
    imprimerCommande(ligne) {
      this.commandeCourant = ligne;
      let url =
        this.domaine +
        "fournisseur/" +
        this.commandeCourant.id +
        "/imprimer/commande/user/" +
        this.user.id;
      this.$http.get(url).then(response => {
        if (response.body) {
        }
      });
      window.open(url);
    },
    duplicateChantier(item) {
       this.libelleSelect = item
        this.showDialogDupTrx = true;
    },
    imprimerChantier(ligne) {
      this.chantierCourant = ligne;
      let url = this.domaine + "projet/" + ligne.id + "/imprimer/chantier";
      this.$http.get(url).then(response => {
        if (response.body) {
        }
      });
      window.open(url);
    },
    imprimeListeHisProjets(type) {
      let url = "";
      if (type == "PDF") {
        url = this.domaine + "projet/imprimerPDF/historique/projet/liste";
      } else {
        url = this.domaine + "projet/imprimerEXC/historique/projet/liste";
      }
      window.open(url);
    },
    imprimeListeHisChantierProjet(type) {
      let idProj = this.projetCourant.id;
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "projet/imprimerPDF/historique/" +
          idProj +
          "/chantier/liste";
      } else {
        url =
          this.domaine +
          "projet/imprimerEXC/historique/" +
          idProj +
          "/chantier/liste";
      }
      window.open(url);
    },
    imprimeListeHisPlanTravauxProjet(type) {
      let idProj = this.projetCourant.id;
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "projet/imprimerPDF/historique/" +
          idProj +
          "/plan-travaux/liste";
      } else {
        url =
          this.domaine +
          "projet/imprimerEXC/historique/" +
          idProj +
          "/plan-travaux/liste";
      }
      window.open(url);
    },
    imprimeListeHisSuivieTacheProjet(type) {
      let idProj = this.projetCourant.id;
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "projet/imprimerPDF/historique/" +
          idProj +
          "/suivie-tache/liste";
      } else {
        url =
          this.domaine +
          "projet/imprimerEXC/historique/" +
          idProj +
          "/suivie-tache/liste";
      }
      window.open(url);
    },
    imprimeListeHisSuivieContratProjet(type) {
      let idProj = this.projetCourant.id;
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "projet/imprimerPDF/historique/" +
          idProj +
          "/suivie-contrat/liste";
      } else {
        url =
          this.domaine +
          "projet/imprimerEXC/historique/" +
          idProj +
          "/suivie-contrat/liste";
      }
      window.open(url);
    },
    imprimeListeHisSuivieCmdeAvaliderProjet(type) {
      let idProj = this.projetCourant.id;
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "projet/imprimerPDF/historique/" +
          idProj +
          "/suivie-cmde-a-valider/liste";
      } else {
        url =
          this.domaine +
          "projet/imprimerEXC/historique/" +
          idProj +
          "/suivie-cmde-a-valider/liste";
      }
      window.open(url);
    },
    imprimeListeHisSuivieCmdeValiderProjet(type) {
      let idProj = this.projetCourant.id;
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "projet/imprimerPDF/historique/" +
          idProj +
          "/suivie-cmde-valider/liste";
      } else {
        url =
          this.domaine +
          "projet/imprimerEXC/historique/" +
          idProj +
          "/suivie-cmde-valider/liste";
      }
      window.open(url);
    },
    imprimeListeHisSuivieCmdeAlivrerProjet(type) {
      let idProj = this.projetCourant.id;
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "projet/imprimerPDF/historique/" +
          idProj +
          "/suivie-cmde-a-livrer/liste";
      } else {
        url =
          this.domaine +
          "projet/imprimerEXC/historique/" +
          idProj +
          "/suivie-cmde-a-livrer/liste";
      }
      window.open(url);
    },
    imprimeListeHisSuivieCmdLivrerProjet(type) {
      let idProj = this.projetCourant.id;
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "projet/imprimerPDF/historique/" +
          idProj +
          "/suivie-cmde-livrer/liste";
      } else {
        url =
          this.domaine +
          "projet/imprimerEXC/historique/" +
          idProj +
          "/suivie-cmde-livrer/liste";
      }
      window.open(url);
    },
    imprimeListeHisSuivieAllCmdesProjet(type) {
      let idProj = this.projetCourant.id;
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "projet/imprimerPDF/historique/" +
          idProj +
          "/suivie-all-cmdes/liste";
      } else {
        url =
          this.domaine +
          "projet/imprimerEXC/historique/" +
          idProj +
          "/suivie-all-cmdes/liste";
      }
      window.open(url);
    },
    imprimeListeHisSuivieEngEtVehiculeProjet(type) {
      let idProj = this.projetCourant.id;
      let url = "";
      if (type == "PDF") {
        url =
          this.domaine +
          "projet/imprimerPDF/historique/" +
          idProj +
          "/suivie-engins-vehicule/liste";
      } else {
        url =
          this.domaine +
          "projet/imprimerEXC/historique/" +
          idProj +
          "/suivie-engins-vehicule/liste";
      }
      window.open(url);
    },
    attachSecretMessage(marker, secretMessage) {
      var infowindow = new google.maps.InfoWindow({
        content: secretMessage
      });

      marker.addListener("click", function() {
        infowindow.open(marker.get("map"), marker);
      });
    },
    modalMap() {
      this.showModalMap = true;
    },
    addOptionChantier() {
      this.optionChantier.push({
        key: Date.now(),
        libelle: "",
        duree: null,
        montant: 0,
        idChef: null,
        id: ""
      });
    },
    addOptionComm() {
      this.FormComm.optionCommande.push({
        key: Date.now(),
        produit: "",
        qte: 1,
        unite: "",
        id: ""
      });
      this.totComLigneTTC += 5;
    },
    addOptionP() {
      this.optionProduit.push({
        key: Date.now(),
        type: "",
        produit: "",
        qte: 1,
        priorite: ""
      });
      this.valeurUniteMateriel =''
    },
    addOptionV() {
      this.optionVehicule.push({
        key: Date.now(),
        vehicule: "",
        qte: 1,
        unite: "",
        periode: ""
      });
    },
    addOptionEquipe() {
      if (this.tacheCourant.soutraite == 1) {
        this.optionEquipe.push({
          key: Date.now(),
          type: [{ text: "Prestataire", value: 1 }],
          selectType: 1,
          fournisseur: this.tacheCourant.idFour,
          ouvrier: "",
          duree: "",
          montant: 0,
          montantSupp: 0,
          id: ""
        });
      } else {
        this.optionEquipe.push({
          key: Date.now(),
          type: [
            { text: "Prestataire", value: 1 },
            { text: "Manoeuvre", value: 2 }
          ],
          selectType: "",
          fournisseur: "",
          ouvrier: "",
          duree: "",
          montant: 0,
          montantSupp: 0,
          id: ""
        });
      }

      this.totComLigneTTC += 5;
    },
    removePlan(item) {
      var index = this.optionChantier.indexOf(item);
      if (index !== -1) {
        this.optionChantier.splice(index, 1);
      }
    },
    removeTache(item) {
      var index = this.optionTache.indexOf(item);
      if (index !== -1) {
        if (this.optionTache[index].total != undefined) {
          this.totalHT -= this.optionTache[index].total;
        }
        // enregistrer lid du lot de travaux supprimer dans la liste
        if(this.optionTache[index].id != null){
            this.listeTacheSupp.push(this.optionTache[index].id);
        }
         this.optionTache.splice(index, 1);
      }
    },
    removeOptionComm(item) {
      var index = this.FormComm.optionCommande.indexOf(item);
      if (index !== -1) {
        this.FormComm.optionCommande.splice(index, 1);
      }
    },
    findUnite(index) {
      //  this.uniteAffic =index['unite']
    },
    removeOptionP(item) {
      var index = this.optionProduit.indexOf(item);
      if (index !== -1) {
        this.optionProduit.splice(index, 1);
      }
    },
    removeOptionBesoin(item) {
      var index = this.optionVehicule.indexOf(item);
      if (index !== -1) {
        this.optionVehicule.splice(index, 1);
      }
    },
    removeOptionV(item) {
      var index = this.optionVehicule.indexOf(item);
      if (index !== -1) {
        this.optionVehicule.splice(index, 1);
      }
    },
    removeOptionEquipe(item) {
      var index = this.optionEquipe.indexOf(item);
      if (index !== -1) {
        this.optionEquipe.splice(index, 1);
      }
    },
    deleteProjet(item) {
      let url = this.domaine + "projet/delete/" + this.idProjet;
      this.$http.get(url).then(response => {
        if (response.body) {
          this.$notify({
            title: "SUPPRESSION",
            message: "Projet supprimé avec succès.",
            type: "success",
            position: "top-center"
          });
          this.dialogSupr = false;
          this.loadListeProjet();
          this.loadProjet();
          this.loadPage();
        }
      });
    },
    deleteChantier(item) {
      this.loading = true;
      let url = this.domaine + "projet/delete/chantier/" + this.idChantier;
      this.$http.get(url).then(response => {
        this.loading = false;
        this.dialogSuprChantier = false;
        if (response.body.code == 3) {
          this.$notify({
            title: "SUPPRESSION",
            message: response.body.message,
            type: "warning",
            duration: 5000,
            position: "top-center"
          });
          return;
        }

        if (response.body) {
          this.$notify({
            title: "SUPPRESSION",
            message: "Chantier supprimé avec succès.",
            type: "success",
            position: "top-center",
                duration:5000,
          });
          this.dialogSuprChantier = false;
          this.showProjet(this.projetCourant);
          this.loadChantier(this.projetCourant);
          this.loadPage();
        }
      },
        error => {
            this.loading = false;
            this.$message.error(
                "Vous ne pouvez pas supprimer un chantier avec des travaux'"
            );
        });
    },
    deleteTravaux() {
      let url = this.domaine + "projet/delete/travaux/"+this.idTravaux;
      this.$http.get(url).then(response => {
        if (response.body) {
           if(response.body.code == 2){
            this.$notify({
                title: 'SUPPRESSION',
                duration:5000,
                message: resp.body.message,
                type: 'warning',
                duration:5000,
            });
            }else{
              this.$notify({
              title: "SUPPRESSION REUSSI",
              message: "Travaux supprimé avec succès",
              type: "success",
              position: "top-center",
                duration:5000,
            });
            }
          this.dialogSuprTravaux = false;
          this.showProjet(this.projetCourant);
          this.loadChantier(this.projetCourant);
          if(this.selectSearchChantierFind != null) this.loadAffSupTravaux(this.selectSearchChantierFind)
          this.loadPage();
        }
      },
      response => {
          this.$message.error("Une erreur est survenue lors de la supression,Veuillez contacter votre administrateur")
      });
    },
    deleteTache(item) {
      let url = this.domaine + "projet/delete/tache/" + this.idTache;
      this.$http.get(url).then(response => {
        if (response.body) {
          this.$notify({
            title: "SUPPRESSION",
            message: "Tâche supprimé avec succès.",
            type: "success",
            position: "top-center",
                duration:5000,
          });
          this.dialogSuprTache = false;
          this.showProjet(this.projetCourant);
          this.loadChantier(this.projetCourant);
          this.loadTravauxProjet(this.projetCourant);
          this.loadPage();
        }
      });
    },
    handleRemove(file, fileList) {},
    handlePreview(file) {},
    handleExceed(files, fileList) {
      this.$message.warning(
        `La limite est 3, vous avez choisi ${
          files.length
        } fichiers, soit ${files.length + fileList.length} au total.`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`Supprimer le fichier de ${file.name} ?`);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length === 0) {
        this.choix = true;
      } else {
        this.choix = false;
      }
    },
    selectionChangeDuplique(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length === 0) {
        this.choixChantier = true;
      } else {
        this.choixChantier = false;
      }
    },
    selectionChangeTravaux(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length === 0) {
        this.choixTravux = true;
      } else {
        this.choixTravux = false;
      }
    },
    contratSelect(row, index) {
      let etat = null;
      if (parseInt(row.etat) === 0) {
        etat = true;
      } else {
        etat = false;
      }
      return etat;
    },
    soustraitanceSelect(row, index) {
      let etat = null;
      if (parseInt(row.soutraite) === 1 && row.etatContrat == 0) {
        etat = true;
      } else {
        etat = false;
      }
      return etat;
    },
    querySearch(queryString, cb) {
      var links = this.listKeyword;
      var results = queryString
        ? links.filter(this.createFilter(queryString))
        : links;
      // call callback function to return suggestions
      cb(results);
    },
    createFilter(queryString) {
      return link => {
        return (
          link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    projet(item) {
      this.$router.push({
        name: "Projets",
        params: { projet_id: item.id, projets_id: "0" }
      });
    },
    beforeMount: function() {
      if (!this.roleAcces[this.$router.history.current.name]) {
        this.$router.push({ name: "Home" });
      }
    }
  },
  computed: {
    disabledBtnContTrx: function() {
      return true;
    },

    verifFormBudget: function() {
      if (
        this.formBudget.libelle.libelle != null &&
        this.formBudget.montantAdecaisse != null
      ) {
        return true;
      } else {
        return true;
      }
    }
  }
};
</script>

<style scoped>
/*@import "~dhtmlx-gantt/codebase/dhtmlxgantt.css";*/
@import "~dhtmlx-gantt/codebase/dhtmlxgantt.css";




// WEBPACK FOOTER //
// src/components/Projet.vue